var map = {
	"./crypto/$based.svg": 190815,
	"./crypto/$read.svg": 444650,
	"./crypto/$snow.svg": 785837,
	"./crypto/0xbtc.svg": 764432,
	"./crypto/10set.svg": 77592,
	"./crypto/1flr.svg": 146939,
	"./crypto/1inch.svg": 163112,
	"./crypto/1st.svg": 38910,
	"./crypto/4token.svg": 927926,
	"./crypto/aave.svg": 6894,
	"./crypto/abat.svg": 449625,
	"./crypto/abbc.svg": 107286,
	"./crypto/abt.svg": 418713,
	"./crypto/abusd.svg": 862307,
	"./crypto/ac3.svg": 725821,
	"./crypto/aca.svg": 41723,
	"./crypto/act.svg": 274444,
	"./crypto/ada.svg": 871956,
	"./crypto/adai.svg": 912081,
	"./crypto/adb.svg": 139245,
	"./crypto/adx.svg": 765630,
	"./crypto/ae.svg": 718966,
	"./crypto/aenj.svg": 804331,
	"./crypto/aeon.svg": 681578,
	"./crypto/aergo.svg": 97222,
	"./crypto/aeth.svg": 782668,
	"./crypto/agi.svg": 233153,
	"./crypto/aidoge.svg": 974,
	"./crypto/aion.svg": 886090,
	"./crypto/aioz.svg": 19952,
	"./crypto/ait.svg": 613553,
	"./crypto/aknc.svg": 372398,
	"./crypto/akro.svg": 218398,
	"./crypto/akt.svg": 558639,
	"./crypto/alcx.svg": 514467,
	"./crypto/alend.svg": 385172,
	"./crypto/aleph.svg": 593187,
	"./crypto/aleth.svg": 565459,
	"./crypto/algo.svg": 631571,
	"./crypto/ali.svg": 390663,
	"./crypto/alink.svg": 847949,
	"./crypto/alis.svg": 191176,
	"./crypto/alpha.svg": 919362,
	"./crypto/alusd.svg": 911630,
	"./crypto/alx.svg": 981499,
	"./crypto/amana.svg": 936237,
	"./crypto/amb.svg": 201599,
	"./crypto/amkr.svg": 718898,
	"./crypto/amkt.svg": 631714,
	"./crypto/amlt.svg": 501976,
	"./crypto/amp.svg": 339143,
	"./crypto/ampl.svg": 965008,
	"./crypto/anc.svg": 329942,
	"./crypto/anj.svg": 445771,
	"./crypto/ankr.svg": 168398,
	"./crypto/ant.svg": 674231,
	"./crypto/ape.svg": 148249,
	"./crypto/aph.svg": 181847,
	"./crypto/apl.svg": 58445,
	"./crypto/appc.svg": 505365,
	"./crypto/apt.svg": 135945,
	"./crypto/apw.svg": 743072,
	"./crypto/apx.svg": 258123,
	"./crypto/apy.svg": 696118,
	"./crypto/ar.svg": 350868,
	"./crypto/arb.svg": 527278,
	"./crypto/arbs.svg": 563292,
	"./crypto/archive.svg": 581394,
	"./crypto/ardr.svg": 165878,
	"./crypto/aren.svg": 694215,
	"./crypto/ark.svg": 614209,
	"./crypto/arkm.svg": 308660,
	"./crypto/armor.svg": 293693,
	"./crypto/arn.svg": 903287,
	"./crypto/aro.svg": 570917,
	"./crypto/arrr.svg": 955380,
	"./crypto/asm.svg": 633634,
	"./crypto/asnx.svg": 132078,
	"./crypto/ast.svg": 339277,
	"./crypto/aster.svg": 967374,
	"./crypto/astro.svg": 11978,
	"./crypto/asusd.svg": 466943,
	"./crypto/atmi.svg": 9952,
	"./crypto/atom.svg": 858090,
	"./crypto/atusd.svg": 213676,
	"./crypto/auc.svg": 275360,
	"./crypto/audio.svg": 931786,
	"./crypto/aura.svg": 701646,
	"./crypto/ausdc.svg": 239625,
	"./crypto/ausdt.svg": 768819,
	"./crypto/auto.svg": 920797,
	"./crypto/avax.svg": 5866,
	"./crypto/avinoc.svg": 817854,
	"./crypto/avnt.svg": 929139,
	"./crypto/awbtc.svg": 513592,
	"./crypto/awc.svg": 967457,
	"./crypto/aweth.svg": 44796,
	"./crypto/axl.svg": 991802,
	"./crypto/axp.svg": 418944,
	"./crypto/axs.svg": 515323,
	"./crypto/ayfi.svg": 886024,
	"./crypto/azero.svg": 45513,
	"./crypto/azrx.svg": 460953,
	"./crypto/babydoge.svg": 429007,
	"./crypto/bac.svg": 662675,
	"./crypto/badger.svg": 902231,
	"./crypto/bal.svg": 544736,
	"./crypto/bam.svg": 303043,
	"./crypto/band.svg": 250063,
	"./crypto/bao.svg": 621752,
	"./crypto/bat.svg": 278065,
	"./crypto/bay.svg": 474010,
	"./crypto/bbr.svg": 590923,
	"./crypto/bcd.svg": 830938,
	"./crypto/bch.svg": 68310,
	"./crypto/bcha.svg": 797531,
	"./crypto/bcn.svg": 886504,
	"./crypto/bco.svg": 323511,
	"./crypto/beam.svg": 3667,
	"./crypto/bel.svg": 856608,
	"./crypto/beta.svg": 217309,
	"./crypto/bf.svg": 433677,
	"./crypto/bfc.svg": 637647,
	"./crypto/bgb.svg": 418728,
	"./crypto/bico.svg": 568548,
	"./crypto/bifi.svg": 796641,
	"./crypto/birb.svg": 358661,
	"./crypto/bit-2.svg": 181839,
	"./crypto/bit.svg": 741649,
	"./crypto/bitcoin.svg": 298949,
	"./crypto/bix.svg": 782594,
	"./crypto/blank.svg": 561837,
	"./crypto/bld.svg": 871940,
	"./crypto/blk.svg": 973224,
	"./crypto/block.svg": 240366,
	"./crypto/blt.svg": 488654,
	"./crypto/blue.svg": 771853,
	"./crypto/blur.svg": 204032,
	"./crypto/blz.svg": 196674,
	"./crypto/bmda.svg": 469890,
	"./crypto/bnb.svg": 994673,
	"./crypto/bnc.svg": 77755,
	"./crypto/bnt.svg": 287465,
	"./crypto/bnx.svg": 850662,
	"./crypto/bob.svg": 845235,
	"./crypto/bond-2.svg": 825078,
	"./crypto/bond.svg": 967275,
	"./crypto/bondly.svg": 641377,
	"./crypto/bora.svg": 206577,
	"./crypto/botto.svg": 300609,
	"./crypto/box.svg": 807294,
	"./crypto/bpt.svg": 717144,
	"./crypto/bqx.svg": 702190,
	"./crypto/brd.svg": 589850,
	"./crypto/brise.svg": 228561,
	"./crypto/brock.svg": 830682,
	"./crypto/bsw.svg": 777166,
	"./crypto/btc++.svg": 680506,
	"./crypto/btc.svg": 759256,
	"./crypto/btcd.svg": 937415,
	"./crypto/btcp.svg": 15719,
	"./crypto/btg.svg": 402416,
	"./crypto/btmx.svg": 257685,
	"./crypto/bto.svg": 165284,
	"./crypto/btr.svg": 559290,
	"./crypto/bts.svg": 378280,
	"./crypto/btt.svg": 167099,
	"./crypto/btu.svg": 543521,
	"./crypto/bu.svg": 358785,
	"./crypto/bunny.svg": 566743,
	"./crypto/busd.svg": 664030,
	"./crypto/bwajna.svg": 343715,
	"./crypto/bwt.svg": 344135,
	"./crypto/bz.svg": 221196,
	"./crypto/bznt.svg": 917025,
	"./crypto/bzrx.svg": 261782,
	"./crypto/c20.svg": 302536,
	"./crypto/c98.svg": 933032,
	"./crypto/cake.svg": 343538,
	"./crypto/canto.svg": 629254,
	"./crypto/cap.svg": 516733,
	"./crypto/capp.svg": 166510,
	"./crypto/car.svg": 223223,
	"./crypto/card.svg": 365909,
	"./crypto/cbat.svg": 414879,
	"./crypto/cbc.svg": 655313,
	"./crypto/cbeth.svg": 190068,
	"./crypto/cbt.svg": 629203,
	"./crypto/cccx.svg": 588968,
	"./crypto/cdai.svg": 194877,
	"./crypto/cdt.svg": 15387,
	"./crypto/ceek.svg": 767903,
	"./crypto/cel.svg": 271322,
	"./crypto/celo.svg": 162796,
	"./crypto/celr.svg": 346919,
	"./crypto/cennz.svg": 855322,
	"./crypto/cet.svg": 908281,
	"./crypto/ceth.svg": 766412,
	"./crypto/cfg.svg": 105191,
	"./crypto/cfx.svg": 168969,
	"./crypto/chai.svg": 582527,
	"./crypto/chain.svg": 175653,
	"./crypto/chat.svg": 835142,
	"./crypto/chia.svg": 472763,
	"./crypto/cho.svg": 336861,
	"./crypto/chr.svg": 347970,
	"./crypto/chsb.svg": 553093,
	"./crypto/chz.svg": 128248,
	"./crypto/cirus.svg": 886563,
	"./crypto/ckb.svg": 275292,
	"./crypto/clo.svg": 624908,
	"./crypto/cloak.svg": 999193,
	"./crypto/clout.svg": 454640,
	"./crypto/cmt.svg": 18708,
	"./crypto/cnc.svg": 349581,
	"./crypto/cnd.svg": 620854,
	"./crypto/cnx.svg": 264715,
	"./crypto/coc.svg": 506548,
	"./crypto/cocn.svg": 834154,
	"./crypto/comai.svg": 121612,
	"./crypto/comp.svg": 752694,
	"./crypto/coni.svg": 240280,
	"./crypto/core.svg": 618022,
	"./crypto/cosm.svg": 197565,
	"./crypto/coti.svg": 228604,
	"./crypto/cov.svg": 845978,
	"./crypto/cova.svg": 314735,
	"./crypto/cover.svg": 26723,
	"./crypto/cpc.svg": 284849,
	"./crypto/cpx.svg": 729327,
	"./crypto/crd.svg": 978848,
	"./crypto/cre-2.svg": 84760,
	"./crypto/cre.svg": 452421,
	"./crypto/cream.svg": 910146,
	"./crypto/cred.svg": 399269,
	"./crypto/crep.svg": 93245,
	"./crypto/cro.svg": 272690,
	"./crypto/crpt.svg": 939707,
	"./crypto/crv.svg": 327973,
	"./crypto/crvusd.svg": 836358,
	"./crypto/cs.svg": 111251,
	"./crypto/csai.svg": 531445,
	"./crypto/csc.svg": 486216,
	"./crypto/cspr.svg": 942059,
	"./crypto/ctc.svg": 244474,
	"./crypto/ctsi.svg": 461529,
	"./crypto/ctxc.svg": 28191,
	"./crypto/cube.svg": 734705,
	"./crypto/cusdc.svg": 807148,
	"./crypto/cv.svg": 348247,
	"./crypto/cvc.svg": 139963,
	"./crypto/cvp.svg": 981227,
	"./crypto/cvt.svg": 976743,
	"./crypto/cvx.svg": 352133,
	"./crypto/cwbtc.svg": 302842,
	"./crypto/cyber.svg": 696883,
	"./crypto/czrx.svg": 703554,
	"./crypto/d2.svg": 570966,
	"./crypto/dadi.svg": 887788,
	"./crypto/dafi.svg": 221742,
	"./crypto/dag.svg": 244100,
	"./crypto/dai.svg": 652233,
	"./crypto/dao.svg": 164530,
	"./crypto/dasc.svg": 306991,
	"./crypto/dash.svg": 279387,
	"./crypto/dat.svg": 194763,
	"./crypto/data.svg": 879027,
	"./crypto/datx.svg": 334016,
	"./crypto/dbc.svg": 370355,
	"./crypto/dcb.svg": 586277,
	"./crypto/dcc.svg": 277973,
	"./crypto/dck.svg": 588950,
	"./crypto/dcn.svg": 302477,
	"./crypto/dcr.svg": 684288,
	"./crypto/dct.svg": 229660,
	"./crypto/ddd.svg": 61017,
	"./crypto/del.svg": 486413,
	"./crypto/dent.svg": 721026,
	"./crypto/dep.svg": 518849,
	"./crypto/deri.svg": 836215,
	"./crypto/deso.svg": 254128,
	"./crypto/dexe-2.svg": 558402,
	"./crypto/dexe.svg": 51507,
	"./crypto/df.svg": 409833,
	"./crypto/dfi.svg": 154134,
	"./crypto/dft.svg": 298994,
	"./crypto/dfyn.svg": 959544,
	"./crypto/dgb.svg": 106649,
	"./crypto/dgd.svg": 441439,
	"./crypto/dgtx.svg": 657645,
	"./crypto/dht.svg": 159087,
	"./crypto/dia.svg": 385441,
	"./crypto/dinero.svg": 135026,
	"./crypto/divi.svg": 643117,
	"./crypto/dlt.svg": 200085,
	"./crypto/dmt.svg": 744219,
	"./crypto/dmtr.svg": 785150,
	"./crypto/dnt.svg": 528421,
	"./crypto/dock.svg": 292694,
	"./crypto/dodo.svg": 190557,
	"./crypto/doge.svg": 694447,
	"./crypto/dogs.svg": 629486,
	"./crypto/dojo.svg": 755058,
	"./crypto/dome.svg": 580344,
	"./crypto/dor.svg": 119798,
	"./crypto/dot.svg": 805146,
	"./crypto/drgn.svg": 102355,
	"./crypto/drop.svg": 846384,
	"./crypto/dta.svg": 825725,
	"./crypto/dtr.svg": 567363,
	"./crypto/dtx.svg": 373813,
	"./crypto/duck.svg": 961574,
	"./crypto/dvf.svg": 201961,
	"./crypto/dxd.svg": 541474,
	"./crypto/dxt.svg": 20098,
	"./crypto/dydx.svg": 831551,
	"./crypto/eco.svg": 76935,
	"./crypto/edg.svg": 616495,
	"./crypto/edo.svg": 764615,
	"./crypto/edu.svg": 392748,
	"./crypto/efi.svg": 155031,
	"./crypto/efx.svg": 529169,
	"./crypto/egld.svg": 827302,
	"./crypto/egt.svg": 407102,
	"./crypto/ekg.svg": 744563,
	"./crypto/ekt.svg": 626251,
	"./crypto/ela.svg": 825129,
	"./crypto/elan.svg": 572920,
	"./crypto/elec.svg": 291193,
	"./crypto/elf.svg": 449906,
	"./crypto/elg.svg": 44581,
	"./crypto/emc.svg": 928047,
	"./crypto/emc2.svg": 363753,
	"./crypto/ena.svg": 406441,
	"./crypto/eng.svg": 771047,
	"./crypto/enix.svg": 544258,
	"./crypto/enj.svg": 736944,
	"./crypto/ens.svg": 815088,
	"./crypto/ents.svg": 65842,
	"./crypto/eos.svg": 323781,
	"./crypto/eosdac.svg": 468083,
	"./crypto/eqb.svg": 34026,
	"./crypto/erg.svg": 858582,
	"./crypto/ern.svg": 593539,
	"./crypto/esd.svg": 696902,
	"./crypto/esp.svg": 215768,
	"./crypto/ess.svg": 141434,
	"./crypto/etc.svg": 674756,
	"./crypto/eth.svg": 877292,
	"./crypto/ethw.svg": 265318,
	"./crypto/etn.svg": 153272,
	"./crypto/etp.svg": 537515,
	"./crypto/etz.svg": 577110,
	"./crypto/euroc.svg": 111555,
	"./crypto/ever.svg": 502380,
	"./crypto/evmos.svg": 837090,
	"./crypto/evx.svg": 484939,
	"./crypto/ewt.svg": 636469,
	"./crypto/exrn.svg": 639971,
	"./crypto/exy.svg": 478624,
	"./crypto/ezy.svg": 782799,
	"./crypto/fab.svg": 638631,
	"./crypto/fame.svg": 38330,
	"./crypto/farm.svg": 273147,
	"./crypto/fct.svg": 304944,
	"./crypto/fdusd.svg": 381193,
	"./crypto/feed.svg": 469234,
	"./crypto/fei.svg": 171525,
	"./crypto/fet.svg": 347937,
	"./crypto/fida.svg": 656042,
	"./crypto/fidu.svg": 190605,
	"./crypto/fil.svg": 535153,
	"./crypto/filda.svg": 631308,
	"./crypto/fis.svg": 285247,
	"./crypto/flash.svg": 488818,
	"./crypto/flex.svg": 980104,
	"./crypto/floki.svg": 671235,
	"./crypto/flow.svg": 80400,
	"./crypto/flr.svg": 534955,
	"./crypto/flux.svg": 177768,
	"./crypto/fnsa.svg": 485220,
	"./crypto/foam.svg": 815040,
	"./crypto/fold.svg": 736391,
	"./crypto/fota.svg": 186780,
	"./crypto/fox.svg": 52087,
	"./crypto/fpi.svg": 236828,
	"./crypto/fpis.svg": 339804,
	"./crypto/frax.svg": 401407,
	"./crypto/frm.svg": 208932,
	"./crypto/front.svg": 530387,
	"./crypto/frxeth.svg": 666037,
	"./crypto/fsn.svg": 173969,
	"./crypto/fst.svg": 470544,
	"./crypto/ft.svg": 871021,
	"./crypto/ftc.svg": 75006,
	"./crypto/ftm.svg": 696380,
	"./crypto/ftt.svg": 826188,
	"./crypto/fuel.svg": 670030,
	"./crypto/fun.svg": 231247,
	"./crypto/fx.svg": 13722,
	"./crypto/fxc.svg": 352166,
	"./crypto/fxs.svg": 787091,
	"./crypto/fxt.svg": 204275,
	"./crypto/gal.svg": 378805,
	"./crypto/gala.svg": 421676,
	"./crypto/gamma.svg": 382145,
	"./crypto/gb.svg": 928067,
	"./crypto/gdc.svg": 642938,
	"./crypto/gem.svg": 706461,
	"./crypto/gen.svg": 313819,
	"./crypto/giv.svg": 167696,
	"./crypto/glmr.svg": 706170,
	"./crypto/gmee.svg": 125866,
	"./crypto/gmt-2.svg": 750262,
	"./crypto/gmt.svg": 156745,
	"./crypto/gmx.svg": 38061,
	"./crypto/gno.svg": 524609,
	"./crypto/gns.svg": 274906,
	"./crypto/gnt.svg": 932487,
	"./crypto/gnx.svg": 258509,
	"./crypto/go.svg": 763810,
	"./crypto/goc.svg": 941363,
	"./crypto/got.svg": 1729,
	"./crypto/govi.svg": 415213,
	"./crypto/grail.svg": 833143,
	"./crypto/grin.svg": 391566,
	"./crypto/grow.svg": 407900,
	"./crypto/grp.svg": 256688,
	"./crypto/grs.svg": 402666,
	"./crypto/grt.svg": 759483,
	"./crypto/gsc.svg": 861315,
	"./crypto/gswap.svg": 396090,
	"./crypto/gt.svg": 648756,
	"./crypto/gtai.svg": 662171,
	"./crypto/gtc-2.svg": 977171,
	"./crypto/gtc.svg": 564340,
	"./crypto/gto.svg": 337860,
	"./crypto/gusd.svg": 834936,
	"./crypto/gvt.svg": 826374,
	"./crypto/gxs.svg": 525088,
	"./crypto/gyen.svg": 105996,
	"./crypto/hair.svg": 407871,
	"./crypto/hakka.svg": 214761,
	"./crypto/han.svg": 417098,
	"./crypto/hanep.svg": 828522,
	"./crypto/hav.svg": 965639,
	"./crypto/hbar.svg": 340553,
	"./crypto/hc.svg": 844297,
	"./crypto/heart.svg": 42902,
	"./crypto/hedg.svg": 870352,
	"./crypto/hegic.svg": 105681,
	"./crypto/her.svg": 511007,
	"./crypto/hex.svg": 429848,
	"./crypto/hft.svg": 109395,
	"./crypto/high.svg": 114245,
	"./crypto/hive.svg": 486249,
	"./crypto/hnt.svg": 791569,
	"./crypto/hot-x.svg": 986350,
	"./crypto/hot.svg": 60889,
	"./crypto/hpb.svg": 269163,
	"./crypto/hsr.svg": 866242,
	"./crypto/ht.svg": 263459,
	"./crypto/hum.svg": 166815,
	"./crypto/husd.svg": 284792,
	"./crypto/hvn.svg": 809452,
	"./crypto/hxro.svg": 846198,
	"./crypto/hydro.svg": 958606,
	"./crypto/hyn.svg": 844982,
	"./crypto/hype.svg": 275383,
	"./crypto/hzn.svg": 32552,
	"./crypto/ibat.svg": 717155,
	"./crypto/ice.svg": 701015,
	"./crypto/icn.svg": 743358,
	"./crypto/icp.svg": 97,
	"./crypto/icx.svg": 271167,
	"./crypto/id.svg": 586350,
	"./crypto/idai.svg": 462969,
	"./crypto/idex.svg": 617545,
	"./crypto/ieth.svg": 15049,
	"./crypto/ifarm.svg": 430777,
	"./crypto/ignis.svg": 700514,
	"./crypto/iknc.svg": 954984,
	"./crypto/ilink.svg": 938790,
	"./crypto/ilv.svg": 862369,
	"./crypto/imx.svg": 48474,
	"./crypto/inb.svg": 851179,
	"./crypto/inj.svg": 486257,
	"./crypto/ins.svg": 657780,
	"./crypto/instar.svg": 918147,
	"./crypto/iost.svg": 850844,
	"./crypto/iota.svg": 472148,
	"./crypto/iotx.svg": 726234,
	"./crypto/iq-2.svg": 736282,
	"./crypto/iq.svg": 1518,
	"./crypto/irep.svg": 359578,
	"./crypto/iris.svg": 956067,
	"./crypto/isai.svg": 252081,
	"./crypto/ist.svg": 579041,
	"./crypto/isusd.svg": 997478,
	"./crypto/iusdc.svg": 275793,
	"./crypto/iwbtc.svg": 656202,
	"./crypto/ixt.svg": 148815,
	"./crypto/izrx.svg": 607956,
	"./crypto/jnt.svg": 551644,
	"./crypto/jrt.svg": 800080,
	"./crypto/jst.svg": 82443,
	"./crypto/jto.svg": 720992,
	"./crypto/juno.svg": 380934,
	"./crypto/jup.svg": 204256,
	"./crypto/kas.svg": 883156,
	"./crypto/kava.svg": 919967,
	"./crypto/kcs.svg": 49936,
	"./crypto/kda.svg": 912649,
	"./crypto/keep.svg": 36593,
	"./crypto/key.svg": 966688,
	"./crypto/kick.svg": 586660,
	"./crypto/kin.svg": 654657,
	"./crypto/kira.svg": 575753,
	"./crypto/kiro.svg": 218656,
	"./crypto/kiwi.svg": 945529,
	"./crypto/klay.svg": 955619,
	"./crypto/klv.svg": 446180,
	"./crypto/kmd.svg": 606696,
	"./crypto/knc.svg": 819365,
	"./crypto/ksm.svg": 142291,
	"./crypto/ktn.svg": 193144,
	"./crypto/kub.svg": 800930,
	"./crypto/kuji.svg": 205177,
	"./crypto/lamb.svg": 457799,
	"./crypto/land.svg": 234700,
	"./crypto/lba.svg": 103459,
	"./crypto/lcx.svg": 412854,
	"./crypto/ldo.svg": 323900,
	"./crypto/lend.svg": 631989,
	"./crypto/leo.svg": 636794,
	"./crypto/lien.svg": 165446,
	"./crypto/link.svg": 958745,
	"./crypto/lit.svg": 141458,
	"./crypto/lky.svg": 232030,
	"./crypto/ln.svg": 943826,
	"./crypto/lode.svg": 161811,
	"./crypto/loki.svg": 353063,
	"./crypto/lon.svg": 8424,
	"./crypto/looks.svg": 589725,
	"./crypto/loom.svg": 324949,
	"./crypto/lpf.svg": 959793,
	"./crypto/lpt.svg": 734002,
	"./crypto/lqd.svg": 781277,
	"./crypto/lqty.svg": 407175,
	"./crypto/lrc.svg": 84589,
	"./crypto/lsk.svg": 717655,
	"./crypto/ltc.svg": 501027,
	"./crypto/lto.svg": 444726,
	"./crypto/luca.svg": 869126,
	"./crypto/lun.svg": 536500,
	"./crypto/luna.svg": 286983,
	"./crypto/lusd.svg": 873991,
	"./crypto/lxt.svg": 313623,
	"./crypto/lym.svg": 205445,
	"./crypto/m.svg": 28697,
	"./crypto/mSOL.svg": 51444,
	"./crypto/magic.svg": 180587,
	"./crypto/maha.svg": 125186,
	"./crypto/maid.svg": 937244,
	"./crypto/man.svg": 231327,
	"./crypto/mana.svg": 40597,
	"./crypto/manta.svg": 370280,
	"./crypto/mask.svg": 622151,
	"./crypto/math.svg": 259686,
	"./crypto/matic.svg": 754798,
	"./crypto/matter.svg": 688069,
	"./crypto/mav.svg": 442510,
	"./crypto/mbc.svg": 226354,
	"./crypto/mbox.svg": 244815,
	"./crypto/mc.svg": 705415,
	"./crypto/mcb.svg": 550476,
	"./crypto/mco.svg": 464950,
	"./crypto/mcx.svg": 789989,
	"./crypto/mda.svg": 226743,
	"./crypto/mdao.svg": 724779,
	"./crypto/mds.svg": 557751,
	"./crypto/med.svg": 180000,
	"./crypto/medx.svg": 852144,
	"./crypto/meme.svg": 5214,
	"./crypto/met.svg": 709382,
	"./crypto/metano.svg": 748881,
	"./crypto/meth.svg": 958642,
	"./crypto/metis.svg": 760248,
	"./crypto/mew.svg": 180249,
	"./crypto/mex.svg": 889370,
	"./crypto/mfg.svg": 701292,
	"./crypto/mft.svg": 509664,
	"./crypto/mim.svg": 843808,
	"./crypto/mimatic.svg": 277508,
	"./crypto/mina.svg": 242046,
	"./crypto/mir.svg": 626697,
	"./crypto/mith.svg": 826729,
	"./crypto/mkr.svg": 752655,
	"./crypto/mln.svg": 352644,
	"./crypto/mngo.svg": 83209,
	"./crypto/mnt.svg": 95250,
	"./crypto/mntl.svg": 804998,
	"./crypto/mnw.svg": 611744,
	"./crypto/mochi.svg": 498669,
	"./crypto/mod.svg": 129212,
	"./crypto/mom.svg": 511263,
	"./crypto/moons.svg": 499738,
	"./crypto/mot.svg": 219096,
	"./crypto/mpl.svg": 652148,
	"./crypto/mta.svg": 839945,
	"./crypto/mth.svg": 266960,
	"./crypto/mtl.svg": 202483,
	"./crypto/mtn.svg": 86129,
	"./crypto/mura.svg": 634067,
	"./crypto/mvc.svg": 663003,
	"./crypto/mvl.svg": 106593,
	"./crypto/mvp.svg": 441709,
	"./crypto/mwat.svg": 236227,
	"./crypto/mwc.svg": 806138,
	"./crypto/mxc.svg": 317192,
	"./crypto/mxm.svg": 155153,
	"./crypto/myb.svg": 990006,
	"./crypto/nano.svg": 584087,
	"./crypto/nas.svg": 484639,
	"./crypto/nav.svg": 847387,
	"./crypto/ncash.svg": 850201,
	"./crypto/nct.svg": 7712,
	"./crypto/near.svg": 992574,
	"./crypto/nebl.svg": 717481,
	"./crypto/nec.svg": 266225,
	"./crypto/neo.svg": 304325,
	"./crypto/neox.svg": 690929,
	"./crypto/nest.svg": 11788,
	"./crypto/new.svg": 715563,
	"./crypto/nex.svg": 780305,
	"./crypto/nexo.svg": 682489,
	"./crypto/nexus.svg": 591450,
	"./crypto/nexxo.svg": 651061,
	"./crypto/nft.svg": 824415,
	"./crypto/nftb.svg": 830205,
	"./crypto/ngc.svg": 694124,
	"./crypto/niox.svg": 561879,
	"./crypto/nkn.svg": 354003,
	"./crypto/nlg.svg": 736325,
	"./crypto/nmr.svg": 533857,
	"./crypto/noia.svg": 907177,
	"./crypto/nos.svg": 325415,
	"./crypto/not.svg": 214103,
	"./crypto/npc.svg": 483475,
	"./crypto/nper.svg": 935820,
	"./crypto/npxs.svg": 501822,
	"./crypto/nrg.svg": 677968,
	"./crypto/nrv.svg": 803064,
	"./crypto/nrve.svg": 140884,
	"./crypto/ntic.svg": 815826,
	"./crypto/ntl.svg": 270510,
	"./crypto/ntrn.svg": 238630,
	"./crypto/nu.svg": 112120,
	"./crypto/nuls.svg": 570988,
	"./crypto/nxm.svg": 730674,
	"./crypto/nxra.svg": 710393,
	"./crypto/nxs.svg": 379628,
	"./crypto/nxt.svg": 674545,
	"./crypto/oag.svg": 949994,
	"./crypto/oax.svg": 799095,
	"./crypto/ocean.svg": 36768,
	"./crypto/ocn.svg": 108893,
	"./crypto/ode.svg": 669567,
	"./crypto/ogn.svg": 607450,
	"./crypto/ohm.svg": 766727,
	"./crypto/oil.svg": 27013,
	"./crypto/okb.svg": 297848,
	"./crypto/oks.svg": 884661,
	"./crypto/olt.svg": 297445,
	"./crypto/omg.svg": 556635,
	"./crypto/ondo.svg": 242523,
	"./crypto/one.svg": 922474,
	"./crypto/onion.svg": 121323,
	"./crypto/ont.svg": 673852,
	"./crypto/op.svg": 250585,
	"./crypto/open.svg": 675220,
	"./crypto/opium.svg": 316329,
	"./crypto/opul.svg": 534342,
	"./crypto/opx.svg": 894558,
	"./crypto/orai.svg": 39400,
	"./crypto/orbs.svg": 279167,
	"./crypto/orc.svg": 113921,
	"./crypto/ordi.svg": 456896,
	"./crypto/orn.svg": 921440,
	"./crypto/osmo.svg": 549966,
	"./crypto/ost.svg": 528304,
	"./crypto/ovc.svg": 135489,
	"./crypto/ox.svg": 310905,
	"./crypto/oxt.svg": 487392,
	"./crypto/pBTC.svg": 497913,
	"./crypto/pai.svg": 250954,
	"./crypto/paint.svg": 434592,
	"./crypto/pal.svg": 954297,
	"./crypto/palm-2.svg": 664932,
	"./crypto/palm.svg": 7491,
	"./crypto/paper.svg": 760617,
	"./crypto/par.svg": 20677,
	"./crypto/part.svg": 461525,
	"./crypto/pasg.svg": 96224,
	"./crypto/pax.svg": 995122,
	"./crypto/paxg.svg": 11849,
	"./crypto/pay.svg": 430712,
	"./crypto/pbirb.svg": 525464,
	"./crypto/pbr.svg": 887397,
	"./crypto/pendle.svg": 308566,
	"./crypto/pepe.svg": 578241,
	"./crypto/perl.svg": 109959,
	"./crypto/perp.svg": 500701,
	"./crypto/pha.svg": 35144,
	"./crypto/phtk.svg": 622928,
	"./crypto/phx.svg": 296605,
	"./crypto/pickle.svg": 941722,
	"./crypto/pika.svg": 146935,
	"./crypto/pip.svg": 431116,
	"./crypto/pivx.svg": 424446,
	"./crypto/plDAI.svg": 118320,
	"./crypto/plUSDC.svg": 312799,
	"./crypto/pla.svg": 59456,
	"./crypto/play.svg": 26419,
	"./crypto/plr.svg": 342402,
	"./crypto/pltc.svg": 354369,
	"./crypto/pnb.svg": 655775,
	"./crypto/png.svg": 957951,
	"./crypto/pnk.svg": 38665,
	"./crypto/pnt.svg": 144749,
	"./crypto/poa.svg": 745892,
	"./crypto/poe.svg": 646661,
	"./crypto/pokt.svg": 252923,
	"./crypto/pols.svg": 189226,
	"./crypto/poly-2.svg": 822389,
	"./crypto/poly.svg": 249986,
	"./crypto/polyx.svg": 149166,
	"./crypto/pom.svg": 34594,
	"./crypto/pond.svg": 915184,
	"./crypto/pool.svg": 197808,
	"./crypto/pop.svg": 316708,
	"./crypto/popcat.svg": 790854,
	"./crypto/powr.svg": 758904,
	"./crypto/ppay.svg": 164497,
	"./crypto/ppc.svg": 541629,
	"./crypto/ppp.svg": 148727,
	"./crypto/ppt.svg": 6380,
	"./crypto/pre.svg": 549328,
	"./crypto/premia.svg": 857611,
	"./crypto/prime.svg": 136844,
	"./crypto/prl.svg": 991648,
	"./crypto/pro.svg": 21532,
	"./crypto/prom.svg": 319247,
	"./crypto/pros.svg": 850065,
	"./crypto/prq.svg": 819464,
	"./crypto/psp.svg": 34561,
	"./crypto/pst.svg": 753712,
	"./crypto/pxp.svg": 827996,
	"./crypto/pyr.svg": 845898,
	"./crypto/pyth.svg": 616631,
	"./crypto/pyusd.svg": 277299,
	"./crypto/qash.svg": 980086,
	"./crypto/qbit.svg": 231347,
	"./crypto/qi.svg": 828712,
	"./crypto/qkc.svg": 235609,
	"./crypto/qlc.svg": 175351,
	"./crypto/qnt.svg": 451740,
	"./crypto/qrdo.svg": 834414,
	"./crypto/qsp.svg": 872115,
	"./crypto/qtcon.svg": 880247,
	"./crypto/qtum.svg": 884591,
	"./crypto/quick.svg": 837516,
	"./crypto/r.svg": 377554,
	"./crypto/raca.svg": 981705,
	"./crypto/rae.svg": 877679,
	"./crypto/rai.svg": 994624,
	"./crypto/rari.svg": 229335,
	"./crypto/ray.svg": 882537,
	"./crypto/rbn.svg": 78613,
	"./crypto/rbx.svg": 987072,
	"./crypto/rcn.svg": 828754,
	"./crypto/rdai.svg": 452719,
	"./crypto/rdd.svg": 234859,
	"./crypto/rdn.svg": 451309,
	"./crypto/rdnt.svg": 726317,
	"./crypto/ren.svg": 729429,
	"./crypto/rep.svg": 922919,
	"./crypto/req.svg": 4549,
	"./crypto/reth-2.svg": 249042,
	"./crypto/reth.svg": 674055,
	"./crypto/rev.svg": 834121,
	"./crypto/rfox.svg": 292781,
	"./crypto/rfwsteth.svg": 230584,
	"./crypto/rgt.svg": 282732,
	"./crypto/rhoc.svg": 865540,
	"./crypto/rif.svg": 999723,
	"./crypto/rlc.svg": 697555,
	"./crypto/rly.svg": 659680,
	"./crypto/rndr.svg": 290666,
	"./crypto/ron.svg": 496108,
	"./crypto/rook.svg": 353318,
	"./crypto/rose.svg": 172821,
	"./crypto/rpl.svg": 398344,
	"./crypto/rpx.svg": 610037,
	"./crypto/rseth.svg": 51314,
	"./crypto/rsr.svg": 379481,
	"./crypto/rsv.svg": 512259,
	"./crypto/rune.svg": 71712,
	"./crypto/rvn.svg": 41850,
	"./crypto/s.svg": 441927,
	"./crypto/sai.svg": 782678,
	"./crypto/salt.svg": 976713,
	"./crypto/san.svg": 61541,
	"./crypto/sand.svg": 263846,
	"./crypto/sapp.svg": 489673,
	"./crypto/sar.svg": 141260,
	"./crypto/sats.svg": 758875,
	"./crypto/scrl.svg": 765249,
	"./crypto/scrt.svg": 195477,
	"./crypto/scs.svg": 714164,
	"./crypto/sdex.svg": 978169,
	"./crypto/sdl.svg": 658009,
	"./crypto/sdt.svg": 598156,
	"./crypto/seele.svg": 832715,
	"./crypto/sefi.svg": 884003,
	"./crypto/sei.svg": 988975,
	"./crypto/sem.svg": 364434,
	"./crypto/seth.svg": 894656,
	"./crypto/seth2.svg": 157444,
	"./crypto/sfi.svg": 269372,
	"./crypto/sfm.svg": 415078,
	"./crypto/sfp-2.svg": 321573,
	"./crypto/sfp.svg": 193671,
	"./crypto/sha.svg": 424851,
	"./crypto/shib.svg": 79137,
	"./crypto/shr.svg": 596261,
	"./crypto/shuf.svg": 393787,
	"./crypto/si.svg": 852615,
	"./crypto/sia.svg": 254703,
	"./crypto/sidus.svg": 789887,
	"./crypto/silo.svg": 460502,
	"./crypto/skl.svg": 959623,
	"./crypto/sky.svg": 887629,
	"./crypto/sld.svg": 404611,
	"./crypto/slex.svg": 644382,
	"./crypto/slp.svg": 178283,
	"./crypto/slt.svg": 227217,
	"./crypto/smart.svg": 346787,
	"./crypto/snail.svg": 654307,
	"./crypto/snc.svg": 377712,
	"./crypto/sngls.svg": 417266,
	"./crypto/snm.svg": 904815,
	"./crypto/snt.svg": 615888,
	"./crypto/snx.svg": 531775,
	"./crypto/soaps.svg": 949301,
	"./crypto/socks.svg": 561890,
	"./crypto/sofi.svg": 626138,
	"./crypto/sol.svg": 113122,
	"./crypto/solch.svg": 339950,
	"./crypto/soul.svg": 407532,
	"./crypto/sov.svg": 963389,
	"./crypto/spank.svg": 129834,
	"./crypto/spike.svg": 902242,
	"./crypto/spn.svg": 375896,
	"./crypto/sqr.svg": 539843,
	"./crypto/srm.svg": 426554,
	"./crypto/ssv.svg": 831007,
	"./crypto/stake.svg": 405341,
	"./crypto/steem.svg": 518503,
	"./crypto/step.svg": 389774,
	"./crypto/steth.svg": 790207,
	"./crypto/stg.svg": 870956,
	"./crypto/stmx.svg": 456481,
	"./crypto/storj.svg": 561201,
	"./crypto/storm.svg": 824304,
	"./crypto/stpt.svg": 705217,
	"./crypto/strat.svg": 80762,
	"./crypto/strdy.svg": 354611,
	"./crypto/strk.svg": 521131,
	"./crypto/strx.svg": 155845,
	"./crypto/stx.svg": 213839,
	"./crypto/stz.svg": 239781,
	"./crypto/sub.svg": 619573,
	"./crypto/sui.svg": 460606,
	"./crypto/sun.svg": 426357,
	"./crypto/super.svg": 437294,
	"./crypto/suqa.svg": 145518,
	"./crypto/surge.svg": 747527,
	"./crypto/susd-2.svg": 576844,
	"./crypto/susd.svg": 18,
	"./crypto/sushi.svg": 556743,
	"./crypto/suter.svg": 552822,
	"./crypto/swap.svg": 680143,
	"./crypto/sweat.svg": 479687,
	"./crypto/sweth.svg": 412688,
	"./crypto/swth.svg": 363681,
	"./crypto/sxdt.svg": 646365,
	"./crypto/sxp.svg": 330482,
	"./crypto/syn.svg": 404027,
	"./crypto/sys.svg": 771719,
	"./crypto/t.svg": 320416,
	"./crypto/tao.svg": 391737,
	"./crypto/tbtc-2.svg": 19245,
	"./crypto/tbtc.svg": 926070,
	"./crypto/tct.svg": 669619,
	"./crypto/tel.svg": 714815,
	"./crypto/tet.svg": 621470,
	"./crypto/tfuel.svg": 945831,
	"./crypto/thales.svg": 907969,
	"./crypto/thc.svg": 16763,
	"./crypto/thedao.svg": 924561,
	"./crypto/theta.svg": 909706,
	"./crypto/thr.svg": 438506,
	"./crypto/tia.svg": 833657,
	"./crypto/tio.svg": 747321,
	"./crypto/titan.svg": 479181,
	"./crypto/tkn.svg": 43801,
	"./crypto/tko.svg": 146692,
	"./crypto/tkx.svg": 454430,
	"./crypto/tky.svg": 501485,
	"./crypto/tnb.svg": 893227,
	"./crypto/tnc.svg": 472487,
	"./crypto/tnd.svg": 367102,
	"./crypto/tnt.svg": 219784,
	"./crypto/token.svg": 145506,
	"./crypto/tomi.svg": 982488,
	"./crypto/tomo.svg": 238830,
	"./crypto/ton.svg": 928639,
	"./crypto/torn.svg": 870217,
	"./crypto/tower.svg": 678757,
	"./crypto/tpay.svg": 947887,
	"./crypto/trac.svg": 165918,
	"./crypto/trb.svg": 184796,
	"./crypto/tribe.svg": 421553,
	"./crypto/trig.svg": 625699,
	"./crypto/trtl.svg": 125775,
	"./crypto/tru.svg": 120793,
	"./crypto/trx.svg": 425149,
	"./crypto/tryb.svg": 920368,
	"./crypto/ttc.svg": 285453,
	"./crypto/tube.svg": 422900,
	"./crypto/tusd.svg": 878986,
	"./crypto/twt.svg": 67745,
	"./crypto/tyzen.svg": 839560,
	"./crypto/ubi.svg": 909044,
	"./crypto/ubq.svg": 171135,
	"./crypto/ubt.svg": 102749,
	"./crypto/uft.svg": 668937,
	"./crypto/ult-2.svg": 159246,
	"./crypto/ult.svg": 639327,
	"./crypto/uma.svg": 507013,
	"./crypto/uncx.svg": 936587,
	"./crypto/unfi.svg": 353864,
	"./crypto/uni.svg": 457783,
	"./crypto/unibot.svg": 28127,
	"./crypto/uniqo.svg": 49640,
	"./crypto/unn.svg": 148355,
	"./crypto/uos.svg": 442366,
	"./crypto/upp.svg": 574494,
	"./crypto/usd1.svg": 829485,
	"./crypto/usdc.svg": 401397,
	"./crypto/usdd.svg": 877692,
	"./crypto/usde.svg": 258469,
	"./crypto/usdn.svg": 175248,
	"./crypto/usdp.svg": 94896,
	"./crypto/usds.svg": 269327,
	"./crypto/usdt.svg": 729377,
	"./crypto/usdt0.svg": 326038,
	"./crypto/usdy.svg": 275555,
	"./crypto/usx.svg": 294895,
	"./crypto/utk.svg": 497267,
	"./crypto/uuu.svg": 164909,
	"./crypto/uxp.svg": 603069,
	"./crypto/vai.svg": 175152,
	"./crypto/value.svg": 109188,
	"./crypto/vekwenta.svg": 986143,
	"./crypto/vela.svg": 351016,
	"./crypto/velo.svg": 790283,
	"./crypto/veri.svg": 335003,
	"./crypto/vest.svg": 556127,
	"./crypto/vet.svg": 415707,
	"./crypto/vgx.svg": 466296,
	"./crypto/via.svg": 253919,
	"./crypto/vib.svg": 248061,
	"./crypto/vibe.svg": 726538,
	"./crypto/vidt.svg": 581510,
	"./crypto/vikky.svg": 556893,
	"./crypto/vin.svg": 420083,
	"./crypto/vina.svg": 487841,
	"./crypto/vita.svg": 615754,
	"./crypto/vite.svg": 735157,
	"./crypto/viu.svg": 255556,
	"./crypto/vlx.svg": 149917,
	"./crypto/vrs.svg": 883391,
	"./crypto/vs.svg": 999792,
	"./crypto/vsp.svg": 450983,
	"./crypto/vsys.svg": 294512,
	"./crypto/vtc.svg": 580054,
	"./crypto/vvs.svg": 387881,
	"./crypto/w.svg": 432496,
	"./crypto/wabi.svg": 295733,
	"./crypto/wagmigames.svg": 943145,
	"./crypto/wan.svg": 453737,
	"./crypto/warp.svg": 449651,
	"./crypto/wassie.svg": 751343,
	"./crypto/waves.svg": 559921,
	"./crypto/wbt.svg": 300349,
	"./crypto/wbtc.svg": 730859,
	"./crypto/wck.svg": 925552,
	"./crypto/wct.svg": 81904,
	"./crypto/weco.svg": 42298,
	"./crypto/weeth.svg": 91514,
	"./crypto/wemix.svg": 76633,
	"./crypto/weth.svg": 15653,
	"./crypto/wexpoly.svg": 564278,
	"./crypto/whale.svg": 662699,
	"./crypto/wib.svg": 901682,
	"./crypto/wild.svg": 722708,
	"./crypto/win.svg": 683585,
	"./crypto/wing.svg": 792287,
	"./crypto/wings.svg": 958859,
	"./crypto/wld.svg": 585611,
	"./crypto/wmt.svg": 13493,
	"./crypto/woo.svg": 436776,
	"./crypto/wopenx.svg": 548454,
	"./crypto/wpr.svg": 305016,
	"./crypto/wrx.svg": 479344,
	"./crypto/wsteth.svg": 326239,
	"./crypto/wtbt.svg": 407741,
	"./crypto/wtc.svg": 832203,
	"./crypto/wxt.svg": 321464,
	"./crypto/x2y2.svg": 382845,
	"./crypto/xai.svg": 909716,
	"./crypto/xas.svg": 922525,
	"./crypto/xaut.svg": 737642,
	"./crypto/xch.svg": 612284,
	"./crypto/xchf.svg": 111908,
	"./crypto/xcm.svg": 879719,
	"./crypto/xcn.svg": 942211,
	"./crypto/xdc.svg": 58937,
	"./crypto/xec.svg": 29810,
	"./crypto/xem.svg": 731177,
	"./crypto/xhv.svg": 651884,
	"./crypto/xido.svg": 14897,
	"./crypto/xin.svg": 348290,
	"./crypto/xlm.svg": 714244,
	"./crypto/xln.svg": 709512,
	"./crypto/xlq.svg": 603726,
	"./crypto/xmark.svg": 110636,
	"./crypto/xmr.svg": 399439,
	"./crypto/xmt.svg": 255835,
	"./crypto/xmx.svg": 977162,
	"./crypto/xnk.svg": 980129,
	"./crypto/xno.svg": 994076,
	"./crypto/xns.svg": 2577,
	"./crypto/xor.svg": 484417,
	"./crypto/xpl.svg": 31770,
	"./crypto/xpr.svg": 711632,
	"./crypto/xprt.svg": 790150,
	"./crypto/xrd.svg": 751376,
	"./crypto/xrgb.svg": 515521,
	"./crypto/xrp.svg": 412940,
	"./crypto/xsn.svg": 340095,
	"./crypto/xsr.svg": 150264,
	"./crypto/xtz.svg": 205322,
	"./crypto/xvg.svg": 492322,
	"./crypto/xym.svg": 68661,
	"./crypto/xyo.svg": 11477,
	"./crypto/xzc.svg": 349045,
	"./crypto/yara.svg": 552570,
	"./crypto/yfi.svg": 510317,
	"./crypto/yfii.svg": 80597,
	"./crypto/yld.svg": 350507,
	"./crypto/yoyo.svg": 564542,
	"./crypto/zai.svg": 779301,
	"./crypto/zb.svg": 545387,
	"./crypto/zco.svg": 793960,
	"./crypto/zec.svg": 161191,
	"./crypto/zel.svg": 232651,
	"./crypto/zen.svg": 715505,
	"./crypto/zeph.svg": 813568,
	"./crypto/zil.svg": 390949,
	"./crypto/zk.svg": 991878,
	"./crypto/zks.svg": 514622,
	"./crypto/zksp.svg": 235578,
	"./crypto/zpay.svg": 544446,
	"./crypto/zro.svg": 913143,
	"./crypto/zrx.svg": 761110,
	"./crypto/zusd.svg": 44592,
	"./forex/AUD.png": 190756,
	"./forex/CAD.png": 669683,
	"./forex/CHF.png": 566340,
	"./forex/DKK.png": 439136,
	"./forex/EUR.png": 875272,
	"./forex/GBP.png": 166880,
	"./forex/HKD.png": 309807,
	"./forex/HUF.png": 225471,
	"./forex/JMD.png": 814918,
	"./forex/JPY.png": 470642,
	"./forex/MXN.png": 816836,
	"./forex/NOK.png": 907598,
	"./forex/NZD.png": 682711,
	"./forex/PLN.png": 396287,
	"./forex/RUB.png": 356167,
	"./forex/SEK.png": 550503,
	"./forex/SGD.png": 626394,
	"./forex/TRY.png": 40001,
	"./forex/USD.png": 322745,
	"./forex/XAG.png": 909703,
	"./forex/XAU.png": 140302,
	"./forex/ZAR.png": 4694,
	"./stocks/A.png": 31274,
	"./stocks/AA.png": 878315,
	"./stocks/AAA.png": 776538,
	"./stocks/AAC.U.png": 20298,
	"./stocks/AAC.png": 352677,
	"./stocks/AACG.png": 855174,
	"./stocks/AACI.png": 211364,
	"./stocks/AACIU.png": 721773,
	"./stocks/AACOU.png": 610330,
	"./stocks/AADI.png": 162716,
	"./stocks/AAGR.png": 2480,
	"./stocks/AAIN.png": 636064,
	"./stocks/AAL.png": 543546,
	"./stocks/AAMC.png": 58147,
	"./stocks/AAME.png": 292271,
	"./stocks/AAN.png": 57457,
	"./stocks/AAOI.png": 892622,
	"./stocks/AAON.png": 134990,
	"./stocks/AAP.png": 427855,
	"./stocks/AAPL.png": 124231,
	"./stocks/AAQC.png": 611170,
	"./stocks/AAT.png": 746213,
	"./stocks/AATC.png": 561106,
	"./stocks/AAU.png": 439849,
	"./stocks/AAWW.png": 386200,
	"./stocks/AB.png": 755410,
	"./stocks/ABAT.png": 842057,
	"./stocks/ABB.png": 794097,
	"./stocks/ABBV.png": 935842,
	"./stocks/ABC.png": 705836,
	"./stocks/ABCB.png": 861352,
	"./stocks/ABCL.png": 132935,
	"./stocks/ABCM.png": 219739,
	"./stocks/ABEO.png": 746921,
	"./stocks/ABEV.png": 935130,
	"./stocks/ABG.png": 13680,
	"./stocks/ABIO.png": 560605,
	"./stocks/ABLV.png": 753523,
	"./stocks/ABM.png": 211778,
	"./stocks/ABMD.png": 178632,
	"./stocks/ABML.png": 282634,
	"./stocks/ABNB.png": 118512,
	"./stocks/ABOS.png": 907022,
	"./stocks/ABP.png": 186060,
	"./stocks/ABR.png": 478785,
	"./stocks/ABSI.png": 58534,
	"./stocks/ABST.png": 56543,
	"./stocks/ABT.png": 589103,
	"./stocks/ABTS.png": 175422,
	"./stocks/ABTX.png": 112055,
	"./stocks/ABUS.png": 745581,
	"./stocks/ABVC.png": 197356,
	"./stocks/AC.png": 120756,
	"./stocks/ACA.png": 93709,
	"./stocks/ACACU.png": 300004,
	"./stocks/ACAD.png": 592990,
	"./stocks/ACAH.png": 418136,
	"./stocks/ACAHU.png": 30842,
	"./stocks/ACAQ.png": 474438,
	"./stocks/ACAX.png": 561154,
	"./stocks/ACAXR.png": 974285,
	"./stocks/ACAXU.png": 83294,
	"./stocks/ACAXW.png": 418805,
	"./stocks/ACB.png": 833513,
	"./stocks/ACBI.png": 528817,
	"./stocks/ACC.png": 650765,
	"./stocks/ACCD.png": 619575,
	"./stocks/ACCO.png": 926145,
	"./stocks/ACEL.png": 991702,
	"./stocks/ACER.png": 219143,
	"./stocks/ACET.png": 36391,
	"./stocks/ACGL.png": 546926,
	"./stocks/ACGLN.png": 515446,
	"./stocks/ACGLO.png": 177854,
	"./stocks/ACH.png": 827801,
	"./stocks/ACHC.png": 871273,
	"./stocks/ACHL.png": 687516,
	"./stocks/ACHR.png": 22795,
	"./stocks/ACHV.png": 918684,
	"./stocks/ACI.png": 60841,
	"./stocks/ACIU.png": 396456,
	"./stocks/ACIW.png": 313549,
	"./stocks/ACLS.png": 435984,
	"./stocks/ACLX.png": 622030,
	"./stocks/ACM.png": 910754,
	"./stocks/ACMR.png": 940130,
	"./stocks/ACN.png": 569554,
	"./stocks/ACNB.png": 917037,
	"./stocks/ACON.png": 564495,
	"./stocks/ACOR.png": 263644,
	"./stocks/ACRE.png": 971436,
	"./stocks/ACRS.png": 658605,
	"./stocks/ACRV.png": 682741,
	"./stocks/ACRX.png": 7187,
	"./stocks/ACST.png": 167960,
	"./stocks/ACTD.png": 538618,
	"./stocks/ACTDU.png": 585794,
	"./stocks/ACTG.png": 363428,
	"./stocks/ACTU.png": 763875,
	"./stocks/ACTX.png": 263943,
	"./stocks/ACV.png": 316276,
	"./stocks/ACVA.png": 533955,
	"./stocks/ACXP.png": 944625,
	"./stocks/ACY.png": 492636,
	"./stocks/ADAP.png": 953311,
	"./stocks/ADBE.png": 160326,
	"./stocks/ADC.png": 87077,
	"./stocks/ADCT.png": 272430,
	"./stocks/ADD.png": 3445,
	"./stocks/ADDYY.png": 160498,
	"./stocks/ADER.png": 724322,
	"./stocks/ADGI.png": 160707,
	"./stocks/ADGM.png": 738824,
	"./stocks/ADI.png": 917391,
	"./stocks/ADIL.png": 705933,
	"./stocks/ADM.png": 591627,
	"./stocks/ADMA.png": 279601,
	"./stocks/ADMP.png": 412010,
	"./stocks/ADMS.png": 795474,
	"./stocks/ADN.png": 754163,
	"./stocks/ADNT.png": 151026,
	"./stocks/ADP.png": 141801,
	"./stocks/ADPT.png": 12140,
	"./stocks/ADRT.png": 71560,
	"./stocks/ADS.png": 422363,
	"./stocks/ADSK.png": 680755,
	"./stocks/ADT.png": 125126,
	"./stocks/ADTH.png": 267036,
	"./stocks/ADTN.png": 844640,
	"./stocks/ADTX.png": 484378,
	"./stocks/ADUR.png": 38610,
	"./stocks/ADUS.png": 869328,
	"./stocks/ADV.png": 885982,
	"./stocks/ADVM.png": 110345,
	"./stocks/ADX.png": 936330,
	"./stocks/ADXN.png": 658424,
	"./stocks/ADXS.png": 422377,
	"./stocks/AEE.png": 637331,
	"./stocks/AEG.png": 994141,
	"./stocks/AEHL.png": 270975,
	"./stocks/AEHR.png": 70690,
	"./stocks/AEI.png": 963991,
	"./stocks/AEIS.png": 218963,
	"./stocks/AEL.png": 648424,
	"./stocks/AEM.png": 328885,
	"./stocks/AEMD.png": 483461,
	"./stocks/AEO.png": 252814,
	"./stocks/AEON.png": 527771,
	"./stocks/AEP.png": 339069,
	"./stocks/AEPPZ.png": 904982,
	"./stocks/AER.png": 899881,
	"./stocks/AERC.png": 13044,
	"./stocks/AERI.png": 135609,
	"./stocks/AERT.png": 606979,
	"./stocks/AES.png": 289275,
	"./stocks/AESC.png": 513675,
	"./stocks/AESE.png": 904991,
	"./stocks/AEVA.png": 737868,
	"./stocks/AEY.png": 304096,
	"./stocks/AEYE.png": 933589,
	"./stocks/AEZS.png": 902758,
	"./stocks/AFAQ.png": 537895,
	"./stocks/AFB.png": 768730,
	"./stocks/AFBI.png": 687601,
	"./stocks/AFCG.png": 365569,
	"./stocks/AFG.png": 801630,
	"./stocks/AFI.png": 887619,
	"./stocks/AFIB.png": 426574,
	"./stocks/AFIN.png": 749871,
	"./stocks/AFINO.png": 773249,
	"./stocks/AFINP.png": 276587,
	"./stocks/AFL.png": 16407,
	"./stocks/AFMD.png": 346988,
	"./stocks/AFRM.png": 803840,
	"./stocks/AG.png": 487239,
	"./stocks/AGBA.png": 719452,
	"./stocks/AGCO.png": 367401,
	"./stocks/AGE.png": 699124,
	"./stocks/AGEN.png": 906019,
	"./stocks/AGFS.png": 636692,
	"./stocks/AGFY.png": 706467,
	"./stocks/AGH.png": 873395,
	"./stocks/AGI.png": 3537,
	"./stocks/AGIL.png": 404629,
	"./stocks/AGIO.png": 669741,
	"./stocks/AGL.png": 618721,
	"./stocks/AGLE.png": 574537,
	"./stocks/AGM.png": 123691,
	"./stocks/AGMH.png": 798415,
	"./stocks/AGN.png": 585164,
	"./stocks/AGNC.png": 848684,
	"./stocks/AGO.png": 472818,
	"./stocks/AGR.png": 328857,
	"./stocks/AGRI.png": 368543,
	"./stocks/AGRO.png": 700619,
	"./stocks/AGRX.png": 912790,
	"./stocks/AGS.png": 628320,
	"./stocks/AGTC.png": 528675,
	"./stocks/AGTI.png": 353384,
	"./stocks/AGYS.png": 570531,
	"./stocks/AHCO.png": 287140,
	"./stocks/AHELF.png": 148567,
	"./stocks/AHG.png": 28582,
	"./stocks/AHI.png": 438068,
	"./stocks/AHPI.png": 745768,
	"./stocks/AHT.png": 563988,
	"./stocks/AI.png": 555803,
	"./stocks/AIEV.png": 923329,
	"./stocks/AIFF.png": 864594,
	"./stocks/AIG.png": 419351,
	"./stocks/AIH.png": 684697,
	"./stocks/AIHS.png": 858124,
	"./stocks/AIKI.png": 630617,
	"./stocks/AILE.png": 509593,
	"./stocks/AIM.png": 783471,
	"./stocks/AIMC.png": 551538,
	"./stocks/AIMD.png": 386806,
	"./stocks/AINV.png": 149461,
	"./stocks/AIP.png": 459695,
	"./stocks/AIR.png": 435596,
	"./stocks/AIRC.png": 600136,
	"./stocks/AIRE.png": 225795,
	"./stocks/AIRG.png": 229695,
	"./stocks/AIRI.png": 227294,
	"./stocks/AIRS.png": 501232,
	"./stocks/AIRT.png": 89632,
	"./stocks/AIRTP.png": 353038,
	"./stocks/AISP.png": 41340,
	"./stocks/AIV.png": 871572,
	"./stocks/AIZ.png": 846001,
	"./stocks/AJG.png": 709819,
	"./stocks/AJRD.png": 342979,
	"./stocks/AKAM.png": 968096,
	"./stocks/AKAN.png": 333677,
	"./stocks/AKBA.png": 460532,
	"./stocks/AKIC.png": 364605,
	"./stocks/AKLI.png": 676665,
	"./stocks/AKR.png": 895145,
	"./stocks/AKRO.png": 769293,
	"./stocks/AKTS.png": 310269,
	"./stocks/AKTX.png": 919042,
	"./stocks/AKU.png": 37171,
	"./stocks/AKUS.png": 21000,
	"./stocks/AKYA.png": 653220,
	"./stocks/AL.png": 334805,
	"./stocks/ALAB.png": 311757,
	"./stocks/ALAC.png": 879366,
	"./stocks/ALACW.png": 520953,
	"./stocks/ALB.png": 359224,
	"./stocks/ALBO.png": 260596,
	"./stocks/ALBT.png": 581211,
	"./stocks/ALC.png": 327036,
	"./stocks/ALCC.png": 617900,
	"./stocks/ALCE.png": 583741,
	"./stocks/ALDX.png": 57128,
	"./stocks/ALE.png": 399598,
	"./stocks/ALEC.png": 655038,
	"./stocks/ALEX.png": 126119,
	"./stocks/ALF.png": 559734,
	"./stocks/ALGM.png": 58456,
	"./stocks/ALGN.png": 451971,
	"./stocks/ALGS.png": 941474,
	"./stocks/ALGT.png": 469394,
	"./stocks/ALHC.png": 889641,
	"./stocks/ALIM.png": 482457,
	"./stocks/ALIT.png": 907562,
	"./stocks/ALK.png": 493988,
	"./stocks/ALKS.png": 44131,
	"./stocks/ALKT.png": 435651,
	"./stocks/ALL.png": 905985,
	"./stocks/ALLE.png": 498155,
	"./stocks/ALLG.png": 604966,
	"./stocks/ALLK.png": 633267,
	"./stocks/ALLO.png": 857017,
	"./stocks/ALLR.png": 79677,
	"./stocks/ALLT.png": 285091,
	"./stocks/ALLY.png": 391842,
	"./stocks/ALMS.png": 503464,
	"./stocks/ALNA.png": 929384,
	"./stocks/ALNY.png": 467532,
	"./stocks/ALOT.png": 675378,
	"./stocks/ALPN.png": 807811,
	"./stocks/ALPP.png": 819104,
	"./stocks/ALPS.png": 494266,
	"./stocks/ALRM.png": 723180,
	"./stocks/ALRN.png": 956634,
	"./stocks/ALRS.png": 467697,
	"./stocks/ALSA.png": 130285,
	"./stocks/ALSN.png": 850815,
	"./stocks/ALT.png": 408739,
	"./stocks/ALTM.png": 836167,
	"./stocks/ALTO.png": 763241,
	"./stocks/ALTR.png": 904750,
	"./stocks/ALUR.png": 623136,
	"./stocks/ALV.png": 476210,
	"./stocks/ALVR.png": 99441,
	"./stocks/ALXO.png": 480877,
	"./stocks/ALYA.png": 617682,
	"./stocks/ALZN.png": 273762,
	"./stocks/AM.png": 588314,
	"./stocks/AMAL.png": 862917,
	"./stocks/AMAM.png": 519930,
	"./stocks/AMAO.png": 323711,
	"./stocks/AMAT.png": 958521,
	"./stocks/AMBA.png": 562778,
	"./stocks/AMBO.png": 449159,
	"./stocks/AMBP.png": 364445,
	"./stocks/AMC.png": 920753,
	"./stocks/AMCCF.png": 42440,
	"./stocks/AMCR.png": 220600,
	"./stocks/AMCX.png": 253857,
	"./stocks/AMD.png": 497287,
	"./stocks/AME.png": 516727,
	"./stocks/AMED.png": 171993,
	"./stocks/AMEH.png": 454966,
	"./stocks/AMG.png": 661058,
	"./stocks/AMGN.png": 93476,
	"./stocks/AMGO.png": 474194,
	"./stocks/AMH.png": 68726,
	"./stocks/AMIX.png": 843807,
	"./stocks/AMJ.png": 113168,
	"./stocks/AMK.png": 717362,
	"./stocks/AMKR.png": 699262,
	"./stocks/AMLP.png": 791579,
	"./stocks/AMLX.png": 145851,
	"./stocks/AMN.png": 207154,
	"./stocks/AMNB.png": 938252,
	"./stocks/AMOD.png": 786666,
	"./stocks/AMOT.png": 3473,
	"./stocks/AMP.png": 736381,
	"./stocks/AMPE.png": 991542,
	"./stocks/AMPG.png": 871450,
	"./stocks/AMPGW.png": 580379,
	"./stocks/AMPH.png": 640298,
	"./stocks/AMPL.png": 476577,
	"./stocks/AMPS.png": 396097,
	"./stocks/AMPX.png": 796638,
	"./stocks/AMPY.png": 170061,
	"./stocks/AMR.png": 699339,
	"./stocks/AMRC.png": 471740,
	"./stocks/AMRK.png": 256110,
	"./stocks/AMRN.png": 520289,
	"./stocks/AMRS.png": 22355,
	"./stocks/AMRX.png": 276065,
	"./stocks/AMS.png": 688613,
	"./stocks/AMSC.png": 606069,
	"./stocks/AMSF.png": 740510,
	"./stocks/AMST.png": 263648,
	"./stocks/AMSWA.png": 206152,
	"./stocks/AMT.png": 27697,
	"./stocks/AMTB.png": 974750,
	"./stocks/AMTBB.png": 796987,
	"./stocks/AMTD.png": 597362,
	"./stocks/AMTX.png": 419765,
	"./stocks/AMV.png": 126059,
	"./stocks/AMWD.png": 971856,
	"./stocks/AMWL.png": 687622,
	"./stocks/AMX.png": 219029,
	"./stocks/AMYT.png": 784423,
	"./stocks/AMZN.png": 747862,
	"./stocks/AN.png": 929789,
	"./stocks/ANAB.png": 376800,
	"./stocks/ANAT.png": 949837,
	"./stocks/ANDE.png": 412137,
	"./stocks/ANEB.png": 613149,
	"./stocks/ANET.png": 905270,
	"./stocks/ANF.png": 996647,
	"./stocks/ANG.png": 924404,
	"./stocks/ANGH.png": 895946,
	"./stocks/ANGI.png": 959944,
	"./stocks/ANGN.png": 298134,
	"./stocks/ANGO.png": 240471,
	"./stocks/ANIK.png": 671520,
	"./stocks/ANIP.png": 819035,
	"./stocks/ANIX.png": 177369,
	"./stocks/ANNX.png": 314430,
	"./stocks/ANPC.png": 258279,
	"./stocks/ANSS.png": 364387,
	"./stocks/ANTE.png": 719909,
	"./stocks/ANTM.png": 394437,
	"./stocks/ANTX.png": 656975,
	"./stocks/ANVS.png": 128949,
	"./stocks/ANY.png": 184050,
	"./stocks/AOMR.png": 240347,
	"./stocks/AON.png": 720023,
	"./stocks/AORT.png": 812112,
	"./stocks/AOS.png": 370925,
	"./stocks/AOSL.png": 484675,
	"./stocks/AP.png": 294775,
	"./stocks/APA.png": 949161,
	"./stocks/APAM.png": 252778,
	"./stocks/APB.png": 168797,
	"./stocks/APCX.png": 359511,
	"./stocks/APD.png": 42405,
	"./stocks/APDN.png": 767731,
	"./stocks/APE.png": 768945,
	"./stocks/APEI.png": 800588,
	"./stocks/APEN.png": 959223,
	"./stocks/APG.png": 873941,
	"./stocks/APGN.png": 43827,
	"./stocks/APH.png": 615626,
	"./stocks/API.png": 594487,
	"./stocks/APLD.png": 591446,
	"./stocks/APLE.png": 774923,
	"./stocks/APLM.png": 568937,
	"./stocks/APLS.png": 624870,
	"./stocks/APLT.png": 933124,
	"./stocks/APM.png": 725804,
	"./stocks/APMI.png": 566419,
	"./stocks/APO.png": 954020,
	"./stocks/APOG.png": 438184,
	"./stocks/APOP.png": 959483,
	"./stocks/APP.png": 19734,
	"./stocks/APPF.png": 870273,
	"./stocks/APPH.png": 122260,
	"./stocks/APPN.png": 505343,
	"./stocks/APPS.png": 510102,
	"./stocks/APRE.png": 808560,
	"./stocks/APRN.png": 1293,
	"./stocks/APT.png": 917247,
	"./stocks/APTO.png": 479223,
	"./stocks/APTS.png": 363818,
	"./stocks/APTV.png": 448888,
	"./stocks/APTX.png": 289433,
	"./stocks/APVO.png": 537381,
	"./stocks/APWC.png": 874897,
	"./stocks/APYX.png": 69963,
	"./stocks/AQB.png": 351043,
	"./stocks/AQMS.png": 690471,
	"./stocks/AQN.png": 604881,
	"./stocks/AQST.png": 497848,
	"./stocks/AQUA.png": 937883,
	"./stocks/AR.png": 18827,
	"./stocks/ARAV.png": 457453,
	"./stocks/ARAY.png": 20775,
	"./stocks/ARBB.png": 48265,
	"./stocks/ARBB2.png": 512622,
	"./stocks/ARBE.png": 473840,
	"./stocks/ARBK.png": 386074,
	"./stocks/ARC.png": 500488,
	"./stocks/ARCB.png": 128869,
	"./stocks/ARCC.png": 449074,
	"./stocks/ARCH.png": 653199,
	"./stocks/ARCO.png": 793855,
	"./stocks/ARCT.png": 349415,
	"./stocks/ARDS.png": 925187,
	"./stocks/ARDX.png": 582997,
	"./stocks/ARE.png": 569899,
	"./stocks/AREB.png": 468915,
	"./stocks/AREC.png": 657924,
	"./stocks/AREN.png": 237533,
	"./stocks/ARES.png": 245440,
	"./stocks/ARGO.png": 130873,
	"./stocks/ARGX.png": 69907,
	"./stocks/ARHS.png": 744023,
	"./stocks/ARI.png": 341669,
	"./stocks/ARKR.png": 61296,
	"./stocks/ARL.png": 854372,
	"./stocks/ARLO.png": 482339,
	"./stocks/ARLP.png": 360564,
	"./stocks/ARM.png": 756598,
	"./stocks/ARMK.png": 718209,
	"./stocks/ARNA.png": 247110,
	"./stocks/AROC.png": 635949,
	"./stocks/ARQQ.png": 581141,
	"./stocks/ARQT.png": 968468,
	"./stocks/ARR.png": 463760,
	"./stocks/ARRY.png": 601279,
	"./stocks/ARTL.png": 877574,
	"./stocks/ARTW.png": 302668,
	"./stocks/ARVL.png": 728948,
	"./stocks/ARVN.png": 474370,
	"./stocks/ARW.png": 524710,
	"./stocks/ARWR.png": 314219,
	"./stocks/ARYD.png": 958793,
	"./stocks/ASAI.png": 261563,
	"./stocks/ASAN.png": 447724,
	"./stocks/ASB.png": 486995,
	"./stocks/ASC.png": 73463,
	"./stocks/ASGN.png": 825732,
	"./stocks/ASH.png": 382667,
	"./stocks/ASLE.png": 269605,
	"./stocks/ASLEW.png": 71475,
	"./stocks/ASLN.png": 703478,
	"./stocks/ASM.png": 270793,
	"./stocks/ASMB.png": 373953,
	"./stocks/ASML.png": 349182,
	"./stocks/ASND.png": 385269,
	"./stocks/ASNS.png": 486997,
	"./stocks/ASO.png": 16846,
	"./stocks/ASPI.png": 280079,
	"./stocks/ASPN.png": 443694,
	"./stocks/ASPS.png": 892744,
	"./stocks/ASPU.png": 913137,
	"./stocks/ASR.png": 873920,
	"./stocks/ASRT.png": 590079,
	"./stocks/ASRV.png": 438388,
	"./stocks/ASST.png": 457920,
	"./stocks/ASTC.png": 515341,
	"./stocks/ASTE.png": 936911,
	"./stocks/ASTI.png": 633088,
	"./stocks/ASTL.png": 846779,
	"./stocks/ASTR.png": 801353,
	"./stocks/ASTS.png": 916018,
	"./stocks/ASX.png": 5500,
	"./stocks/ASYS.png": 622238,
	"./stocks/ATAI.png": 983598,
	"./stocks/ATAQ.png": 823398,
	"./stocks/ATAX.png": 626086,
	"./stocks/ATCH.png": 999073,
	"./stocks/ATCO.png": 526430,
	"./stocks/ATCOL.png": 639732,
	"./stocks/ATCX.png": 58353,
	"./stocks/ATEC.png": 738703,
	"./stocks/ATEN.png": 663410,
	"./stocks/ATER.png": 461956,
	"./stocks/ATEX.png": 100117,
	"./stocks/ATGE.png": 931426,
	"./stocks/ATGL.png": 843750,
	"./stocks/ATH.png": 281786,
	"./stocks/ATHA.png": 564614,
	"./stocks/ATHE.png": 927799,
	"./stocks/ATHM.png": 208022,
	"./stocks/ATHX.png": 474127,
	"./stocks/ATI.png": 996017,
	"./stocks/ATIF.png": 103693,
	"./stocks/ATIP.png": 733261,
	"./stocks/ATKR.png": 564497,
	"./stocks/ATLN.png": 982391,
	"./stocks/ATLX.png": 475802,
	"./stocks/ATNF.png": 135286,
	"./stocks/ATNM.png": 206154,
	"./stocks/ATNX.png": 958236,
	"./stocks/ATO.png": 184344,
	"./stocks/ATOM.png": 395365,
	"./stocks/ATPC.png": 67047,
	"./stocks/ATR.png": 617262,
	"./stocks/ATRA.png": 600344,
	"./stocks/ATRC.png": 109416,
	"./stocks/ATRI.png": 142159,
	"./stocks/ATTO.png": 601578,
	"./stocks/ATUS.png": 398433,
	"./stocks/ATVI.png": 824188,
	"./stocks/ATXG.png": 577764,
	"./stocks/ATXI.png": 217216,
	"./stocks/ATY.png": 29753,
	"./stocks/AUD.png": 791989,
	"./stocks/AUDC.png": 345238,
	"./stocks/AUID.png": 549187,
	"./stocks/AUMN.png": 813821,
	"./stocks/AUPH.png": 188532,
	"./stocks/AUR.png": 265412,
	"./stocks/AUST.png": 176112,
	"./stocks/AUTL.png": 333342,
	"./stocks/AUTO.png": 16105,
	"./stocks/AUUD.png": 407558,
	"./stocks/AUUDW.png": 11880,
	"./stocks/AUVI.png": 453320,
	"./stocks/AUY.png": 342087,
	"./stocks/AVA.png": 936250,
	"./stocks/AVAL.png": 794272,
	"./stocks/AVAV.png": 766501,
	"./stocks/AVB.png": 243386,
	"./stocks/AVCT.png": 830639,
	"./stocks/AVDL.png": 997497,
	"./stocks/AVDX.png": 44007,
	"./stocks/AVEO.png": 784540,
	"./stocks/AVGO.png": 43631,
	"./stocks/AVGOP.png": 508964,
	"./stocks/AVGR.png": 580930,
	"./stocks/AVID.png": 579511,
	"./stocks/AVNT.png": 559647,
	"./stocks/AVNW.png": 730169,
	"./stocks/AVO.png": 7714,
	"./stocks/AVRO.png": 884792,
	"./stocks/AVT.png": 804920,
	"./stocks/AVTE.png": 709742,
	"./stocks/AVTR.png": 327609,
	"./stocks/AVTX.png": 876405,
	"./stocks/AVXL.png": 188712,
	"./stocks/AVXT.png": 630887,
	"./stocks/AVY.png": 57182,
	"./stocks/AVYA.png": 931643,
	"./stocks/AWF.png": 456329,
	"./stocks/AWH.png": 188643,
	"./stocks/AWI.png": 359246,
	"./stocks/AWIN.png": 325716,
	"./stocks/AWK.png": 472293,
	"./stocks/AWR.png": 208902,
	"./stocks/AWRE.png": 423746,
	"./stocks/AXDX.png": 374775,
	"./stocks/AXGN.png": 494265,
	"./stocks/AXH.png": 226759,
	"./stocks/AXL.png": 518273,
	"./stocks/AXLA.png": 176691,
	"./stocks/AXNX.png": 709398,
	"./stocks/AXON.png": 663869,
	"./stocks/AXP.png": 158543,
	"./stocks/AXR.png": 337012,
	"./stocks/AXS.png": 112070,
	"./stocks/AXSM.png": 73995,
	"./stocks/AXTA.png": 251776,
	"./stocks/AXTI.png": 903132,
	"./stocks/AY.png": 938135,
	"./stocks/AYI.png": 588332,
	"./stocks/AYLA.png": 75137,
	"./stocks/AYRO.png": 248468,
	"./stocks/AYTU.png": 281270,
	"./stocks/AYX.png": 863056,
	"./stocks/AZEK.png": 538451,
	"./stocks/AZI.png": 460107,
	"./stocks/AZN.png": 486497,
	"./stocks/AZO.png": 855147,
	"./stocks/AZRE.png": 466936,
	"./stocks/AZTA.png": 452580,
	"./stocks/AZTR.png": 39386,
	"./stocks/AZUL.png": 865443,
	"./stocks/AZYO.png": 636615,
	"./stocks/AZZ.png": 998106,
	"./stocks/B.png": 342958,
	"./stocks/BA.png": 553568,
	"./stocks/BABA.png": 928736,
	"./stocks/BAC.png": 867932,
	"./stocks/BACK.png": 904250,
	"./stocks/BAER.png": 922883,
	"./stocks/BAH.png": 232120,
	"./stocks/BAK.png": 787154,
	"./stocks/BALY.png": 626709,
	"./stocks/BAM.png": 572808,
	"./stocks/BANC.png": 76458,
	"./stocks/BAND.png": 156971,
	"./stocks/BANR.png": 796543,
	"./stocks/BAOS.png": 814015,
	"./stocks/BAP.png": 208567,
	"./stocks/BARK.png": 310093,
	"./stocks/BASE.png": 658969,
	"./stocks/BATRA.png": 178406,
	"./stocks/BATRK.png": 714487,
	"./stocks/BAX.png": 934486,
	"./stocks/BAYN.png": 165341,
	"./stocks/BAYRY.png": 540929,
	"./stocks/BAYZF.png": 898186,
	"./stocks/BB.png": 951106,
	"./stocks/BBAI.png": 325994,
	"./stocks/BBAR.png": 946662,
	"./stocks/BBBY.png": 244838,
	"./stocks/BBCP.png": 963766,
	"./stocks/BBD.png": 529740,
	"./stocks/BBI.png": 632075,
	"./stocks/BBIG.png": 878395,
	"./stocks/BBIO.png": 417806,
	"./stocks/BBL.png": 939843,
	"./stocks/BBLG.png": 598690,
	"./stocks/BBLN.png": 609007,
	"./stocks/BBN.png": 933323,
	"./stocks/BBQ.png": 169038,
	"./stocks/BBSI.png": 471547,
	"./stocks/BBU.png": 987334,
	"./stocks/BBVA.png": 168500,
	"./stocks/BBW.png": 814500,
	"./stocks/BBWI.png": 332401,
	"./stocks/BBY.png": 327712,
	"./stocks/BC.png": 261166,
	"./stocks/BCAB.png": 223493,
	"./stocks/BCAC.png": 49628,
	"./stocks/BCACU.png": 19068,
	"./stocks/BCAN.png": 52629,
	"./stocks/BCC.png": 192841,
	"./stocks/BCDA.png": 859224,
	"./stocks/BCE.png": 640838,
	"./stocks/BCEI.png": 713373,
	"./stocks/BCEL.png": 166635,
	"./stocks/BCG.png": 539436,
	"./stocks/BCH.png": 547403,
	"./stocks/BCLI.png": 170943,
	"./stocks/BCO.png": 935979,
	"./stocks/BCOR.png": 598354,
	"./stocks/BCOV.png": 77687,
	"./stocks/BCPC.png": 739251,
	"./stocks/BCRX.png": 676046,
	"./stocks/BCS.png": 334146,
	"./stocks/BCTS.png": 626188,
	"./stocks/BCTX.png": 164624,
	"./stocks/BCTXW.png": 247001,
	"./stocks/BCU.png": 518121,
	"./stocks/BCX.png": 426877,
	"./stocks/BCYC.png": 286520,
	"./stocks/BCYP.png": 964994,
	"./stocks/BCYPU.png": 318904,
	"./stocks/BDJ.png": 440860,
	"./stocks/BDMD.png": 350494,
	"./stocks/BDN.png": 911366,
	"./stocks/BDR.png": 742037,
	"./stocks/BDRX.png": 142554,
	"./stocks/BDSI.png": 278926,
	"./stocks/BDSX.png": 195765,
	"./stocks/BDTX.png": 480097,
	"./stocks/BDX.png": 574569,
	"./stocks/BDXB.png": 3096,
	"./stocks/BE.png": 702577,
	"./stocks/BEAM.png": 477162,
	"./stocks/BEAT.png": 475066,
	"./stocks/BECN.png": 254854,
	"./stocks/BEDU.png": 952958,
	"./stocks/BEEM.png": 737706,
	"./stocks/BEKE.png": 810677,
	"./stocks/BELFB.png": 926427,
	"./stocks/BEN.png": 411197,
	"./stocks/BENE.png": 248611,
	"./stocks/BENF.png": 253158,
	"./stocks/BEP.png": 518583,
	"./stocks/BEPC.png": 149838,
	"./stocks/BERY.png": 175783,
	"./stocks/BFAM.png": 538361,
	"./stocks/BFH.png": 873836,
	"./stocks/BFI.png": 369407,
	"./stocks/BFIN.png": 496970,
	"./stocks/BFIT.png": 32257,
	"./stocks/BFK.png": 124722,
	"./stocks/BFLY.png": 777152,
	"./stocks/BFRG.png": 934193,
	"./stocks/BFRI.png": 95716,
	"./stocks/BFZ.png": 634033,
	"./stocks/BG.png": 424012,
	"./stocks/BGFV.png": 921797,
	"./stocks/BGIO.png": 97384,
	"./stocks/BGLC.png": 475614,
	"./stocks/BGNE.png": 579974,
	"./stocks/BGR.png": 879034,
	"./stocks/BGRY.png": 510599,
	"./stocks/BGS.png": 901355,
	"./stocks/BGSF.png": 211093,
	"./stocks/BGSX.png": 513063,
	"./stocks/BGT.png": 69249,
	"./stocks/BGXX.png": 81444,
	"./stocks/BGY.png": 955190,
	"./stocks/BHAT.png": 651241,
	"./stocks/BHB.png": 183818,
	"./stocks/BHC.png": 390408,
	"./stocks/BHE.png": 773635,
	"./stocks/BHF.png": 74411,
	"./stocks/BHFAN.png": 582455,
	"./stocks/BHFAO.png": 542535,
	"./stocks/BHFAP.png": 853493,
	"./stocks/BHG.png": 890226,
	"./stocks/BHIL.png": 785111,
	"./stocks/BHK.png": 9243,
	"./stocks/BHP.png": 554743,
	"./stocks/BHR.png": 500757,
	"./stocks/BHSE.png": 349240,
	"./stocks/BHTG.png": 78646,
	"./stocks/BHV.png": 216828,
	"./stocks/BHVN.png": 742561,
	"./stocks/BIAF.png": 149879,
	"./stocks/BIDU.png": 359793,
	"./stocks/BIG.png": 395950,
	"./stocks/BIGC.png": 949939,
	"./stocks/BIIB.png": 805856,
	"./stocks/BILI.png": 529812,
	"./stocks/BILL.png": 931181,
	"./stocks/BIMI.png": 498841,
	"./stocks/BIO.png": 338697,
	"./stocks/BIOC.png": 871123,
	"./stocks/BIOL.png": 519279,
	"./stocks/BIOR.png": 361679,
	"./stocks/BIOX.png": 379456,
	"./stocks/BIP.png": 563660,
	"./stocks/BIPC.png": 748887,
	"./stocks/BIRD.png": 287897,
	"./stocks/BIREF.png": 901552,
	"./stocks/BIRK.png": 806299,
	"./stocks/BIT.png": 13010,
	"./stocks/BITF.png": 493843,
	"./stocks/BITO.png": 262559,
	"./stocks/BITQ.png": 90973,
	"./stocks/BIVI.png": 469209,
	"./stocks/BJ.png": 98842,
	"./stocks/BJDX.png": 39463,
	"./stocks/BJRI.png": 830987,
	"./stocks/BK.png": 109110,
	"./stocks/BKCC.png": 598982,
	"./stocks/BKD.png": 351623,
	"./stocks/BKE.png": 628417,
	"./stocks/BKEP.png": 629833,
	"./stocks/BKEPP.png": 163472,
	"./stocks/BKI.png": 23813,
	"./stocks/BKKT.png": 173838,
	"./stocks/BKN.png": 44613,
	"./stocks/BKNG.png": 152111,
	"./stocks/BKR.png": 403534,
	"./stocks/BKSY.png": 496613,
	"./stocks/BKT.png": 117842,
	"./stocks/BKTI.png": 262184,
	"./stocks/BKU.png": 865451,
	"./stocks/BKYI.png": 390881,
	"./stocks/BL.png": 112068,
	"./stocks/BLBD.png": 919096,
	"./stocks/BLBX.png": 462115,
	"./stocks/BLCM.png": 729482,
	"./stocks/BLD.png": 631986,
	"./stocks/BLDE.png": 668764,
	"./stocks/BLDP.png": 868867,
	"./stocks/BLDR.png": 904449,
	"./stocks/BLE.png": 959251,
	"./stocks/BLFY.png": 28267,
	"./stocks/BLI.png": 423426,
	"./stocks/BLIN.png": 668578,
	"./stocks/BLK.png": 910691,
	"./stocks/BLKB.png": 396979,
	"./stocks/BLL.png": 99050,
	"./stocks/BLMN.png": 788185,
	"./stocks/BLMZ.png": 662152,
	"./stocks/BLNG.png": 763946,
	"./stocks/BLNK.png": 794352,
	"./stocks/BLPH.png": 351843,
	"./stocks/BLRX.png": 90981,
	"./stocks/BLU.png": 443030,
	"./stocks/BLUE.png": 950266,
	"./stocks/BLW.png": 328409,
	"./stocks/BLX.png": 260024,
	"./stocks/BMAQ.png": 250946,
	"./stocks/BMBL.png": 200028,
	"./stocks/BME.png": 684592,
	"./stocks/BMEA.png": 756899,
	"./stocks/BMI.png": 779711,
	"./stocks/BMO.png": 375255,
	"./stocks/BMR.png": 682220,
	"./stocks/BMRA.png": 623862,
	"./stocks/BMRN.png": 578289,
	"./stocks/BMT.png": 960833,
	"./stocks/BMTC.png": 399454,
	"./stocks/BMTX.png": 55808,
	"./stocks/BMY.png": 261315,
	"./stocks/BNAI.png": 382155,
	"./stocks/BNED.png": 879495,
	"./stocks/BNFT.png": 804626,
	"./stocks/BNGO.png": 842577,
	"./stocks/BNL.png": 523997,
	"./stocks/BNOX.png": 959511,
	"./stocks/BNRG.png": 450709,
	"./stocks/BNS.png": 539179,
	"./stocks/BNSO.png": 557404,
	"./stocks/BNTC.png": 310037,
	"./stocks/BNTX.png": 437517,
	"./stocks/BNY.png": 597319,
	"./stocks/BNZI.png": 352152,
	"./stocks/BOE.png": 782582,
	"./stocks/BOF.png": 999761,
	"./stocks/BOH.png": 215285,
	"./stocks/BOKF.png": 92458,
	"./stocks/BOLT.png": 496227,
	"./stocks/BON.png": 710177,
	"./stocks/BOOT.png": 654854,
	"./stocks/BORR.png": 165722,
	"./stocks/BOSC.png": 416765,
	"./stocks/BOWN.png": 918990,
	"./stocks/BOWX.png": 278595,
	"./stocks/BOWXU.png": 804948,
	"./stocks/BOX.png": 89712,
	"./stocks/BOXD.png": 363136,
	"./stocks/BOXL.png": 388189,
	"./stocks/BP.png": 648902,
	"./stocks/BPMC.png": 699247,
	"./stocks/BPMP.png": 633396,
	"./stocks/BPOP.png": 831774,
	"./stocks/BPRN.png": 497939,
	"./stocks/BPT.png": 743292,
	"./stocks/BPTH.png": 67619,
	"./stocks/BPTS.png": 896764,
	"./stocks/BPYPN.png": 250859,
	"./stocks/BPYPO.png": 386122,
	"./stocks/BPYPP.png": 251626,
	"./stocks/BQ.png": 267002,
	"./stocks/BR.png": 16879,
	"./stocks/BRAG.png": 389489,
	"./stocks/BRBR.png": 380593,
	"./stocks/BRC.png": 75242,
	"./stocks/BRCC.png": 369734,
	"./stocks/BRCN.png": 333089,
	"./stocks/BRDG.png": 200571,
	"./stocks/BRDS.png": 203649,
	"./stocks/BREA.png": 232723,
	"./stocks/BREZ.png": 345237,
	"./stocks/BRFH.png": 942292,
	"./stocks/BRFS.png": 249699,
	"./stocks/BRID.png": 65721,
	"./stocks/BRKA.png": 154190,
	"./stocks/BRKB.png": 244448,
	"./stocks/BRKR.png": 255781,
	"./stocks/BRKS.png": 335682,
	"./stocks/BRLT.png": 909714,
	"./stocks/BRMK.png": 460749,
	"./stocks/BRN.png": 836650,
	"./stocks/BRO.png": 744035,
	"./stocks/BROG.png": 209765,
	"./stocks/BROS.png": 255637,
	"./stocks/BRPM.png": 782308,
	"./stocks/BRQS.png": 912556,
	"./stocks/BRSH.png": 457807,
	"./stocks/BRSP.png": 262361,
	"./stocks/BRTX.png": 879072,
	"./stocks/BRX.png": 433377,
	"./stocks/BRY.png": 875706,
	"./stocks/BRZE.png": 495475,
	"./stocks/BSAC.png": 561413,
	"./stocks/BSBK.png": 608377,
	"./stocks/BSBR.png": 947054,
	"./stocks/BSFC.png": 874118,
	"./stocks/BSGM.png": 854252,
	"./stocks/BSLK.png": 464813,
	"./stocks/BSM.png": 880448,
	"./stocks/BSMX.png": 665390,
	"./stocks/BSMXB.png": 37250,
	"./stocks/BSN.png": 365923,
	"./stocks/BST.png": 532301,
	"./stocks/BSVN.png": 184992,
	"./stocks/BSX.png": 664851,
	"./stocks/BSY.png": 417910,
	"./stocks/BTA.png": 683341,
	"./stocks/BTAI.png": 662654,
	"./stocks/BTB.png": 585415,
	"./stocks/BTBD.png": 481147,
	"./stocks/BTBT.png": 674171,
	"./stocks/BTCM.png": 230019,
	"./stocks/BTCS.png": 825123,
	"./stocks/BTCT.png": 932893,
	"./stocks/BTCWF.png": 880385,
	"./stocks/BTCY.png": 755882,
	"./stocks/BTDR.png": 779719,
	"./stocks/BTE.png": 987974,
	"./stocks/BTF.png": 864653,
	"./stocks/BTG.png": 413511,
	"./stocks/BTGOF.png": 235105,
	"./stocks/BTI.png": 89137,
	"./stocks/BTM.png": 748294,
	"./stocks/BTMD.png": 627373,
	"./stocks/BTOG.png": 935891,
	"./stocks/BTRS.png": 428385,
	"./stocks/BTSG.png": 19571,
	"./stocks/BTT.png": 459273,
	"./stocks/BTTR.png": 722482,
	"./stocks/BTTX.png": 271173,
	"./stocks/BTU.png": 677589,
	"./stocks/BTZ.png": 677149,
	"./stocks/BUD.png": 104314,
	"./stocks/BUI.png": 244389,
	"./stocks/BUK.png": 945344,
	"./stocks/BUR.png": 566097,
	"./stocks/BURL.png": 280544,
	"./stocks/BURU.png": 522645,
	"./stocks/BURU2.png": 180511,
	"./stocks/BUSE.png": 805428,
	"./stocks/BV.png": 501053,
	"./stocks/BVH.png": 866119,
	"./stocks/BVN.png": 979183,
	"./stocks/BVS.png": 292004,
	"./stocks/BVXV.png": 250625,
	"./stocks/BW.png": 551095,
	"./stocks/BWA.png": 871816,
	"./stocks/BWAQ.png": 364886,
	"./stocks/BWAY.png": 650262,
	"./stocks/BWB.png": 880876,
	"./stocks/BWEN.png": 946937,
	"./stocks/BWIN.png": 951931,
	"./stocks/BWMN.png": 852049,
	"./stocks/BWV.png": 818079,
	"./stocks/BWXT.png": 738445,
	"./stocks/BX.png": 981262,
	"./stocks/BXC.png": 794758,
	"./stocks/BXMT.png": 615999,
	"./stocks/BXP.png": 94023,
	"./stocks/BXRX.png": 460136,
	"./stocks/BXS.png": 74197,
	"./stocks/BY.png": 696825,
	"./stocks/BYD.png": 451909,
	"./stocks/BYM.png": 774824,
	"./stocks/BYND.png": 52067,
	"./stocks/BYON.png": 159394,
	"./stocks/BYRN.png": 243806,
	"./stocks/BYSI.png": 694717,
	"./stocks/BYU.png": 784547,
	"./stocks/BZAI.png": 887976,
	"./stocks/BZFD.png": 843959,
	"./stocks/BZH.png": 422121,
	"./stocks/BZLFY.png": 889913,
	"./stocks/C.png": 24445,
	"./stocks/CAAS.png": 514791,
	"./stocks/CABA.png": 209501,
	"./stocks/CABO.png": 507921,
	"./stocks/CAC.png": 591908,
	"./stocks/CACC.png": 196874,
	"./stocks/CACI.png": 295344,
	"./stocks/CACO.png": 58623,
	"./stocks/CADE.png": 3710,
	"./stocks/CADL.png": 98952,
	"./stocks/CAE.png": 620913,
	"./stocks/CAG.png": 837243,
	"./stocks/CAH.png": 919017,
	"./stocks/CAJ.png": 403825,
	"./stocks/CAKE.png": 954842,
	"./stocks/CAL.png": 316499,
	"./stocks/CALA.png": 479561,
	"./stocks/CALM.png": 220896,
	"./stocks/CALT.png": 762864,
	"./stocks/CALX.png": 577167,
	"./stocks/CAMP.png": 533271,
	"./stocks/CAMT.png": 286435,
	"./stocks/CAN.png": 703312,
	"./stocks/CANF.png": 189934,
	"./stocks/CANG.png": 693916,
	"./stocks/CANO.png": 7645,
	"./stocks/CAPR.png": 409466,
	"./stocks/CAPS.png": 331319,
	"./stocks/CAPT.png": 227458,
	"./stocks/CAR.png": 400157,
	"./stocks/CARA.png": 162655,
	"./stocks/CARE.png": 196895,
	"./stocks/CARG.png": 849749,
	"./stocks/CARM.png": 315354,
	"./stocks/CARR.png": 136967,
	"./stocks/CARS.png": 311857,
	"./stocks/CART.png": 440253,
	"./stocks/CARV.png": 886359,
	"./stocks/CASA.png": 683369,
	"./stocks/CASH.png": 3712,
	"./stocks/CASI.png": 249410,
	"./stocks/CASS.png": 522705,
	"./stocks/CAT.png": 942479,
	"./stocks/CATC.png": 288618,
	"./stocks/CATX.png": 523892,
	"./stocks/CAUD.png": 804427,
	"./stocks/CAVA.png": 603997,
	"./stocks/CB.png": 396560,
	"./stocks/CBAN.png": 166305,
	"./stocks/CBAT.png": 846378,
	"./stocks/CBAY.png": 866385,
	"./stocks/CBH.png": 222578,
	"./stocks/CBIO.png": 525746,
	"./stocks/CBIO1.png": 562961,
	"./stocks/CBMB.png": 25763,
	"./stocks/CBNK.png": 393072,
	"./stocks/CBOE.png": 160427,
	"./stocks/CBRE.png": 990955,
	"./stocks/CBRL.png": 615560,
	"./stocks/CBSH.png": 732050,
	"./stocks/CBSTF.png": 629737,
	"./stocks/CBT.png": 177665,
	"./stocks/CBTX.png": 856405,
	"./stocks/CBZ.png": 483810,
	"./stocks/CC.png": 75247,
	"./stocks/CCBG.png": 817015,
	"./stocks/CCCC.png": 129385,
	"./stocks/CCEP.png": 599393,
	"./stocks/CCI.png": 956934,
	"./stocks/CCJ.png": 237539,
	"./stocks/CCK.png": 604117,
	"./stocks/CCL.png": 211993,
	"./stocks/CCLD.png": 330028,
	"./stocks/CCM.png": 146346,
	"./stocks/CCMP.png": 971655,
	"./stocks/CCNC.png": 70196,
	"./stocks/CCO.png": 554660,
	"./stocks/CCRN.png": 71223,
	"./stocks/CCS.png": 950444,
	"./stocks/CCTG.png": 329367,
	"./stocks/CCTS.png": 748869,
	"./stocks/CCU.png": 309667,
	"./stocks/CCXI.png": 466766,
	"./stocks/CD.png": 461386,
	"./stocks/CDAK.png": 824326,
	"./stocks/CDAY.png": 642419,
	"./stocks/CDE.png": 572021,
	"./stocks/CDEV.png": 540446,
	"./stocks/CDIO.png": 222716,
	"./stocks/CDK.png": 730721,
	"./stocks/CDLX.png": 190582,
	"./stocks/CDMO.png": 974317,
	"./stocks/CDNA.png": 148301,
	"./stocks/CDNS.png": 124957,
	"./stocks/CDR.png": 208601,
	"./stocks/CDT.png": 784517,
	"./stocks/CDTG.png": 305066,
	"./stocks/CDTX.png": 562440,
	"./stocks/CDW.png": 997087,
	"./stocks/CDXC.png": 779753,
	"./stocks/CDXS.png": 200474,
	"./stocks/CDZI.png": 54855,
	"./stocks/CDZIP.png": 829837,
	"./stocks/CE.png": 592068,
	"./stocks/CEAD.png": 472547,
	"./stocks/CECE.png": 99599,
	"./stocks/CEE.png": 567820,
	"./stocks/CEG.png": 981572,
	"./stocks/CEI.png": 11321,
	"./stocks/CEIX.png": 770486,
	"./stocks/CELC.png": 902511,
	"./stocks/CELH.png": 619944,
	"./stocks/CELP.png": 998236,
	"./stocks/CELU.png": 848081,
	"./stocks/CELV.png": 161827,
	"./stocks/CELZ.png": 528895,
	"./stocks/CEMI.png": 583942,
	"./stocks/CEN.png": 978655,
	"./stocks/CENN.png": 66549,
	"./stocks/CENT.png": 747674,
	"./stocks/CENTA.png": 502257,
	"./stocks/CEPU.png": 469145,
	"./stocks/CEQP.png": 56003,
	"./stocks/CERE.png": 587558,
	"./stocks/CERN.png": 346799,
	"./stocks/CERO.png": 487865,
	"./stocks/CERS.png": 309166,
	"./stocks/CERT.png": 220184,
	"./stocks/CETU.png": 307966,
	"./stocks/CETX.png": 104615,
	"./stocks/CETXP.png": 914213,
	"./stocks/CETY.png": 301926,
	"./stocks/CEVA.png": 531621,
	"./stocks/CF.png": 971312,
	"./stocks/CFBK.png": 780225,
	"./stocks/CFFN.png": 945622,
	"./stocks/CFG.png": 325624,
	"./stocks/CFLT.png": 532006,
	"./stocks/CFMS.png": 797015,
	"./stocks/CFR.png": 844666,
	"./stocks/CFRX.png": 198575,
	"./stocks/CFV.png": 147345,
	"./stocks/CFVI.png": 902507,
	"./stocks/CG.png": 91422,
	"./stocks/CGA.png": 503987,
	"./stocks/CGAU.png": 121813,
	"./stocks/CGBS.png": 290297,
	"./stocks/CGC.png": 504473,
	"./stocks/CGEM.png": 170298,
	"./stocks/CGEN.png": 500327,
	"./stocks/CGNT.png": 180445,
	"./stocks/CGRN.png": 656855,
	"./stocks/CGTL.png": 947151,
	"./stocks/CGTX.png": 217398,
	"./stocks/CHAA.png": 758639,
	"./stocks/CHCI.png": 992542,
	"./stocks/CHCO.png": 436073,
	"./stocks/CHD.png": 308467,
	"./stocks/CHDN.png": 282085,
	"./stocks/CHEA.png": 709297,
	"./stocks/CHEF.png": 58138,
	"./stocks/CHEK.png": 407978,
	"./stocks/CHGG.png": 893438,
	"./stocks/CHH.png": 794197,
	"./stocks/CHK.png": 97175,
	"./stocks/CHKP.png": 253289,
	"./stocks/CHMG.png": 692945,
	"./stocks/CHN.png": 353013,
	"./stocks/CHNG.png": 400892,
	"./stocks/CHNR.png": 966232,
	"./stocks/CHPM.png": 857476,
	"./stocks/CHPT.png": 904534,
	"./stocks/CHRA.png": 998114,
	"./stocks/CHRO.png": 945798,
	"./stocks/CHRS.png": 154944,
	"./stocks/CHSCL.png": 27320,
	"./stocks/CHSCM.png": 525857,
	"./stocks/CHSCN.png": 206108,
	"./stocks/CHSCO.png": 535934,
	"./stocks/CHSCP.png": 159255,
	"./stocks/CHSN.png": 429020,
	"./stocks/CHT.png": 750413,
	"./stocks/CHTR.png": 734759,
	"./stocks/CHUY.png": 572774,
	"./stocks/CHWA.png": 265906,
	"./stocks/CHWY.png": 161650,
	"./stocks/CHX.png": 268591,
	"./stocks/CI.png": 777609,
	"./stocks/CIA.png": 639867,
	"./stocks/CIB.png": 944915,
	"./stocks/CIDM.png": 388317,
	"./stocks/CIEN.png": 728742,
	"./stocks/CIF.png": 606242,
	"./stocks/CIFR.png": 664268,
	"./stocks/CIGI.png": 748223,
	"./stocks/CII.png": 810365,
	"./stocks/CIM.png": 96048,
	"./stocks/CINC.png": 764074,
	"./stocks/CINF.png": 104861,
	"./stocks/CING.png": 956957,
	"./stocks/CINR.png": 162361,
	"./stocks/CINT.png": 310091,
	"./stocks/CIO.png": 597919,
	"./stocks/CION.png": 999452,
	"./stocks/CIR.png": 26882,
	"./stocks/CISO.png": 442030,
	"./stocks/CISS.png": 247343,
	"./stocks/CIZN.png": 424803,
	"./stocks/CJET.png": 185540,
	"./stocks/CJJD.png": 88215,
	"./stocks/CKPT.png": 263049,
	"./stocks/CKX.png": 794337,
	"./stocks/CL.png": 274060,
	"./stocks/CLAQ.png": 877808,
	"./stocks/CLAY.png": 456270,
	"./stocks/CLBK.png": 880716,
	"./stocks/CLBT.png": 445538,
	"./stocks/CLCO.png": 836766,
	"./stocks/CLCS.png": 699041,
	"./stocks/CLDB.png": 774732,
	"./stocks/CLDI.png": 928253,
	"./stocks/CLDT.png": 493074,
	"./stocks/CLDX.png": 965158,
	"./stocks/CLEU.png": 957513,
	"./stocks/CLF.png": 904800,
	"./stocks/CLFD.png": 885860,
	"./stocks/CLGN.png": 202242,
	"./stocks/CLH.png": 804874,
	"./stocks/CLI.png": 456182,
	"./stocks/CLIN.png": 353370,
	"./stocks/CLIR.png": 873237,
	"./stocks/CLLS.png": 659610,
	"./stocks/CLMT.png": 422225,
	"./stocks/CLNE.png": 807938,
	"./stocks/CLOE.png": 486966,
	"./stocks/CLOV.png": 313338,
	"./stocks/CLPS.png": 54969,
	"./stocks/CLPT.png": 60612,
	"./stocks/CLR.png": 752697,
	"./stocks/CLRB.png": 921599,
	"./stocks/CLRO.png": 568784,
	"./stocks/CLS.png": 260890,
	"./stocks/CLSD.png": 533910,
	"./stocks/CLSK.png": 185202,
	"./stocks/CLSM.png": 388701,
	"./stocks/CLSN.png": 495362,
	"./stocks/CLVR.png": 432986,
	"./stocks/CLVRW.png": 830843,
	"./stocks/CLVS.png": 474683,
	"./stocks/CLVT.png": 588127,
	"./stocks/CLW.png": 806969,
	"./stocks/CLWT.png": 26497,
	"./stocks/CLX.png": 92342,
	"./stocks/CLXT.png": 692817,
	"./stocks/CM.png": 786051,
	"./stocks/CMA.png": 189447,
	"./stocks/CMAX.png": 627695,
	"./stocks/CMBM.png": 699785,
	"./stocks/CMC.png": 22395,
	"./stocks/CMCO.png": 276796,
	"./stocks/CMCSA.png": 864071,
	"./stocks/CMCT.png": 185444,
	"./stocks/CME.png": 657746,
	"./stocks/CMG.png": 631803,
	"./stocks/CMI.png": 89727,
	"./stocks/CMLS.png": 483608,
	"./stocks/CMLS2.png": 538509,
	"./stocks/CMMB.png": 695306,
	"./stocks/CMND.png": 319765,
	"./stocks/CMP.png": 215389,
	"./stocks/CMPI.png": 836610,
	"./stocks/CMPR.png": 216214,
	"./stocks/CMPS.png": 683322,
	"./stocks/CMRA.png": 128161,
	"./stocks/CMRE.png": 968283,
	"./stocks/CMRX.png": 964403,
	"./stocks/CMS.png": 298262,
	"./stocks/CMTL.png": 356649,
	"./stocks/CMU.png": 713737,
	"./stocks/CNA.png": 582215,
	"./stocks/CNBKA.png": 456614,
	"./stocks/CNC.png": 545811,
	"./stocks/CNCE.png": 279661,
	"./stocks/CNET.png": 804773,
	"./stocks/CNEY.png": 366074,
	"./stocks/CNFR.png": 63314,
	"./stocks/CNI.png": 347773,
	"./stocks/CNK.png": 744574,
	"./stocks/CNM.png": 693554,
	"./stocks/CNMD.png": 3062,
	"./stocks/CNNB.png": 101272,
	"./stocks/CNO.png": 206522,
	"./stocks/CNOB.png": 234714,
	"./stocks/CNOBP.png": 740469,
	"./stocks/CNOOC.png": 231860,
	"./stocks/CNR.png": 835051,
	"./stocks/CNSL.png": 418740,
	"./stocks/CNSP.png": 867110,
	"./stocks/CNTA.png": 761547,
	"./stocks/CNTB.png": 719789,
	"./stocks/CNTG.png": 618814,
	"./stocks/CNTX.png": 340158,
	"./stocks/CNTY.png": 683609,
	"./stocks/CNVY.png": 925811,
	"./stocks/CNX.png": 362987,
	"./stocks/CNXA.png": 195324,
	"./stocks/CNXC.png": 362654,
	"./stocks/CO.png": 288700,
	"./stocks/COCO.png": 948234,
	"./stocks/COCP.png": 90414,
	"./stocks/CODX.png": 637099,
	"./stocks/COE.png": 493597,
	"./stocks/COEP.png": 501634,
	"./stocks/COF.png": 950827,
	"./stocks/COFS.png": 697411,
	"./stocks/COG.png": 211355,
	"./stocks/COHR.png": 647023,
	"./stocks/COHU.png": 146980,
	"./stocks/COIN.png": 980127,
	"./stocks/COKE.png": 10577,
	"./stocks/COLB.png": 550289,
	"./stocks/COLD.png": 915985,
	"./stocks/COMM.png": 83527,
	"./stocks/COMP.png": 920216,
	"./stocks/COMS.png": 669482,
	"./stocks/CONE.png": 660525,
	"./stocks/CONN.png": 604364,
	"./stocks/COOK.png": 718656,
	"./stocks/COOL.png": 842194,
	"./stocks/COOLU.png": 435071,
	"./stocks/COOP.png": 48701,
	"./stocks/COOT.png": 647160,
	"./stocks/COP.png": 232764,
	"./stocks/COR.png": 192587,
	"./stocks/CORN.png": 680566,
	"./stocks/CORR.png": 42674,
	"./stocks/CORT.png": 451115,
	"./stocks/CORZ.png": 947552,
	"./stocks/COSM.png": 295737,
	"./stocks/COST.png": 277169,
	"./stocks/COTY.png": 302141,
	"./stocks/COUP.png": 737753,
	"./stocks/COUR.png": 179082,
	"./stocks/COVA.png": 943547,
	"./stocks/COVAU.png": 474185,
	"./stocks/COWN.png": 100866,
	"./stocks/COYA.png": 836274,
	"./stocks/CP.png": 244331,
	"./stocks/CPA.png": 856943,
	"./stocks/CPB.png": 897486,
	"./stocks/CPE.png": 704433,
	"./stocks/CPF.png": 64135,
	"./stocks/CPFE.png": 322194,
	"./stocks/CPG.png": 957721,
	"./stocks/CPHC.png": 748552,
	"./stocks/CPHI.png": 72776,
	"./stocks/CPIX.png": 589206,
	"./stocks/CPLP.png": 138670,
	"./stocks/CPNG.png": 491467,
	"./stocks/CPOP.png": 390244,
	"./stocks/CPRT.png": 563566,
	"./stocks/CPRX.png": 445455,
	"./stocks/CPS.png": 857103,
	"./stocks/CPSH.png": 444138,
	"./stocks/CPSI.png": 170243,
	"./stocks/CPSR.png": 229357,
	"./stocks/CPSS.png": 711567,
	"./stocks/CPT.png": 455199,
	"./stocks/CPTK.png": 375121,
	"./stocks/CPTN.png": 20894,
	"./stocks/CQP.png": 845116,
	"./stocks/CR.png": 149505,
	"./stocks/CRAI.png": 358844,
	"./stocks/CRBP.png": 420401,
	"./stocks/CRBU.png": 152516,
	"./stocks/CRCT.png": 904325,
	"./stocks/CRDF.png": 209772,
	"./stocks/CRDO.png": 398715,
	"./stocks/CREG.png": 575841,
	"./stocks/CRESY.png": 603486,
	"./stocks/CREV.png": 487164,
	"./stocks/CREX.png": 362312,
	"./stocks/CRGE.png": 150063,
	"./stocks/CRH.png": 484451,
	"./stocks/CRI.png": 857723,
	"./stocks/CRIS.png": 337042,
	"./stocks/CRKN.png": 683475,
	"./stocks/CRM.png": 188139,
	"./stocks/CRMD.png": 277834,
	"./stocks/CRMT.png": 413235,
	"./stocks/CRN.png": 255810,
	"./stocks/CRNC.png": 888781,
	"./stocks/CRNT.png": 31605,
	"./stocks/CRNX.png": 378634,
	"./stocks/CRON.png": 283036,
	"./stocks/CROX.png": 857531,
	"./stocks/CRS.png": 512445,
	"./stocks/CRSP.png": 182627,
	"./stocks/CRSR.png": 51293,
	"./stocks/CRT.png": 321371,
	"./stocks/CRTD.png": 657536,
	"./stocks/CRTO.png": 81517,
	"./stocks/CRTX.png": 147598,
	"./stocks/CRUS.png": 87397,
	"./stocks/CRVL.png": 486074,
	"./stocks/CRVO.png": 362638,
	"./stocks/CRVS.png": 145085,
	"./stocks/CRWD.png": 72856,
	"./stocks/CRWS.png": 466106,
	"./stocks/CRXT.png": 84302,
	"./stocks/CRXTW.png": 170212,
	"./stocks/CRY.png": 453975,
	"./stocks/CS.png": 138458,
	"./stocks/CSAI.png": 289537,
	"./stocks/CSAN.png": 768711,
	"./stocks/CSBR.png": 123007,
	"./stocks/CSCCF.png": 78896,
	"./stocks/CSCO.png": 501844,
	"./stocks/CSCW.png": 384759,
	"./stocks/CSFB.png": 10252,
	"./stocks/CSGP.png": 494195,
	"./stocks/CSGS.png": 558320,
	"./stocks/CSII.png": 811053,
	"./stocks/CSIQ.png": 785044,
	"./stocks/CSL.png": 765406,
	"./stocks/CSLR.png": 141894,
	"./stocks/CSLT.png": 302281,
	"./stocks/CSOD.png": 556883,
	"./stocks/CSPI.png": 581974,
	"./stocks/CSPR.png": 774938,
	"./stocks/CSR.png": 294347,
	"./stocks/CSSE.png": 472369,
	"./stocks/CSSE3.png": 729701,
	"./stocks/CSSEP.png": 547304,
	"./stocks/CSTA.png": 702632,
	"./stocks/CSTE.png": 235839,
	"./stocks/CSTL.png": 821084,
	"./stocks/CSTM.png": 929620,
	"./stocks/CSU.png": 684338,
	"./stocks/CSUI.png": 723182,
	"./stocks/CSWI.png": 207853,
	"./stocks/CSX.png": 659746,
	"./stocks/CTA-A.png": 513849,
	"./stocks/CTAS.png": 922638,
	"./stocks/CTCX.png": 360601,
	"./stocks/CTEK.png": 606402,
	"./stocks/CTG.png": 806550,
	"./stocks/CTGO.png": 209368,
	"./stocks/CTHR.png": 526536,
	"./stocks/CTIB.png": 635230,
	"./stocks/CTIC.png": 761851,
	"./stocks/CTK.png": 573616,
	"./stocks/CTLP.png": 721284,
	"./stocks/CTLT.png": 813813,
	"./stocks/CTM.png": 256949,
	"./stocks/CTMX.png": 933419,
	"./stocks/CTNT.png": 682492,
	"./stocks/CTO.png": 936306,
	"./stocks/CTOR.png": 532989,
	"./stocks/CTOS.png": 813943,
	"./stocks/CTRA.png": 447279,
	"./stocks/CTRE.png": 330553,
	"./stocks/CTRM.png": 806842,
	"./stocks/CTRN.png": 118430,
	"./stocks/CTSH.png": 602520,
	"./stocks/CTSO.png": 141414,
	"./stocks/CTT.png": 646138,
	"./stocks/CTVA.png": 696510,
	"./stocks/CTXR.png": 719557,
	"./stocks/CTXS.png": 235291,
	"./stocks/CUBE.png": 329877,
	"./stocks/CUBI.png": 505091,
	"./stocks/CUE.png": 526958,
	"./stocks/CUEN.png": 739668,
	"./stocks/CUK.png": 605206,
	"./stocks/CULP.png": 189771,
	"./stocks/CURI.png": 360361,
	"./stocks/CURLF.png": 707311,
	"./stocks/CURO.png": 186760,
	"./stocks/CURR.png": 714976,
	"./stocks/CURV.png": 515192,
	"./stocks/CUZ.png": 750892,
	"./stocks/CVA.png": 415550,
	"./stocks/CVAC.png": 178336,
	"./stocks/CVBF.png": 825337,
	"./stocks/CVCO.png": 885806,
	"./stocks/CVCY.png": 979262,
	"./stocks/CVE.png": 340846,
	"./stocks/CVEO.png": 472958,
	"./stocks/CVET.png": 17273,
	"./stocks/CVGI.png": 402812,
	"./stocks/CVGW.png": 728660,
	"./stocks/CVI.png": 160838,
	"./stocks/CVLG.png": 963190,
	"./stocks/CVLT.png": 915872,
	"./stocks/CVLY.png": 64308,
	"./stocks/CVM.png": 677811,
	"./stocks/CVNA.png": 386060,
	"./stocks/CVRX.png": 819722,
	"./stocks/CVS.png": 788968,
	"./stocks/CVT.png": 341363,
	"./stocks/CVU.png": 529436,
	"./stocks/CVV.png": 773487,
	"./stocks/CVX.png": 273093,
	"./stocks/CWAN.png": 846318,
	"./stocks/CWBR.png": 289569,
	"./stocks/CWEN.png": 163403,
	"./stocks/CWH.png": 842713,
	"./stocks/CWK.png": 682023,
	"./stocks/CWST.png": 132216,
	"./stocks/CX.png": 523831,
	"./stocks/CXAI.png": 454871,
	"./stocks/CXDO.png": 588916,
	"./stocks/CXE.png": 247489,
	"./stocks/CXH.png": 588100,
	"./stocks/CXM.png": 359023,
	"./stocks/CXP.png": 385688,
	"./stocks/CXW.png": 672944,
	"./stocks/CYAD.png": 926602,
	"./stocks/CYAN.png": 314868,
	"./stocks/CYBN.png": 908841,
	"./stocks/CYBR.png": 533558,
	"./stocks/CYCC.png": 650815,
	"./stocks/CYCN.png": 691745,
	"./stocks/CYCU.png": 74811,
	"./stocks/CYH.png": 502065,
	"./stocks/CYMB.png": 202579,
	"./stocks/CYN.png": 631730,
	"./stocks/CYRN.png": 665505,
	"./stocks/CYRX.png": 836703,
	"./stocks/CYT.png": 380979,
	"./stocks/CYTH.png": 375022,
	"./stocks/CYTO.png": 216004,
	"./stocks/CYXT.png": 41477,
	"./stocks/CZOO.png": 414906,
	"./stocks/CZR.png": 95849,
	"./stocks/CZWI.png": 673289,
	"./stocks/D.png": 491370,
	"./stocks/DAC.png": 390576,
	"./stocks/DADA.png": 732171,
	"./stocks/DAIO.png": 311781,
	"./stocks/DAKT.png": 902913,
	"./stocks/DAL.png": 617687,
	"./stocks/DAN.png": 188763,
	"./stocks/DAO.png": 880987,
	"./stocks/DAR.png": 139918,
	"./stocks/DARE.png": 623599,
	"./stocks/DASH.png": 927264,
	"./stocks/DATS.png": 906950,
	"./stocks/DAVA.png": 575522,
	"./stocks/DAVE.png": 899328,
	"./stocks/DAWN.png": 362263,
	"./stocks/DAX.png": 750751,
	"./stocks/DB.png": 870281,
	"./stocks/DBD.png": 177671,
	"./stocks/DBDR.png": 14673,
	"./stocks/DBGI.png": 914813,
	"./stocks/DBI.png": 149559,
	"./stocks/DBTX.png": 254057,
	"./stocks/DBVT.png": 124235,
	"./stocks/DBX.png": 669274,
	"./stocks/DCBO.png": 255376,
	"./stocks/DCFC.png": 631220,
	"./stocks/DCFCW.png": 13776,
	"./stocks/DCGO.png": 162000,
	"./stocks/DCOM.png": 173559,
	"./stocks/DCOMP.png": 862662,
	"./stocks/DCP.png": 764423,
	"./stocks/DCPH.png": 267353,
	"./stocks/DCRD.png": 699630,
	"./stocks/DCT.png": 578623,
	"./stocks/DCTH.png": 121259,
	"./stocks/DD.png": 721569,
	"./stocks/DDC.png": 752842,
	"./stocks/DDD.png": 798117,
	"./stocks/DDL.png": 536991,
	"./stocks/DDOG.png": 544306,
	"./stocks/DDS.png": 539392,
	"./stocks/DE.png": 609240,
	"./stocks/DEA2.png": 442054,
	"./stocks/DECK.png": 646827,
	"./stocks/DEFTF.png": 187818,
	"./stocks/DEI.png": 611066,
	"./stocks/DELL.png": 67860,
	"./stocks/DENN.png": 793600,
	"./stocks/DEO.png": 352393,
	"./stocks/DERM.png": 657937,
	"./stocks/DESP.png": 725677,
	"./stocks/DEVS.png": 855178,
	"./stocks/DFFN.png": 79264,
	"./stocks/DFH.png": 420929,
	"./stocks/DFORF.png": 823415,
	"./stocks/DFP.png": 241226,
	"./stocks/DFS.png": 458596,
	"./stocks/DG.png": 9413,
	"./stocks/DGICA.png": 470321,
	"./stocks/DGICB.png": 954537,
	"./stocks/DGII.png": 379872,
	"./stocks/DGLY.png": 752581,
	"./stocks/DGNX.png": 234949,
	"./stocks/DGX.png": 367447,
	"./stocks/DHAC.png": 66127,
	"./stocks/DHAI.png": 344354,
	"./stocks/DHC.png": 702031,
	"./stocks/DHHC.png": 614801,
	"./stocks/DHI.png": 227044,
	"./stocks/DHIL.png": 557237,
	"./stocks/DHR.png": 308521,
	"./stocks/DHT.png": 882506,
	"./stocks/DHX.png": 522820,
	"./stocks/DIBS.png": 659649,
	"./stocks/DICE.png": 398764,
	"./stocks/DIDI.png": 725965,
	"./stocks/DILA.png": 650094,
	"./stocks/DIN.png": 375519,
	"./stocks/DINO.png": 179121,
	"./stocks/DIOD.png": 611054,
	"./stocks/DIP.png": 996260,
	"./stocks/DIS.png": 168069,
	"./stocks/DISCA.png": 752698,
	"./stocks/DISCB.png": 18452,
	"./stocks/DISCK.png": 297980,
	"./stocks/DISH.png": 162051,
	"./stocks/DJI.png": 562389,
	"./stocks/DJT.png": 661999,
	"./stocks/DK.png": 894815,
	"./stocks/DKL.png": 929529,
	"./stocks/DKNG.png": 895018,
	"./stocks/DKS.png": 112970,
	"./stocks/DLA.png": 732203,
	"./stocks/DLB.png": 602053,
	"./stocks/DLHC.png": 731427,
	"./stocks/DLNG.png": 520932,
	"./stocks/DLO.png": 430442,
	"./stocks/DLPN.png": 90014,
	"./stocks/DLR.png": 980946,
	"./stocks/DLTH.png": 724723,
	"./stocks/DLTR.png": 659468,
	"./stocks/DLX.png": 698846,
	"./stocks/DM.png": 562766,
	"./stocks/DMN.png": 845877,
	"./stocks/DMRC.png": 183591,
	"./stocks/DMS.png": 505411,
	"./stocks/DMTK.png": 611336,
	"./stocks/DMYQ.png": 486514,
	"./stocks/DNA.png": 444521,
	"./stocks/DNAY.png": 207342,
	"./stocks/DNB.png": 363783,
	"./stocks/DNMR.png": 762783,
	"./stocks/DNN.png": 331626,
	"./stocks/DNOW.png": 18584,
	"./stocks/DNP.png": 266251,
	"./stocks/DNUT.png": 551309,
	"./stocks/DOC.png": 177749,
	"./stocks/DOCN.png": 221926,
	"./stocks/DOCS.png": 872446,
	"./stocks/DOCU.png": 799930,
	"./stocks/DOGZ.png": 782763,
	"./stocks/DOLE.png": 883682,
	"./stocks/DOMH.png": 797955,
	"./stocks/DOMO.png": 240466,
	"./stocks/DOOO.png": 996990,
	"./stocks/DOOR.png": 517102,
	"./stocks/DORM.png": 595026,
	"./stocks/DOUG.png": 164065,
	"./stocks/DOV.png": 209839,
	"./stocks/DOW.png": 50469,
	"./stocks/DOYU.png": 885934,
	"./stocks/DPG.png": 452460,
	"./stocks/DPRO.png": 848447,
	"./stocks/DPSI.png": 367022,
	"./stocks/DPZ.png": 607974,
	"./stocks/DRCT.png": 546156,
	"./stocks/DRD.png": 979817,
	"./stocks/DRE.png": 372796,
	"./stocks/DRI.png": 152600,
	"./stocks/DRMA.png": 630260,
	"./stocks/DRNA.png": 340715,
	"./stocks/DRQ.png": 300534,
	"./stocks/DRRX.png": 436265,
	"./stocks/DRTT.png": 672506,
	"./stocks/DRUG.png": 937378,
	"./stocks/DRVN.png": 327453,
	"./stocks/DS.png": 708988,
	"./stocks/DSAC.png": 985879,
	"./stocks/DSGX.png": 489561,
	"./stocks/DSKE.png": 318530,
	"./stocks/DSL.png": 520757,
	"./stocks/DSM.png": 159521,
	"./stocks/DSP.png": 434525,
	"./stocks/DSPG.png": 156596,
	"./stocks/DSS.png": 292793,
	"./stocks/DSU.png": 418351,
	"./stocks/DSX.png": 440939,
	"./stocks/DSY.png": 430592,
	"./stocks/DT.png": 36158,
	"./stocks/DTC.png": 411984,
	"./stocks/DTCK.png": 583791,
	"./stocks/DTE.png": 480107,
	"./stocks/DTEA.png": 28890,
	"./stocks/DTF.png": 859317,
	"./stocks/DTIL.png": 199926,
	"./stocks/DTOC.png": 261263,
	"./stocks/DTSS.png": 658802,
	"./stocks/DTST.png": 303484,
	"./stocks/DUK.png": 87325,
	"./stocks/DUO.png": 595339,
	"./stocks/DUOL.png": 179817,
	"./stocks/DUOT.png": 709197,
	"./stocks/DV.png": 228128,
	"./stocks/DVA.png": 752920,
	"./stocks/DVAX.png": 900332,
	"./stocks/DVD.png": 313554,
	"./stocks/DVN.png": 830794,
	"./stocks/DWAC.png": 418353,
	"./stocks/DWACW.png": 875955,
	"./stocks/DWTX.png": 193743,
	"./stocks/DXC.png": 203728,
	"./stocks/DXCM.png": 526234,
	"./stocks/DXF.png": 739235,
	"./stocks/DXLG.png": 777320,
	"./stocks/DXYZ.png": 749464,
	"./stocks/DY.png": 823260,
	"./stocks/DYAI.png": 568783,
	"./stocks/DYN.png": 737973,
	"./stocks/DYNT.png": 551419,
	"./stocks/E.png": 988010,
	"./stocks/EA.png": 766492,
	"./stocks/EAF.png": 873308,
	"./stocks/EAR.png": 922585,
	"./stocks/EAST.png": 102321,
	"./stocks/EAT.png": 856966,
	"./stocks/EB.png": 579266,
	"./stocks/EBAC.png": 20633,
	"./stocks/EBAY.png": 190197,
	"./stocks/EBC.png": 369583,
	"./stocks/EBET.png": 608850,
	"./stocks/EBF.png": 169390,
	"./stocks/EBIX.png": 392567,
	"./stocks/EBMT.png": 460139,
	"./stocks/EBON.png": 805433,
	"./stocks/EBR.png": 197782,
	"./stocks/EBS.png": 710847,
	"./stocks/EBTC.png": 721604,
	"./stocks/EC.png": 920376,
	"./stocks/ECBK.png": 101658,
	"./stocks/ECHO.png": 804442,
	"./stocks/ECL.png": 103091,
	"./stocks/ECOL.png": 947746,
	"./stocks/ECOM.png": 125651,
	"./stocks/ECOR.png": 28353,
	"./stocks/ECPG.png": 82222,
	"./stocks/ECX.png": 834996,
	"./stocks/ED.png": 756195,
	"./stocks/EDAP.png": 797295,
	"./stocks/EDBL.png": 148256,
	"./stocks/EDF.png": 471597,
	"./stocks/EDIT.png": 185190,
	"./stocks/EDN.png": 463935,
	"./stocks/EDRY.png": 709319,
	"./stocks/EDSA.png": 934251,
	"./stocks/EDTX.png": 207177,
	"./stocks/EDU.png": 666480,
	"./stocks/EDUC.png": 692420,
	"./stocks/EEA.png": 934809,
	"./stocks/EEFT.png": 958465,
	"./stocks/EEIQ.png": 640026,
	"./stocks/EEX.png": 59150,
	"./stocks/EFOI.png": 886738,
	"./stocks/EFSC.png": 334320,
	"./stocks/EFSH.png": 819744,
	"./stocks/EFTR.png": 443207,
	"./stocks/EFX.png": 936420,
	"./stocks/EGAN.png": 952794,
	"./stocks/EGBN.png": 191119,
	"./stocks/EGHT.png": 18130,
	"./stocks/EGIO.png": 983435,
	"./stocks/EGLE.png": 414044,
	"./stocks/EGLX.png": 761038,
	"./stocks/EGO.png": 716890,
	"./stocks/EGOX.png": 23532,
	"./stocks/EGP.png": 578956,
	"./stocks/EGY.png": 673095,
	"./stocks/EH.png": 101474,
	"./stocks/EHAB.png": 290804,
	"./stocks/EHC.png": 692100,
	"./stocks/EHLDV.png": 197255,
	"./stocks/EHTH.png": 389593,
	"./stocks/EIG.png": 433579,
	"./stocks/EIGR.png": 855073,
	"./stocks/EIX.png": 388485,
	"./stocks/EJH.png": 265608,
	"./stocks/EKSO.png": 993199,
	"./stocks/EL.png": 24079,
	"./stocks/ELA.png": 685795,
	"./stocks/ELAB.png": 319232,
	"./stocks/ELAN.png": 895944,
	"./stocks/ELBM.png": 783205,
	"./stocks/ELDN.png": 521186,
	"./stocks/ELET.png": 50019,
	"./stocks/ELEV.png": 118558,
	"./stocks/ELF.png": 419144,
	"./stocks/ELIQ.png": 124185,
	"./stocks/ELMD.png": 212870,
	"./stocks/ELMS.png": 499130,
	"./stocks/ELOX.png": 721824,
	"./stocks/ELP.png": 805346,
	"./stocks/ELPC.png": 44259,
	"./stocks/ELS.png": 789072,
	"./stocks/ELSE.png": 422402,
	"./stocks/ELTK.png": 448006,
	"./stocks/ELV.png": 980795,
	"./stocks/ELVT.png": 116664,
	"./stocks/ELWS.png": 446363,
	"./stocks/ELYM.png": 941279,
	"./stocks/ELYS.png": 423960,
	"./stocks/EM.png": 786549,
	"./stocks/EMBK.png": 887745,
	"./stocks/EME.png": 217666,
	"./stocks/EMKR.png": 621457,
	"./stocks/EMN.png": 497955,
	"./stocks/EMR.png": 223740,
	"./stocks/ENB.png": 994701,
	"./stocks/ENBL.png": 421680,
	"./stocks/ENDP.png": 274355,
	"./stocks/ENFN.png": 740104,
	"./stocks/ENG.png": 632206,
	"./stocks/ENIC.png": 380255,
	"./stocks/ENJ.png": 352522,
	"./stocks/ENJY.png": 242745,
	"./stocks/ENLC.png": 794211,
	"./stocks/ENLV.png": 829354,
	"./stocks/ENOB.png": 31660,
	"./stocks/ENPH.png": 92207,
	"./stocks/ENR.png": 717642,
	"./stocks/ENS.png": 458385,
	"./stocks/ENSC.png": 826966,
	"./stocks/ENSG.png": 752510,
	"./stocks/ENSV.png": 656631,
	"./stocks/ENTA.png": 554298,
	"./stocks/ENTG.png": 351659,
	"./stocks/ENTO.png": 202947,
	"./stocks/ENV.png": 444669,
	"./stocks/ENVA.png": 936504,
	"./stocks/ENVB.png": 170313,
	"./stocks/ENVX.png": 460780,
	"./stocks/ENZ.png": 970257,
	"./stocks/EOG.png": 691772,
	"./stocks/EOLS.png": 806548,
	"./stocks/EONR.png": 939554,
	"./stocks/EOSE.png": 451497,
	"./stocks/EP.png": 333626,
	"./stocks/EPAC.png": 316077,
	"./stocks/EPAM.png": 483326,
	"./stocks/EPD.png": 734598,
	"./stocks/EPHY.png": 396787,
	"./stocks/EPHYU.png": 618455,
	"./stocks/EPIX.png": 213023,
	"./stocks/EPM.png": 157677,
	"./stocks/EPOW.png": 779235,
	"./stocks/EPR.png": 190078,
	"./stocks/EPRT.png": 962676,
	"./stocks/EPRX.png": 108034,
	"./stocks/EPWR.png": 231021,
	"./stocks/EPZM.png": 720131,
	"./stocks/EQ.png": 182180,
	"./stocks/EQBK.png": 599267,
	"./stocks/EQC.png": 766851,
	"./stocks/EQH.png": 680584,
	"./stocks/EQIX.png": 722499,
	"./stocks/EQNR.png": 25939,
	"./stocks/EQOS.png": 21763,
	"./stocks/EQR.png": 788324,
	"./stocks/EQT.png": 266834,
	"./stocks/EQZ.png": 469972,
	"./stocks/ERDCF.png": 216560,
	"./stocks/ERF.png": 602683,
	"./stocks/ERIC.png": 964056,
	"./stocks/ERIE.png": 804618,
	"./stocks/ERII.png": 987476,
	"./stocks/ERJ.png": 935404,
	"./stocks/ERNA.png": 549881,
	"./stocks/ERO.png": 863835,
	"./stocks/ERYP.png": 798834,
	"./stocks/ES.png": 955877,
	"./stocks/ESAB.png": 941188,
	"./stocks/ESE.png": 131259,
	"./stocks/ESGC.png": 214472,
	"./stocks/ESGL.png": 893166,
	"./stocks/ESLT.png": 190390,
	"./stocks/ESMT.png": 863045,
	"./stocks/ESOA.png": 135703,
	"./stocks/ESPR.png": 116862,
	"./stocks/ESQ.png": 665124,
	"./stocks/ESS.png": 228781,
	"./stocks/ESSA.png": 744237,
	"./stocks/ESTC.png": 706021,
	"./stocks/ESTE.png": 941308,
	"./stocks/ET.png": 572404,
	"./stocks/ETAO.png": 610064,
	"./stocks/ETB.png": 842786,
	"./stocks/ETCG.png": 465525,
	"./stocks/ETG.png": 670137,
	"./stocks/ETJ.png": 703848,
	"./stocks/ETN.png": 956736,
	"./stocks/ETNB.png": 131255,
	"./stocks/ETON.png": 929722,
	"./stocks/ETR.png": 649323,
	"./stocks/ETRN.png": 431521,
	"./stocks/ETSY.png": 776907,
	"./stocks/ETTX.png": 430415,
	"./stocks/ETWO.png": 870576,
	"./stocks/EU.png": 963506,
	"./stocks/EUDA.png": 621377,
	"./stocks/EVA.png": 204933,
	"./stocks/EVAX.png": 712741,
	"./stocks/EVER.png": 786056,
	"./stocks/EVFM.png": 455685,
	"./stocks/EVGN.png": 478775,
	"./stocks/EVGO.png": 42393,
	"./stocks/EVH.png": 817660,
	"./stocks/EVLO.png": 781692,
	"./stocks/EVLV.png": 771941,
	"./stocks/EVLVW.png": 42932,
	"./stocks/EVOK.png": 815309,
	"./stocks/EVOL.png": 730760,
	"./stocks/EVOP.png": 927069,
	"./stocks/EVRI.png": 955150,
	"./stocks/EVTC.png": 341585,
	"./stocks/EVTL.png": 431898,
	"./stocks/EW.png": 301172,
	"./stocks/EWBC.png": 118853,
	"./stocks/EWCZ.png": 631717,
	"./stocks/EWTX.png": 998014,
	"./stocks/EXAS.png": 257874,
	"./stocks/EXC.png": 213455,
	"./stocks/EXE.png": 718647,
	"./stocks/EXEL.png": 299877,
	"./stocks/EXK.png": 432404,
	"./stocks/EXLS.png": 65108,
	"./stocks/EXN.png": 243939,
	"./stocks/EXP.png": 50362,
	"./stocks/EXPD.png": 195460,
	"./stocks/EXPE.png": 826923,
	"./stocks/EXPI.png": 509000,
	"./stocks/EXPR.png": 327368,
	"./stocks/EXR.png": 73418,
	"./stocks/EXTN.png": 8011,
	"./stocks/EXTR.png": 940680,
	"./stocks/EYE.png": 851025,
	"./stocks/EYEG.png": 100153,
	"./stocks/EYEN.png": 909078,
	"./stocks/EYES.png": 80904,
	"./stocks/EYPT.png": 554695,
	"./stocks/EZFL.png": 559757,
	"./stocks/EZFL2.png": 109394,
	"./stocks/EZGO.png": 988682,
	"./stocks/EZPW.png": 303661,
	"./stocks/F.png": 992459,
	"./stocks/FA.png": 882307,
	"./stocks/FAAS.png": 371501,
	"./stocks/FACT.png": 359667,
	"./stocks/FAF.png": 723491,
	"./stocks/FAM.png": 501440,
	"./stocks/FAMI.png": 527058,
	"./stocks/FANG.png": 185014,
	"./stocks/FANH.png": 708681,
	"./stocks/FARM.png": 914947,
	"./stocks/FARO.png": 319826,
	"./stocks/FAST.png": 812663,
	"./stocks/FAT.png": 652136,
	"./stocks/FATBP.png": 515118,
	"./stocks/FATH.png": 763273,
	"./stocks/FAZE.png": 626632,
	"./stocks/FB.png": 53459,
	"./stocks/FBGL.png": 26248,
	"./stocks/FBHS.png": 873022,
	"./stocks/FBIN.png": 699860,
	"./stocks/FBIO.png": 538001,
	"./stocks/FBIOP.png": 232555,
	"./stocks/FBIZ.png": 715911,
	"./stocks/FBK.png": 598487,
	"./stocks/FBMS.png": 644142,
	"./stocks/FBNC.png": 465901,
	"./stocks/FBRX.png": 886554,
	"./stocks/FC.png": 608678,
	"./stocks/FCAP.png": 212114,
	"./stocks/FCEL.png": 700272,
	"./stocks/FCF.png": 609406,
	"./stocks/FCN.png": 304934,
	"./stocks/FCNCA.png": 126688,
	"./stocks/FCNCP.png": 717586,
	"./stocks/FCT.png": 54534,
	"./stocks/FCUV.png": 786193,
	"./stocks/FCX.png": 448954,
	"./stocks/FDBC.png": 68736,
	"./stocks/FDEU.png": 923107,
	"./stocks/FDP.png": 932898,
	"./stocks/FDS.png": 822889,
	"./stocks/FDX.png": 601126,
	"./stocks/FE.png": 903887,
	"./stocks/FEAM.png": 476827,
	"./stocks/FEI.png": 680863,
	"./stocks/FEIM.png": 75734,
	"./stocks/FELE.png": 749384,
	"./stocks/FEMY.png": 144235,
	"./stocks/FENG.png": 984265,
	"./stocks/FEO.png": 33087,
	"./stocks/FERG.png": 80095,
	"./stocks/FET.png": 682063,
	"./stocks/FEXD.png": 477265,
	"./stocks/FF.png": 235886,
	"./stocks/FFA.png": 471303,
	"./stocks/FFBC.png": 744949,
	"./stocks/FFBW.png": 242501,
	"./stocks/FFC.png": 678022,
	"./stocks/FFIE.png": 131498,
	"./stocks/FFIV.png": 65955,
	"./stocks/FFNW.png": 836916,
	"./stocks/FFWM.png": 887370,
	"./stocks/FGB.png": 321995,
	"./stocks/FGBI.png": 445929,
	"./stocks/FGEN.png": 611114,
	"./stocks/FGF.png": 32749,
	"./stocks/FGFPP.png": 807432,
	"./stocks/FGI.png": 38870,
	"./stocks/FGL.png": 923399,
	"./stocks/FHB.png": 104745,
	"./stocks/FHI.png": 980773,
	"./stocks/FHN.png": 271827,
	"./stocks/FHS.png": 550570,
	"./stocks/FHTX.png": 387853,
	"./stocks/FI.png": 614920,
	"./stocks/FIAC.png": 359278,
	"./stocks/FICO.png": 590191,
	"./stocks/FIF.png": 767406,
	"./stocks/FINS.png": 122718,
	"./stocks/FINV.png": 16467,
	"./stocks/FIS.png": 152297,
	"./stocks/FISV.png": 936242,
	"./stocks/FITB.png": 750521,
	"./stocks/FITBI.png": 959947,
	"./stocks/FITBO.png": 338949,
	"./stocks/FITBP.png": 960924,
	"./stocks/FIV.png": 78609,
	"./stocks/FIVE.png": 925829,
	"./stocks/FIVN.png": 681244,
	"./stocks/FIX.png": 815731,
	"./stocks/FIXX.png": 689611,
	"./stocks/FIZZ.png": 725927,
	"./stocks/FKWL.png": 565317,
	"./stocks/FL.png": 330411,
	"./stocks/FLAC.png": 985115,
	"./stocks/FLAG.png": 637854,
	"./stocks/FLC.png": 211270,
	"./stocks/FLD.png": 371415,
	"./stocks/FLDM.png": 959280,
	"./stocks/FLEX.png": 498448,
	"./stocks/FLGC.png": 629582,
	"./stocks/FLGT.png": 788417,
	"./stocks/FLIC.png": 330117,
	"./stocks/FLJ.png": 752779,
	"./stocks/FLL.png": 426345,
	"./stocks/FLME.png": 633026,
	"./stocks/FLNC.png": 332658,
	"./stocks/FLNG.png": 465457,
	"./stocks/FLNT.png": 766570,
	"./stocks/FLO.png": 677078,
	"./stocks/FLOC.png": 445625,
	"./stocks/FLR.png": 124766,
	"./stocks/FLT.png": 503593,
	"./stocks/FLUX.png": 550040,
	"./stocks/FLWS.png": 111294,
	"./stocks/FLXN.png": 125613,
	"./stocks/FLXS.png": 781872,
	"./stocks/FLYE.png": 237222,
	"./stocks/FLYW.png": 647922,
	"./stocks/FLYX.png": 193958,
	"./stocks/FMAC.png": 250539,
	"./stocks/FMAO.png": 634747,
	"./stocks/FMBH.png": 136831,
	"./stocks/FMBI.png": 901930,
	"./stocks/FMBIO.png": 592348,
	"./stocks/FMBIP.png": 395687,
	"./stocks/FMC.png": 805355,
	"./stocks/FMN.png": 876448,
	"./stocks/FMS.png": 983108,
	"./stocks/FMTX.png": 765584,
	"./stocks/FMX.png": 368690,
	"./stocks/FNB.png": 8179,
	"./stocks/FNCB.png": 496402,
	"./stocks/FNCH.png": 68969,
	"./stocks/FND.png": 559982,
	"./stocks/FNF.png": 728206,
	"./stocks/FNGR.png": 181374,
	"./stocks/FNHC.png": 258403,
	"./stocks/FNKO.png": 500334,
	"./stocks/FNV.png": 898509,
	"./stocks/FNWB.png": 642180,
	"./stocks/FOA.png": 174841,
	"./stocks/FOCS.png": 77395,
	"./stocks/FOLD.png": 294807,
	"./stocks/FORD.png": 938590,
	"./stocks/FOREU.png": 113379,
	"./stocks/FORG.png": 405450,
	"./stocks/FORM.png": 572283,
	"./stocks/FORR.png": 402787,
	"./stocks/FOSL.png": 658858,
	"./stocks/FOUR.png": 431085,
	"./stocks/FOX.png": 364361,
	"./stocks/FOXO.png": 841264,
	"./stocks/FOXX.png": 241186,
	"./stocks/FPAY.png": 24044,
	"./stocks/FPH.png": 786920,
	"./stocks/FPI.png": 127695,
	"./stocks/FPL.png": 761534,
	"./stocks/FR.png": 737232,
	"./stocks/FRA.png": 855852,
	"./stocks/FRBA.png": 406593,
	"./stocks/FRBK.png": 120536,
	"./stocks/FRC.png": 667918,
	"./stocks/FREQ.png": 948435,
	"./stocks/FRES.png": 792137,
	"./stocks/FREY.png": 181751,
	"./stocks/FRGE.png": 69564,
	"./stocks/FRGT.png": 935882,
	"./stocks/FRHC.png": 986045,
	"./stocks/FRLN.png": 278412,
	"./stocks/FRO.png": 73710,
	"./stocks/FROG.png": 698621,
	"./stocks/FRPH.png": 76497,
	"./stocks/FRPT.png": 699249,
	"./stocks/FRSH.png": 507209,
	"./stocks/FRST.png": 832408,
	"./stocks/FRSX.png": 108602,
	"./stocks/FRT.png": 465524,
	"./stocks/FRTA.png": 9656,
	"./stocks/FRTX.png": 771242,
	"./stocks/FRZA.png": 877326,
	"./stocks/FSBC.png": 242401,
	"./stocks/FSBW.png": 592689,
	"./stocks/FSD.png": 204433,
	"./stocks/FSFG.png": 486619,
	"./stocks/FSI.png": 260635,
	"./stocks/FSK.png": 728173,
	"./stocks/FSLR.png": 100073,
	"./stocks/FSLY.png": 601216,
	"./stocks/FSNB.png": 85094,
	"./stocks/FSR.png": 95381,
	"./stocks/FSRD.png": 414762,
	"./stocks/FSS.png": 783813,
	"./stocks/FSTR.png": 282685,
	"./stocks/FSTX.png": 326428,
	"./stocks/FTAI.png": 907301,
	"./stocks/FTCH.png": 821985,
	"./stocks/FTCI.png": 815987,
	"./stocks/FTEL.png": 674077,
	"./stocks/FTFT.png": 460987,
	"./stocks/FTHM.png": 586282,
	"./stocks/FTI.png": 639954,
	"./stocks/FTK.png": 505754,
	"./stocks/FTNT.png": 546976,
	"./stocks/FTPA.png": 313234,
	"./stocks/FTRE.png": 190053,
	"./stocks/FTS.png": 182429,
	"./stocks/FTV.png": 431532,
	"./stocks/FUBO.png": 298298,
	"./stocks/FUD.png": 164128,
	"./stocks/FUFU.png": 608518,
	"./stocks/FULC.png": 182170,
	"./stocks/FULT.png": 251456,
	"./stocks/FULTP.png": 863488,
	"./stocks/FUNC.png": 249426,
	"./stocks/FUND.png": 977948,
	"./stocks/FUSN.png": 384998,
	"./stocks/FUTU.png": 382918,
	"./stocks/FUV.png": 152134,
	"./stocks/FUV1.png": 58155,
	"./stocks/FVCB.png": 835740,
	"./stocks/FVT.png": 787410,
	"./stocks/FWBI.png": 726583,
	"./stocks/FWONA.png": 282986,
	"./stocks/FWONK.png": 781551,
	"./stocks/FWP.png": 923311,
	"./stocks/FWRG.png": 517069,
	"./stocks/FXLV.png": 414598,
	"./stocks/FYBR.png": 620008,
	"./stocks/G.png": 143298,
	"./stocks/GAB.png": 348472,
	"./stocks/GABC.png": 61865,
	"./stocks/GACQ.png": 429691,
	"./stocks/GAIA.png": 365406,
	"./stocks/GAINZ.png": 621890,
	"./stocks/GALT.png": 683317,
	"./stocks/GAMB.png": 382237,
	"./stocks/GAME.png": 212847,
	"./stocks/GAN.png": 69542,
	"./stocks/GANX.png": 505424,
	"./stocks/GAP.png": 472536,
	"./stocks/GASS.png": 571155,
	"./stocks/GATE.png": 11438,
	"./stocks/GATO.png": 764648,
	"./stocks/GATX.png": 34508,
	"./stocks/GBIO.png": 40555,
	"./stocks/GBL.png": 949878,
	"./stocks/GBLI.png": 975078,
	"./stocks/GBNH.png": 135981,
	"./stocks/GBNY.png": 655619,
	"./stocks/GBOX.png": 677347,
	"./stocks/GBR.png": 560902,
	"./stocks/GBS.png": 568170,
	"./stocks/GBT.png": 176466,
	"./stocks/GBX.png": 162103,
	"./stocks/GCI.png": 955386,
	"./stocks/GCL.png": 778441,
	"./stocks/GCO.png": 467370,
	"./stocks/GCP.png": 354512,
	"./stocks/GCT.png": 758707,
	"./stocks/GCTK.png": 792573,
	"./stocks/GCV.png": 175786,
	"./stocks/GD.png": 469996,
	"./stocks/GDC.png": 719924,
	"./stocks/GDC2.png": 776671,
	"./stocks/GDDY.png": 948145,
	"./stocks/GDEV.png": 184388,
	"./stocks/GDHG.png": 939258,
	"./stocks/GDL.png": 832858,
	"./stocks/GDNR.png": 849799,
	"./stocks/GDOT.png": 887352,
	"./stocks/GDRX.png": 76626,
	"./stocks/GDS.png": 680781,
	"./stocks/GDTC.png": 218949,
	"./stocks/GDV.png": 867903,
	"./stocks/GE.png": 711377,
	"./stocks/GEG.png": 922573,
	"./stocks/GEHC.png": 992224,
	"./stocks/GEHI.png": 708136,
	"./stocks/GEL.png": 239252,
	"./stocks/GELS.png": 200363,
	"./stocks/GEN.png": 460258,
	"./stocks/GENC.png": 185564,
	"./stocks/GENE.png": 805063,
	"./stocks/GENI.png": 647727,
	"./stocks/GEO.png": 216387,
	"./stocks/GER.png": 912455,
	"./stocks/GERN.png": 449535,
	"./stocks/GES.png": 507524,
	"./stocks/GETR.png": 95246,
	"./stocks/GETY.png": 141593,
	"./stocks/GEV.png": 867911,
	"./stocks/GEVO.png": 363343,
	"./stocks/GF.png": 768941,
	"./stocks/GFAI.png": 466072,
	"./stocks/GFED.png": 681731,
	"./stocks/GFL.png": 266766,
	"./stocks/GFLU.png": 991062,
	"./stocks/GGAAF.png": 154246,
	"./stocks/GGAL.png": 553084,
	"./stocks/GGE.png": 399666,
	"./stocks/GGG.png": 211256,
	"./stocks/GGPI.png": 73170,
	"./stocks/GGT.png": 68459,
	"./stocks/GGZ.png": 27635,
	"./stocks/GH.png": 284631,
	"./stocks/GHC.png": 372439,
	"./stocks/GHLD.png": 671273,
	"./stocks/GHM.png": 839996,
	"./stocks/GHRS.png": 550700,
	"./stocks/GHSI.png": 191469,
	"./stocks/GHY.png": 856112,
	"./stocks/GIB.png": 643331,
	"./stocks/GIC.png": 26604,
	"./stocks/GIFI.png": 911665,
	"./stocks/GIII.png": 358194,
	"./stocks/GIL.png": 65319,
	"./stocks/GILD.png": 177648,
	"./stocks/GILT.png": 215031,
	"./stocks/GIS.png": 909677,
	"./stocks/GITS.png": 246674,
	"./stocks/GKOS.png": 170999,
	"./stocks/GL.png": 541500,
	"./stocks/GLBE.png": 914874,
	"./stocks/GLBS.png": 183621,
	"./stocks/GLBZ.png": 720367,
	"./stocks/GLDD.png": 784352,
	"./stocks/GLE.png": 585646,
	"./stocks/GLG.png": 82023,
	"./stocks/GLMD.png": 604750,
	"./stocks/GLNG.png": 845656,
	"./stocks/GLOB.png": 213961,
	"./stocks/GLOP.png": 174287,
	"./stocks/GLP.png": 530118,
	"./stocks/GLPG.png": 652540,
	"./stocks/GLPI.png": 117346,
	"./stocks/GLRE.png": 627565,
	"./stocks/GLSI.png": 673299,
	"./stocks/GLST.png": 139205,
	"./stocks/GLTA.png": 505546,
	"./stocks/GLTO.png": 47168,
	"./stocks/GLUE.png": 934940,
	"./stocks/GLW.png": 338774,
	"./stocks/GLXG.png": 970792,
	"./stocks/GLYC.png": 900634,
	"./stocks/GM.png": 372161,
	"./stocks/GMBL.png": 343876,
	"./stocks/GMDA.png": 873014,
	"./stocks/GME.png": 128837,
	"./stocks/GMED.png": 13399,
	"./stocks/GMGI.png": 118105,
	"./stocks/GMM.png": 457961,
	"./stocks/GMS.png": 415704,
	"./stocks/GMTX.png": 138290,
	"./stocks/GMVD.png": 161837,
	"./stocks/GNAC.png": 292499,
	"./stocks/GNACU.png": 948944,
	"./stocks/GNCA.png": 865354,
	"./stocks/GNE.png": 176710,
	"./stocks/GNFT.png": 583025,
	"./stocks/GNL.png": 834877,
	"./stocks/GNLN.png": 3398,
	"./stocks/GNLX.png": 601138,
	"./stocks/GNPX.png": 598338,
	"./stocks/GNRC.png": 358094,
	"./stocks/GNS.png": 362424,
	"./stocks/GNSS.png": 521571,
	"./stocks/GNT.png": 681688,
	"./stocks/GNTA.png": 191543,
	"./stocks/GNTX.png": 229664,
	"./stocks/GNTY.png": 37647,
	"./stocks/GNUS.png": 387719,
	"./stocks/GNW.png": 720147,
	"./stocks/GO.png": 749399,
	"./stocks/GOEV.png": 876014,
	"./stocks/GOGL.png": 518653,
	"./stocks/GOGO.png": 124048,
	"./stocks/GOL.png": 40523,
	"./stocks/GOLD.png": 212303,
	"./stocks/GOOG.png": 33711,
	"./stocks/GOOGL.png": 661714,
	"./stocks/GOOS.png": 896426,
	"./stocks/GORV.png": 697997,
	"./stocks/GOSS.png": 962010,
	"./stocks/GOTU.png": 224502,
	"./stocks/GOVX.png": 893068,
	"./stocks/GP.png": 286265,
	"./stocks/GPAK.png": 462365,
	"./stocks/GPC.png": 521120,
	"./stocks/GPCO.png": 821978,
	"./stocks/GPCOU.png": 749516,
	"./stocks/GPCR.png": 280841,
	"./stocks/GPI.png": 703160,
	"./stocks/GPK.png": 17305,
	"./stocks/GPL.png": 953435,
	"./stocks/GPMT.png": 89985,
	"./stocks/GPN.png": 287659,
	"./stocks/GPRE.png": 861329,
	"./stocks/GPRK.png": 219134,
	"./stocks/GPRO.png": 110117,
	"./stocks/GPS.png": 786596,
	"./stocks/GRAB.png": 536222,
	"./stocks/GRAY.png": 600186,
	"./stocks/GRCL.png": 416609,
	"./stocks/GRDI.png": 459912,
	"./stocks/GREE.png": 4612,
	"./stocks/GRFS.png": 654169,
	"./stocks/GRFX.png": 240372,
	"./stocks/GRI.png": 196305,
	"./stocks/GRIL.png": 708830,
	"./stocks/GRIN.png": 343147,
	"./stocks/GRMN.png": 315477,
	"./stocks/GRNQ.png": 681810,
	"./stocks/GROM.png": 173852,
	"./stocks/GROV.png": 364732,
	"./stocks/GROW.png": 361038,
	"./stocks/GRPH.png": 907294,
	"./stocks/GRPN.png": 192594,
	"./stocks/GRRR.png": 945398,
	"./stocks/GRTS.png": 788681,
	"./stocks/GRTX.png": 923971,
	"./stocks/GRUB.png": 432810,
	"./stocks/GRWG.png": 657614,
	"./stocks/GRX.png": 246558,
	"./stocks/GS.png": 77716,
	"./stocks/GSAT.png": 79443,
	"./stocks/GSBC.png": 742854,
	"./stocks/GSBD.png": 789962,
	"./stocks/GSHD.png": 993595,
	"./stocks/GSIT.png": 268738,
	"./stocks/GSIW.png": 496403,
	"./stocks/GSK.png": 719895,
	"./stocks/GSKY.png": 669871,
	"./stocks/GSM.png": 576508,
	"./stocks/GSUN.png": 64507,
	"./stocks/GT.png": 120339,
	"./stocks/GTBIF.png": 553401,
	"./stocks/GTBP.png": 983240,
	"./stocks/GTE.png": 213370,
	"./stocks/GTEC.png": 404097,
	"./stocks/GTES.png": 450678,
	"./stocks/GTH.png": 673669,
	"./stocks/GTHX.png": 798141,
	"./stocks/GTI.png": 505525,
	"./stocks/GTIM.png": 567493,
	"./stocks/GTLB.png": 73342,
	"./stocks/GTLS.png": 900206,
	"./stocks/GTS.png": 138357,
	"./stocks/GTX.png": 336310,
	"./stocks/GTXAP.png": 730803,
	"./stocks/GTY.png": 817937,
	"./stocks/GTYH.png": 835300,
	"./stocks/GURE.png": 520823,
	"./stocks/GUT.png": 711422,
	"./stocks/GV.png": 453269,
	"./stocks/GVP.png": 801084,
	"./stocks/GWAV.png": 276846,
	"./stocks/GWGH.png": 89502,
	"./stocks/GWRE.png": 217447,
	"./stocks/GXAI.png": 790492,
	"./stocks/GXO.png": 605961,
	"./stocks/H.png": 791116,
	"./stocks/HA.png": 22906,
	"./stocks/HAAC.png": 748391,
	"./stocks/HAACU.png": 893275,
	"./stocks/HAIN.png": 226765,
	"./stocks/HAL.png": 668190,
	"./stocks/HALL.png": 915334,
	"./stocks/HALO.png": 409594,
	"./stocks/HAO.png": 232729,
	"./stocks/HAPP.png": 584701,
	"./stocks/HARP.png": 586806,
	"./stocks/HAS.png": 490346,
	"./stocks/HASI.png": 320324,
	"./stocks/HAYN.png": 590097,
	"./stocks/HAYW.png": 41258,
	"./stocks/HBCP.png": 34750,
	"./stocks/HBI.png": 65769,
	"./stocks/HBIO.png": 227063,
	"./stocks/HBM.png": 410366,
	"./stocks/HBMD.png": 24460,
	"./stocks/HBNC.png": 47511,
	"./stocks/HCA.png": 598932,
	"./stocks/HCAR.png": 208137,
	"./stocks/HCAT.png": 235018,
	"./stocks/HCC.png": 87800,
	"./stocks/HCCI.png": 804478,
	"./stocks/HCDI.png": 337727,
	"./stocks/HCDIP.png": 27359,
	"./stocks/HCDIZ.png": 495764,
	"./stocks/HCI.png": 4180,
	"./stocks/HCKT.png": 24746,
	"./stocks/HCM.png": 441318,
	"./stocks/HCP.png": 514224,
	"./stocks/HCSG.png": 390772,
	"./stocks/HCTI.png": 774422,
	"./stocks/HCWB.png": 870189,
	"./stocks/HCWC.png": 776409,
	"./stocks/HD.png": 683529,
	"./stocks/HDB.png": 434089,
	"./stocks/HDSN.png": 845326,
	"./stocks/HE.png": 27376,
	"./stocks/HEAR.png": 427482,
	"./stocks/HEES.png": 146884,
	"./stocks/HEI.png": 920550,
	"./stocks/HELE.png": 462409,
	"./stocks/HEPA.png": 942098,
	"./stocks/HEPS.png": 693207,
	"./stocks/HES.png": 684328,
	"./stocks/HEXO.png": 768009,
	"./stocks/HGEN.png": 233058,
	"./stocks/HGLB.png": 754471,
	"./stocks/HGSH.png": 899333,
	"./stocks/HHC.png": 918751,
	"./stocks/HHGC.png": 616163,
	"./stocks/HHLA.png": 458137,
	"./stocks/HHR.png": 119237,
	"./stocks/HI.png": 92673,
	"./stocks/HIBB.png": 523444,
	"./stocks/HIE.png": 211534,
	"./stocks/HIFS.png": 467495,
	"./stocks/HIG.png": 363043,
	"./stocks/HIHO.png": 561109,
	"./stocks/HII.png": 437545,
	"./stocks/HIL.png": 559506,
	"./stocks/HILS.png": 185766,
	"./stocks/HIMS.png": 415297,
	"./stocks/HITI.png": 859070,
	"./stocks/HIVE.png": 863842,
	"./stocks/HIW.png": 242578,
	"./stocks/HKD.png": 581511,
	"./stocks/HKG.png": 511785,
	"./stocks/HKIB.png": 35011,
	"./stocks/HKIT.png": 92854,
	"./stocks/HKPD.png": 118663,
	"./stocks/HL.png": 958607,
	"./stocks/HLBZ.png": 78203,
	"./stocks/HLF.png": 864928,
	"./stocks/HLGN.png": 204001,
	"./stocks/HLIO.png": 614871,
	"./stocks/HLIT.png": 133309,
	"./stocks/HLN.png": 351455,
	"./stocks/HLNE.png": 102757,
	"./stocks/HLT.png": 826989,
	"./stocks/HLTH.png": 826279,
	"./stocks/HLX.png": 620300,
	"./stocks/HLXA.png": 445253,
	"./stocks/HMC.png": 131898,
	"./stocks/HMDPF.png": 478875,
	"./stocks/HMHC.png": 797197,
	"./stocks/HMR.png": 381817,
	"./stocks/HMST.png": 70559,
	"./stocks/HNGR.png": 214111,
	"./stocks/HNI.png": 634638,
	"./stocks/HNNA.png": 909222,
	"./stocks/HNP.png": 133144,
	"./stocks/HNRA.png": 897926,
	"./stocks/HNRC.png": 69756,
	"./stocks/HNRG.png": 977023,
	"./stocks/HNST.png": 724620,
	"./stocks/HOFV.png": 894446,
	"./stocks/HOG.png": 890071,
	"./stocks/HOLD.png": 975282,
	"./stocks/HOLO.png": 154027,
	"./stocks/HOLX.png": 669476,
	"./stocks/HOMB.png": 461707,
	"./stocks/HON.png": 524247,
	"./stocks/HONE.png": 904324,
	"./stocks/HOOD.png": 922794,
	"./stocks/HOOK.png": 675715,
	"./stocks/HOTH.png": 357731,
	"./stocks/HOUR.png": 36774,
	"./stocks/HOVR.png": 228794,
	"./stocks/HOWL.png": 532667,
	"./stocks/HP.png": 781554,
	"./stocks/HPCO.png": 425806,
	"./stocks/HPE.png": 124698,
	"./stocks/HPH.png": 575784,
	"./stocks/HPK.png": 685757,
	"./stocks/HPP.png": 130639,
	"./stocks/HPQ.png": 428199,
	"./stocks/HPX.png": 363627,
	"./stocks/HQH.png": 618571,
	"./stocks/HQI.png": 545907,
	"./stocks/HQL.png": 132125,
	"./stocks/HQY.png": 152332,
	"./stocks/HR.png": 268154,
	"./stocks/HRB.png": 193681,
	"./stocks/HRC.png": 901516,
	"./stocks/HRI.png": 566664,
	"./stocks/HRL.png": 330878,
	"./stocks/HRMY.png": 482216,
	"./stocks/HROW.png": 443910,
	"./stocks/HRTG.png": 410471,
	"./stocks/HRTX.png": 926515,
	"./stocks/HRYU.png": 673866,
	"./stocks/HSAI.png": 335480,
	"./stocks/HSBC.png": 674317,
	"./stocks/HSC.png": 451068,
	"./stocks/HSCS.png": 632102,
	"./stocks/HSDT.png": 141510,
	"./stocks/HSII.png": 624238,
	"./stocks/HSKA.png": 698734,
	"./stocks/HSON.png": 587086,
	"./stocks/HST.png": 309746,
	"./stocks/HSTM.png": 108568,
	"./stocks/HSTO.png": 424109,
	"./stocks/HSY.png": 449989,
	"./stocks/HTA.png": 728213,
	"./stocks/HTBI.png": 331209,
	"./stocks/HTBK.png": 178562,
	"./stocks/HTBX.png": 491681,
	"./stocks/HTCR.png": 419544,
	"./stocks/HTGC.png": 625104,
	"./stocks/HTGM.png": 759553,
	"./stocks/HTHT.png": 955143,
	"./stocks/HTLD.png": 559935,
	"./stocks/HTLF.png": 421743,
	"./stocks/HTLFP.png": 336013,
	"./stocks/HTLM.png": 285784,
	"./stocks/HTOO.png": 26902,
	"./stocks/HTOOW.png": 426146,
	"./stocks/HTPA.png": 113881,
	"./stocks/HTZ.png": 802806,
	"./stocks/HUBB.png": 481960,
	"./stocks/HUBC.png": 998003,
	"./stocks/HUBS.png": 441904,
	"./stocks/HUDA.png": 741333,
	"./stocks/HUDI.png": 474204,
	"./stocks/HUGE.png": 366421,
	"./stocks/HUHU.png": 733558,
	"./stocks/HUIZ.png": 525189,
	"./stocks/HUM.png": 93561,
	"./stocks/HUMA.png": 654209,
	"./stocks/HUN.png": 557973,
	"./stocks/HURA.png": 247302,
	"./stocks/HURC.png": 624044,
	"./stocks/HURN.png": 933405,
	"./stocks/HUSA.png": 433362,
	"./stocks/HUSN.png": 520207,
	"./stocks/HUT.png": 81803,
	"./stocks/HUYA.png": 74254,
	"./stocks/HVT.png": 775864,
	"./stocks/HWC.png": 373828,
	"./stocks/HWH.png": 834041,
	"./stocks/HWM.png": 623703,
	"./stocks/HXL.png": 165928,
	"./stocks/HY.png": 339002,
	"./stocks/HYAC.png": 306823,
	"./stocks/HYACU.png": 995333,
	"./stocks/HYFM.png": 621853,
	"./stocks/HYLN.png": 717222,
	"./stocks/HYMC.png": 867389,
	"./stocks/HYPR.png": 269033,
	"./stocks/HYRE.png": 783251,
	"./stocks/HYSR.png": 685767,
	"./stocks/HYT.png": 523287,
	"./stocks/HYW.png": 796446,
	"./stocks/HYZN.png": 179767,
	"./stocks/HZAC.png": 582078,
	"./stocks/HZN.png": 249822,
	"./stocks/HZO.png": 180842,
	"./stocks/IAA.png": 43714,
	"./stocks/IACB.png": 676372,
	"./stocks/IAG.png": 932546,
	"./stocks/IAIC.png": 746610,
	"./stocks/IART.png": 718645,
	"./stocks/IBA.png": 336769,
	"./stocks/IBCP.png": 49562,
	"./stocks/IBEX.png": 6114,
	"./stocks/IBIO.png": 299268,
	"./stocks/IBKR.png": 874189,
	"./stocks/IBM.png": 745479,
	"./stocks/IBN.png": 239111,
	"./stocks/IBO.png": 372189,
	"./stocks/IBOC.png": 888117,
	"./stocks/IBRX.png": 455684,
	"./stocks/IBTA.png": 56074,
	"./stocks/ICAD.png": 505223,
	"./stocks/ICBK.png": 36044,
	"./stocks/ICCC.png": 650345,
	"./stocks/ICCM.png": 560850,
	"./stocks/ICCT.png": 41726,
	"./stocks/ICD.png": 940681,
	"./stocks/ICE.png": 501777,
	"./stocks/ICG.png": 263986,
	"./stocks/ICHR.png": 544272,
	"./stocks/ICL.png": 942314,
	"./stocks/ICLK.png": 789751,
	"./stocks/ICLR.png": 829145,
	"./stocks/ICMB.png": 452196,
	"./stocks/ICPT.png": 637798,
	"./stocks/ICTI.png": 562344,
	"./stocks/ICU.png": 106562,
	"./stocks/ICUI.png": 637412,
	"./stocks/ICVX.png": 627266,
	"./stocks/ID.png": 831175,
	"./stocks/IDAI.png": 69308,
	"./stocks/IDCC.png": 214527,
	"./stocks/IDEX.png": 746648,
	"./stocks/IDN.png": 576298,
	"./stocks/IDRA.png": 462874,
	"./stocks/IDT.png": 890912,
	"./stocks/IDYA.png": 143991,
	"./stocks/IE.png": 3077,
	"./stocks/IEA.png": 956843,
	"./stocks/IEP.png": 928069,
	"./stocks/IESC.png": 571941,
	"./stocks/IEX.png": 973741,
	"./stocks/IFBD.png": 60016,
	"./stocks/IFF.png": 721856,
	"./stocks/IFRX.png": 888334,
	"./stocks/IGC.png": 618474,
	"./stocks/IGMS.png": 844265,
	"./stocks/IGNY.png": 605410,
	"./stocks/IGNYU.png": 771889,
	"./stocks/IGP.png": 231624,
	"./stocks/IGR.png": 776986,
	"./stocks/IGT.png": 74270,
	"./stocks/IHC.png": 999103,
	"./stocks/IHG.png": 474166,
	"./stocks/IHRT.png": 532409,
	"./stocks/IHS.png": 299715,
	"./stocks/III.png": 871092,
	"./stocks/IIIV.png": 660835,
	"./stocks/IIM.png": 937574,
	"./stocks/IIN.png": 859661,
	"./stocks/IINN.png": 814062,
	"./stocks/IIPR.png": 207338,
	"./stocks/IKNA.png": 957322,
	"./stocks/IKNX.png": 227221,
	"./stocks/ILAG.png": 384789,
	"./stocks/ILMN.png": 203483,
	"./stocks/ILUS.png": 981620,
	"./stocks/IMAB.png": 516648,
	"./stocks/IMAC.png": 59585,
	"./stocks/IMAX.png": 23430,
	"./stocks/IMBI.png": 424007,
	"./stocks/IMCC.png": 610677,
	"./stocks/IMCR.png": 666454,
	"./stocks/IMG.png": 385710,
	"./stocks/IMGN.png": 83094,
	"./stocks/IMKTA.png": 14407,
	"./stocks/IMMP.png": 177231,
	"./stocks/IMMR.png": 29860,
	"./stocks/IMMX.png": 464340,
	"./stocks/IMNM.png": 200764,
	"./stocks/IMNN.png": 758692,
	"./stocks/IMPL.png": 616938,
	"./stocks/IMPP.png": 4172,
	"./stocks/IMPX.png": 480048,
	"./stocks/IMRA.png": 863140,
	"./stocks/IMRN.png": 537905,
	"./stocks/IMRX.png": 106711,
	"./stocks/IMTE.png": 6537,
	"./stocks/IMTX.png": 696030,
	"./stocks/IMUX.png": 900889,
	"./stocks/IMV.png": 274833,
	"./stocks/IMVT.png": 591487,
	"./stocks/IMXI.png": 440658,
	"./stocks/INAB.png": 648162,
	"./stocks/INBK.png": 385971,
	"./stocks/INBS.png": 935810,
	"./stocks/INBX.png": 620299,
	"./stocks/INCR.png": 336937,
	"./stocks/INCY.png": 649775,
	"./stocks/INDB.png": 91426,
	"./stocks/INDI.png": 742965,
	"./stocks/INDO.png": 936552,
	"./stocks/INDP.png": 52062,
	"./stocks/INFI.png": 427017,
	"./stocks/INFM.png": 639680,
	"./stocks/INFN.png": 214641,
	"./stocks/INFO.png": 24785,
	"./stocks/INFU.png": 709236,
	"./stocks/INFY.png": 520979,
	"./stocks/ING.png": 232180,
	"./stocks/INGN.png": 569066,
	"./stocks/INHD.png": 498121,
	"./stocks/INKT.png": 545452,
	"./stocks/INLF.png": 54469,
	"./stocks/INM.png": 235433,
	"./stocks/INMB.png": 667552,
	"./stocks/INMD.png": 227093,
	"./stocks/INN.png": 420142,
	"./stocks/INNV.png": 565749,
	"./stocks/INO.png": 837835,
	"./stocks/INOD.png": 797196,
	"./stocks/INOV.png": 464897,
	"./stocks/INPX.png": 865249,
	"./stocks/INSE.png": 856712,
	"./stocks/INSG.png": 485998,
	"./stocks/INSI.png": 318038,
	"./stocks/INSM.png": 41214,
	"./stocks/INSP.png": 993096,
	"./stocks/INT.png": 542562,
	"./stocks/INTA.png": 969137,
	"./stocks/INTC.png": 820497,
	"./stocks/INTT.png": 239927,
	"./stocks/INTU.png": 475723,
	"./stocks/INTZ.png": 692051,
	"./stocks/INVE.png": 474149,
	"./stocks/INVH.png": 96990,
	"./stocks/INVO.png": 999245,
	"./stocks/INVZ.png": 403097,
	"./stocks/INZY.png": 934786,
	"./stocks/IO.png": 584758,
	"./stocks/IONM.png": 926869,
	"./stocks/IONQ.png": 121527,
	"./stocks/IONS.png": 810718,
	"./stocks/IOSP.png": 79369,
	"./stocks/IOT.png": 408697,
	"./stocks/IOVA.png": 644075,
	"./stocks/IP.png": 187415,
	"./stocks/IPA.png": 744037,
	"./stocks/IPAR.png": 894766,
	"./stocks/IPAX.png": 916014,
	"./stocks/IPDN.png": 133194,
	"./stocks/IPGP.png": 941321,
	"./stocks/IPHA.png": 352242,
	"./stocks/IPI.png": 921627,
	"./stocks/IPOF.png": 370113,
	"./stocks/IPSC.png": 468990,
	"./stocks/IPW.png": 206822,
	"./stocks/IPWR.png": 897807,
	"./stocks/IPX.png": 549459,
	"./stocks/IQ.png": 325583,
	"./stocks/IQI.png": 657494,
	"./stocks/IQV.png": 129767,
	"./stocks/IRBT.png": 283735,
	"./stocks/IRCP.png": 924064,
	"./stocks/IREN.png": 883421,
	"./stocks/IRM.png": 377049,
	"./stocks/IRNT.png": 280460,
	"./stocks/IRT.png": 52999,
	"./stocks/IRTC.png": 602690,
	"./stocks/IRWD.png": 356561,
	"./stocks/IS.png": 476610,
	"./stocks/ISBC.png": 890219,
	"./stocks/ISD.png": 743962,
	"./stocks/ISEE.png": 385826,
	"./stocks/ISIG.png": 869768,
	"./stocks/ISO.png": 218059,
	"./stocks/ISPC.png": 946407,
	"./stocks/ISPO.png": 544584,
	"./stocks/ISPR.png": 434674,
	"./stocks/ISRG.png": 242442,
	"./stocks/ISSC.png": 200244,
	"./stocks/ISTR.png": 377983,
	"./stocks/ISUN.png": 466092,
	"./stocks/ITCB.png": 364303,
	"./stocks/ITGR.png": 855238,
	"./stocks/ITI.png": 396211,
	"./stocks/ITIC.png": 873950,
	"./stocks/ITMR.png": 673408,
	"./stocks/ITOS.png": 702002,
	"./stocks/ITP.png": 186159,
	"./stocks/ITRM.png": 643576,
	"./stocks/ITRN.png": 118453,
	"./stocks/ITT.png": 99439,
	"./stocks/ITUB.png": 789774,
	"./stocks/ITW.png": 469658,
	"./stocks/IVA.png": 427408,
	"./stocks/IVAC.png": 634018,
	"./stocks/IVC.png": 690856,
	"./stocks/IVCP.png": 890698,
	"./stocks/IVDA.png": 810597,
	"./stocks/IVP.png": 462444,
	"./stocks/IVR.png": 402856,
	"./stocks/IVVD.png": 526391,
	"./stocks/IVZ.png": 456058,
	"./stocks/IX.png": 77801,
	"./stocks/IXHL.png": 144163,
	"./stocks/IZEA.png": 286153,
	"./stocks/IZM.png": 800573,
	"./stocks/IZTC.png": 890249,
	"./stocks/J.png": 489214,
	"./stocks/JAGX.png": 729486,
	"./stocks/JAKK.png": 514753,
	"./stocks/JAMF.png": 12234,
	"./stocks/JAN.png": 862519,
	"./stocks/JANX.png": 264661,
	"./stocks/JBDI.png": 747248,
	"./stocks/JBGS.png": 208540,
	"./stocks/JBHT.png": 524067,
	"./stocks/JBI.png": 664512,
	"./stocks/JBL.png": 548518,
	"./stocks/JBLU.png": 22673,
	"./stocks/JBSS.png": 511061,
	"./stocks/JBT.png": 510651,
	"./stocks/JCI.png": 498031,
	"./stocks/JCOM.png": 334837,
	"./stocks/JCSE.png": 557041,
	"./stocks/JCTCF.png": 874551,
	"./stocks/JD.png": 198300,
	"./stocks/JDZG.png": 99979,
	"./stocks/JETS.png": 516825,
	"./stocks/JEWL.png": 371560,
	"./stocks/JFBR.png": 518074,
	"./stocks/JFIN.png": 378907,
	"./stocks/JFR.png": 438883,
	"./stocks/JFU.png": 144364,
	"./stocks/JG.png": 713499,
	"./stocks/JHX.png": 489703,
	"./stocks/JILL.png": 356662,
	"./stocks/JJSF.png": 556230,
	"./stocks/JKS.png": 293894,
	"./stocks/JLL.png": 755630,
	"./stocks/JMAC.png": 427981,
	"./stocks/JMIA.png": 456498,
	"./stocks/JMP.png": 992322,
	"./stocks/JNCE.png": 298519,
	"./stocks/JNJ.png": 859155,
	"./stocks/JNPR.png": 841999,
	"./stocks/JOAN.png": 494600,
	"./stocks/JOB.png": 68334,
	"./stocks/JOBY.png": 778651,
	"./stocks/JOF.png": 422391,
	"./stocks/JPM.png": 923752,
	"./stocks/JSPR.png": 13085,
	"./stocks/JSPRW.png": 819705,
	"./stocks/JT.png": 232716,
	"./stocks/JTAI.png": 731835,
	"./stocks/JUNE.png": 246169,
	"./stocks/JUNS.png": 666782,
	"./stocks/JUPW.png": 451000,
	"./stocks/JVA.png": 121899,
	"./stocks/JWAC.png": 869498,
	"./stocks/JWEL.png": 195865,
	"./stocks/JWN.png": 734264,
	"./stocks/JXJT.png": 315836,
	"./stocks/JYD.png": 746888,
	"./stocks/JYNT.png": 947534,
	"./stocks/JZ.png": 482053,
	"./stocks/JZXN.png": 363012,
	"./stocks/K.png": 386204,
	"./stocks/KA.png": 587644,
	"./stocks/KACL.png": 324602,
	"./stocks/KAHC.png": 682968,
	"./stocks/KAI.png": 164200,
	"./stocks/KAIR.png": 494855,
	"./stocks/KAIRU.png": 757264,
	"./stocks/KAL.png": 919658,
	"./stocks/KALA.png": 867665,
	"./stocks/KALV.png": 990059,
	"./stocks/KAMN.png": 436578,
	"./stocks/KAPA.png": 90006,
	"./stocks/KAR.png": 4719,
	"./stocks/KAVL.png": 744276,
	"./stocks/KB.png": 609144,
	"./stocks/KBAL.png": 148190,
	"./stocks/KBH.png": 925444,
	"./stocks/KBNT.png": 346724,
	"./stocks/KBR.png": 80001,
	"./stocks/KBSX.png": 22403,
	"./stocks/KC.png": 294654,
	"./stocks/KD.png": 884740,
	"./stocks/KDLY.png": 622088,
	"./stocks/KDNY.png": 271982,
	"./stocks/KDP.png": 846496,
	"./stocks/KE.png": 745924,
	"./stocks/KELYA.png": 52369,
	"./stocks/KELYB.png": 867181,
	"./stocks/KEQU.png": 634393,
	"./stocks/KERN.png": 290859,
	"./stocks/KEX.png": 306567,
	"./stocks/KEY.png": 189118,
	"./stocks/KEYS.png": 581129,
	"./stocks/KFFB.png": 879326,
	"./stocks/KFRC.png": 933880,
	"./stocks/KFS.png": 618579,
	"./stocks/KFY.png": 770537,
	"./stocks/KGC.png": 31611,
	"./stocks/KHC.png": 802032,
	"./stocks/KIII.png": 476009,
	"./stocks/KIM.png": 455223,
	"./stocks/KINZ.png": 7715,
	"./stocks/KIQ.png": 953008,
	"./stocks/KIRK.png": 498025,
	"./stocks/KITT.png": 143476,
	"./stocks/KKR.png": 525448,
	"./stocks/KL.png": 639495,
	"./stocks/KLAC.png": 192193,
	"./stocks/KLC.png": 852711,
	"./stocks/KLDO.png": 500427,
	"./stocks/KLR.png": 876737,
	"./stocks/KLTO.png": 461007,
	"./stocks/KLXE.png": 729225,
	"./stocks/KMB.png": 297822,
	"./stocks/KMF.png": 75885,
	"./stocks/KMI.png": 150623,
	"./stocks/KMPH.png": 524877,
	"./stocks/KMPR.png": 777628,
	"./stocks/KMX.png": 154641,
	"./stocks/KNBE.png": 84741,
	"./stocks/KNSA.png": 647351,
	"./stocks/KNTE.png": 747979,
	"./stocks/KNW.png": 215487,
	"./stocks/KNX.png": 536689,
	"./stocks/KO.png": 402448,
	"./stocks/KOD.png": 35680,
	"./stocks/KODK.png": 185140,
	"./stocks/KOPN.png": 645312,
	"./stocks/KORE.png": 106356,
	"./stocks/KOS.png": 66898,
	"./stocks/KOSS.png": 636851,
	"./stocks/KPLT.png": 732196,
	"./stocks/KPRX.png": 681277,
	"./stocks/KPTI.png": 244854,
	"./stocks/KR.png": 368239,
	"./stocks/KRA.png": 19798,
	"./stocks/KRBP.png": 969098,
	"./stocks/KRC.png": 898564,
	"./stocks/KRG.png": 765185,
	"./stocks/KRKR.png": 394232,
	"./stocks/KRNT.png": 382761,
	"./stocks/KRNY.png": 760650,
	"./stocks/KRON.png": 453094,
	"./stocks/KRP.png": 142005,
	"./stocks/KRRO.png": 369084,
	"./stocks/KRT.png": 367903,
	"./stocks/KRTX.png": 333080,
	"./stocks/KRUS.png": 750399,
	"./stocks/KRYS.png": 884545,
	"./stocks/KSCP.png": 392187,
	"./stocks/KSM.png": 761234,
	"./stocks/KSPN.png": 451802,
	"./stocks/KSS.png": 559842,
	"./stocks/KT.png": 695601,
	"./stocks/KTCC.png": 697457,
	"./stocks/KTF.png": 8,
	"./stocks/KTOS.png": 183804,
	"./stocks/KTRA.png": 371194,
	"./stocks/KTTA.png": 948079,
	"./stocks/KUKE.png": 695546,
	"./stocks/KULR.png": 726727,
	"./stocks/KURA.png": 312624,
	"./stocks/KVHI.png": 375410,
	"./stocks/KVUE.png": 280704,
	"./stocks/KWE.png": 819292,
	"./stocks/KXIN.png": 299872,
	"./stocks/KXR.png": 507841,
	"./stocks/KXR2.png": 817560,
	"./stocks/KXS.png": 86423,
	"./stocks/KYMR.png": 959845,
	"./stocks/KYN.png": 234969,
	"./stocks/KZIA.png": 792311,
	"./stocks/KZR.png": 340722,
	"./stocks/L.png": 987894,
	"./stocks/LAB.png": 631653,
	"./stocks/LABP.png": 359263,
	"./stocks/LAC.png": 832191,
	"./stocks/LAD.png": 913030,
	"./stocks/LADR.png": 704420,
	"./stocks/LAES.png": 730344,
	"./stocks/LAKE.png": 521719,
	"./stocks/LAMR.png": 199492,
	"./stocks/LANC.png": 297329,
	"./stocks/LARK.png": 783864,
	"./stocks/LASE.png": 863680,
	"./stocks/LASR.png": 367597,
	"./stocks/LATG.png": 685538,
	"./stocks/LAWS.png": 183375,
	"./stocks/LAX.png": 165252,
	"./stocks/LAZR.png": 930267,
	"./stocks/LBAI.png": 669256,
	"./stocks/LBGJ.png": 192868,
	"./stocks/LBPH.png": 933879,
	"./stocks/LBPS.png": 873114,
	"./stocks/LBRDK.png": 519813,
	"./stocks/LBRT.png": 80439,
	"./stocks/LBTYA.png": 384997,
	"./stocks/LBTYB.png": 637783,
	"./stocks/LBTYK.png": 276390,
	"./stocks/LC.png": 933636,
	"./stocks/LCFY.png": 318343,
	"./stocks/LCI.png": 423551,
	"./stocks/LCID.png": 405319,
	"./stocks/LCII.png": 146130,
	"./stocks/LCNB.png": 547230,
	"./stocks/LCRX.png": 439633,
	"./stocks/LCS.png": 322603,
	"./stocks/LCUT.png": 589417,
	"./stocks/LDI.png": 184622,
	"./stocks/LDOS.png": 686932,
	"./stocks/LDTC.png": 8327,
	"./stocks/LE.png": 52440,
	"./stocks/LEA.png": 814989,
	"./stocks/LECO.png": 543236,
	"./stocks/LEDS.png": 2489,
	"./stocks/LEE.png": 178666,
	"./stocks/LEG.png": 233919,
	"./stocks/LEGN.png": 626416,
	"./stocks/LEJU2.png": 734102,
	"./stocks/LEN.png": 699990,
	"./stocks/LEO.png": 92827,
	"./stocks/LESL.png": 318393,
	"./stocks/LEU.png": 578758,
	"./stocks/LEV.png": 595286,
	"./stocks/LEVI.png": 586162,
	"./stocks/LEXX.png": 702929,
	"./stocks/LFC.png": 163434,
	"./stocks/LFLY.png": 225906,
	"./stocks/LFMD.png": 35445,
	"./stocks/LFMDP.png": 692028,
	"./stocks/LFST.png": 396850,
	"./stocks/LFTR.png": 57500,
	"./stocks/LFTRU.png": 342354,
	"./stocks/LFUS.png": 917223,
	"./stocks/LFVN.png": 663239,
	"./stocks/LFWD.png": 622354,
	"./stocks/LGAC.png": 752744,
	"./stocks/LGACU.png": 424828,
	"./stocks/LGCB.png": 389685,
	"./stocks/LGCL.png": 902864,
	"./stocks/LGHL.png": 859020,
	"./stocks/LGIH.png": 939872,
	"./stocks/LGMK.png": 125340,
	"./stocks/LGND.png": 114914,
	"./stocks/LGO.png": 836985,
	"./stocks/LGV.png": 964869,
	"./stocks/LGVC.png": 790578,
	"./stocks/LGVN.png": 963867,
	"./stocks/LH.png": 833564,
	"./stocks/LHCG.png": 665235,
	"./stocks/LHDX.png": 201761,
	"./stocks/LHX.png": 573176,
	"./stocks/LI.png": 665838,
	"./stocks/LIAN.png": 645881,
	"./stocks/LICENSE": 414341,
	"./stocks/LICN.png": 201637,
	"./stocks/LICY.png": 495664,
	"./stocks/LIDR.png": 875769,
	"./stocks/LIFE.png": 548484,
	"./stocks/LIFW.png": 34301,
	"./stocks/LII.png": 38448,
	"./stocks/LILA.png": 640401,
	"./stocks/LILAK.png": 850923,
	"./stocks/LILM.png": 532931,
	"./stocks/LILMW.png": 487454,
	"./stocks/LIN.png": 107760,
	"./stocks/LINC.png": 862547,
	"./stocks/LIND.png": 246595,
	"./stocks/LINK.png": 477252,
	"./stocks/LINKS.png": 268991,
	"./stocks/LION.png": 801189,
	"./stocks/LIPO.png": 302108,
	"./stocks/LIQT.png": 78430,
	"./stocks/LITB.png": 221913,
	"./stocks/LITE.png": 367851,
	"./stocks/LITM.png": 377230,
	"./stocks/LIVB.png": 416389,
	"./stocks/LIXT.png": 226072,
	"./stocks/LIZI.png": 114231,
	"./stocks/LJAQ.png": 736645,
	"./stocks/LJPC.png": 598563,
	"./stocks/LKCO.png": 424278,
	"./stocks/LKQ.png": 539657,
	"./stocks/LL.png": 871978,
	"./stocks/LLAP.png": 102975,
	"./stocks/LLL.png": 963943,
	"./stocks/LLNW.png": 582935,
	"./stocks/LLY.png": 958095,
	"./stocks/LMAO.png": 761910,
	"./stocks/LMAT.png": 870668,
	"./stocks/LMB.png": 976681,
	"./stocks/LMDX.png": 632305,
	"./stocks/LMFA.png": 911315,
	"./stocks/LMND.png": 408205,
	"./stocks/LMNL.png": 970837,
	"./stocks/LMNR.png": 156500,
	"./stocks/LMPX.png": 260616,
	"./stocks/LMRK.png": 266195,
	"./stocks/LMT.png": 141240,
	"./stocks/LN.png": 438119,
	"./stocks/LNC.png": 522784,
	"./stocks/LNG.png": 928359,
	"./stocks/LNKS.png": 688514,
	"./stocks/LNSR.png": 206855,
	"./stocks/LNT.png": 767150,
	"./stocks/LNTH.png": 9246,
	"./stocks/LNW.png": 911825,
	"./stocks/LOCL.png": 292141,
	"./stocks/LOCO.png": 493031,
	"./stocks/LODE.png": 848312,
	"./stocks/LOGC.png": 757606,
	"./stocks/LOGI.png": 265117,
	"./stocks/LOMA.png": 444825,
	"./stocks/LONM.png": 802054,
	"./stocks/LOOP.png": 470287,
	"./stocks/LOPE.png": 584446,
	"./stocks/LOTS.png": 409991,
	"./stocks/LOTZ.png": 733795,
	"./stocks/LOW.png": 793787,
	"./stocks/LPA.png": 88851,
	"./stocks/LPCN.png": 107651,
	"./stocks/LPG.png": 342259,
	"./stocks/LPL.png": 595037,
	"./stocks/LPRO.png": 362359,
	"./stocks/LPSN.png": 249408,
	"./stocks/LPT.png": 140999,
	"./stocks/LPTH.png": 968466,
	"./stocks/LPTV.png": 671831,
	"./stocks/LPTX.png": 866570,
	"./stocks/LPX.png": 370371,
	"./stocks/LQDA.png": 38629,
	"./stocks/LQDT.png": 329218,
	"./stocks/LQR.png": 761239,
	"./stocks/LRCX.png": 188546,
	"./stocks/LRFC.png": 24149,
	"./stocks/LRHC.png": 127414,
	"./stocks/LRMR.png": 136872,
	"./stocks/LRN.png": 665738,
	"./stocks/LSAQ.png": 582107,
	"./stocks/LSCC.png": 587000,
	"./stocks/LSDI.png": 930940,
	"./stocks/LSE.png": 101343,
	"./stocks/LSEA.png": 354209,
	"./stocks/LSF.png": 519349,
	"./stocks/LSH.png": 674412,
	"./stocks/LSI.png": 517697,
	"./stocks/LSPD.png": 789949,
	"./stocks/LSTR.png": 900401,
	"./stocks/LSXMA.png": 551883,
	"./stocks/LSXMB.png": 707150,
	"./stocks/LSXMK.png": 877227,
	"./stocks/LTBR.png": 786062,
	"./stocks/LTC.png": 735730,
	"./stocks/LTCH.png": 279391,
	"./stocks/LTCHW.png": 258746,
	"./stocks/LTH.png": 223534,
	"./stocks/LTHM.png": 584054,
	"./stocks/LTRN.png": 970361,
	"./stocks/LTRPA.png": 199727,
	"./stocks/LTRX.png": 913274,
	"./stocks/LTRY.png": 277851,
	"./stocks/LU.png": 643369,
	"./stocks/LUB.png": 740961,
	"./stocks/LUCD.png": 739867,
	"./stocks/LUCY.png": 259760,
	"./stocks/LULU.png": 693182,
	"./stocks/LUMN.png": 523715,
	"./stocks/LUMO.png": 140842,
	"./stocks/LUNG.png": 586661,
	"./stocks/LUNR.png": 701707,
	"./stocks/LUV.png": 863722,
	"./stocks/LUXH.png": 339453,
	"./stocks/LVAC.png": 922509,
	"./stocks/LVLU.png": 112282,
	"./stocks/LVO.png": 216690,
	"./stocks/LVOX.png": 414947,
	"./stocks/LVS.png": 877225,
	"./stocks/LVTX.png": 346825,
	"./stocks/LW.png": 850775,
	"./stocks/LWAC.png": 512142,
	"./stocks/LWLG.png": 391314,
	"./stocks/LX.png": 189758,
	"./stocks/LXEH.png": 116538,
	"./stocks/LXFR.png": 379548,
	"./stocks/LXRX.png": 683929,
	"./stocks/LXU.png": 774104,
	"./stocks/LYB.png": 725293,
	"./stocks/LYEL.png": 934224,
	"./stocks/LYFT.png": 442595,
	"./stocks/LYG.png": 595978,
	"./stocks/LYRA.png": 350221,
	"./stocks/LYT.png": 50058,
	"./stocks/LYTS.png": 160185,
	"./stocks/LYV.png": 818633,
	"./stocks/LZ.png": 558330,
	"./stocks/LZB.png": 812692,
	"./stocks/LZMH.png": 715585,
	"./stocks/M.png": 326262,
	"./stocks/MA.png": 528158,
	"./stocks/MACA.png": 696760,
	"./stocks/MACAU.png": 449973,
	"./stocks/MACK.png": 999963,
	"./stocks/MAIA.png": 785874,
	"./stocks/MAIN.png": 649546,
	"./stocks/MAMA.png": 661079,
	"./stocks/MAN.png": 548131,
	"./stocks/MANH.png": 788383,
	"./stocks/MANU.png": 417089,
	"./stocks/MAPS.png": 38406,
	"./stocks/MAPSW.png": 491674,
	"./stocks/MAR.png": 241181,
	"./stocks/MARA.png": 623725,
	"./stocks/MARK.png": 953817,
	"./stocks/MARPS.png": 316577,
	"./stocks/MASI.png": 74343,
	"./stocks/MASS.png": 404720,
	"./stocks/MAT.png": 621294,
	"./stocks/MATW.png": 493989,
	"./stocks/MATX.png": 292525,
	"./stocks/MAX.png": 460777,
	"./stocks/MAXN.png": 794764,
	"./stocks/MAXR.png": 15860,
	"./stocks/MBC.png": 667515,
	"./stocks/MBCN.png": 81782,
	"./stocks/MBII.png": 647789,
	"./stocks/MBIN.png": 515797,
	"./stocks/MBINN.png": 380052,
	"./stocks/MBINO.png": 785350,
	"./stocks/MBINP.png": 593142,
	"./stocks/MBIO.png": 895315,
	"./stocks/MBLY.png": 969034,
	"./stocks/MBOT.png": 356664,
	"./stocks/MBRX.png": 250502,
	"./stocks/MBT.png": 897919,
	"./stocks/MBUU.png": 629967,
	"./stocks/MBWM.png": 792977,
	"./stocks/MC.png": 613165,
	"./stocks/MCA.png": 315621,
	"./stocks/MCAF.png": 837730,
	"./stocks/MCB.png": 602749,
	"./stocks/MCBC.png": 584134,
	"./stocks/MCD.png": 463968,
	"./stocks/MCFE.png": 59763,
	"./stocks/MCFT.png": 439501,
	"./stocks/MCHP.png": 598429,
	"./stocks/MCHX.png": 460006,
	"./stocks/MCK.png": 715579,
	"./stocks/MCLD.png": 956055,
	"./stocks/MCO.png": 433494,
	"./stocks/MCOM.png": 171282,
	"./stocks/MCR.png": 566406,
	"./stocks/MCRB.png": 804061,
	"./stocks/MCTR.png": 815542,
	"./stocks/MCVT.png": 199238,
	"./stocks/MD.png": 679000,
	"./stocks/MDAI.png": 272560,
	"./stocks/MDB.png": 902977,
	"./stocks/MDBH.png": 573882,
	"./stocks/MDC.png": 523719,
	"./stocks/MDGS.png": 621986,
	"./stocks/MDH.png": 51247,
	"./stocks/MDIA.png": 902985,
	"./stocks/MDJH.png": 782585,
	"./stocks/MDLZ.png": 417109,
	"./stocks/MDNA.png": 440031,
	"./stocks/MDRX.png": 978280,
	"./stocks/MDT.png": 447078,
	"./stocks/MDVA.png": 608686,
	"./stocks/MDVL.png": 641903,
	"./stocks/MDWD.png": 640840,
	"./stocks/MDWT.png": 541164,
	"./stocks/MDXG.png": 295156,
	"./stocks/MDXH.png": 940446,
	"./stocks/ME.png": 696097,
	"./stocks/MEACW.png": 340159,
	"./stocks/MEC.png": 302743,
	"./stocks/MED.png": 174754,
	"./stocks/MEDP.png": 450077,
	"./stocks/MEDS.png": 605636,
	"./stocks/MEG.png": 586889,
	"./stocks/MEGL.png": 829844,
	"./stocks/MEI.png": 178445,
	"./stocks/MEIP.png": 395033,
	"./stocks/MELI.png": 106470,
	"./stocks/MEOA.png": 989698,
	"./stocks/MEOH.png": 332777,
	"./stocks/MERC.png": 7293,
	"./stocks/MERCK.png": 376906,
	"./stocks/MESA.png": 101742,
	"./stocks/MESO.png": 512576,
	"./stocks/MET.png": 762968,
	"./stocks/META.png": 661505,
	"./stocks/METC.png": 599450,
	"./stocks/METX.png": 106635,
	"./stocks/MEUSW.png": 886955,
	"./stocks/MF.png": 317439,
	"./stocks/MFC.png": 85944,
	"./stocks/MFD.png": 443540,
	"./stocks/MFG.png": 813548,
	"./stocks/MFGP.png": 37769,
	"./stocks/MFH.png": 205440,
	"./stocks/MFI.png": 16978,
	"./stocks/MFIN.png": 560593,
	"./stocks/MFL.png": 537477,
	"./stocks/MFM.png": 286315,
	"./stocks/MFV.png": 895097,
	"./stocks/MG.png": 472433,
	"./stocks/MGA.png": 688184,
	"./stocks/MGAM.png": 87386,
	"./stocks/MGEE.png": 646231,
	"./stocks/MGF.png": 609034,
	"./stocks/MGIC.png": 397118,
	"./stocks/MGIH.png": 644684,
	"./stocks/MGLN.png": 342914,
	"./stocks/MGM.png": 435242,
	"./stocks/MGNI.png": 441142,
	"./stocks/MGNX.png": 745947,
	"./stocks/MGOL.png": 480246,
	"./stocks/MGP.png": 915376,
	"./stocks/MGRC.png": 275563,
	"./stocks/MGRM.png": 647994,
	"./stocks/MGRX.png": 685018,
	"./stocks/MGTA.png": 909775,
	"./stocks/MGTX.png": 195255,
	"./stocks/MGU.png": 165195,
	"./stocks/MGX.png": 902495,
	"./stocks/MGY.png": 295575,
	"./stocks/MGYR.png": 868556,
	"./stocks/MHD.png": 530932,
	"./stocks/MHI.png": 141369,
	"./stocks/MHK.png": 131085,
	"./stocks/MHN.png": 210728,
	"./stocks/MHO.png": 472220,
	"./stocks/MHUA.png": 861498,
	"./stocks/MI.png": 236041,
	"./stocks/MICS.png": 168453,
	"./stocks/MICT.png": 97441,
	"./stocks/MIGI.png": 816655,
	"./stocks/MILE.png": 77402,
	"./stocks/MIME.png": 536480,
	"./stocks/MIMO.png": 677234,
	"./stocks/MIN.png": 792994,
	"./stocks/MIND.png": 119,
	"./stocks/MINDP.png": 816679,
	"./stocks/MINM.png": 668694,
	"./stocks/MIRA.png": 191864,
	"./stocks/MIRM.png": 238420,
	"./stocks/MIRO.png": 658129,
	"./stocks/MIST.png": 732122,
	"./stocks/MITA.png": 725890,
	"./stocks/MITC.png": 27918,
	"./stocks/MITK.png": 677489,
	"./stocks/MITO.png": 601703,
	"./stocks/MITQ.png": 41659,
	"./stocks/MIXT.png": 150338,
	"./stocks/MIY.png": 12826,
	"./stocks/MKC.png": 830026,
	"./stocks/MKFG.png": 987075,
	"./stocks/MKSI.png": 986834,
	"./stocks/MKTW.png": 435763,
	"./stocks/MKTX.png": 625652,
	"./stocks/MKTY.png": 499457,
	"./stocks/MKTYP.png": 39613,
	"./stocks/MKUL.png": 401478,
	"./stocks/ML.png": 279390,
	"./stocks/MLAB.png": 908989,
	"./stocks/MLAC.png": 95035,
	"./stocks/MLCO.png": 917571,
	"./stocks/MLEC.png": 486241,
	"./stocks/MLGO.png": 866899,
	"./stocks/MLI.png": 640190,
	"./stocks/MLM.png": 169104,
	"./stocks/MLNK.png": 496923,
	"./stocks/MLR.png": 348639,
	"./stocks/MMA.png": 403132,
	"./stocks/MMAT.png": 740756,
	"./stocks/MMC.png": 943559,
	"./stocks/MMD.png": 806510,
	"./stocks/MMI.png": 23145,
	"./stocks/MMLP.png": 493456,
	"./stocks/MMM.png": 232014,
	"./stocks/MMMB.png": 427116,
	"./stocks/MMP.png": 855680,
	"./stocks/MMS.png": 633507,
	"./stocks/MMSI.png": 932768,
	"./stocks/MMT.png": 683808,
	"./stocks/MMTIF.png": 414467,
	"./stocks/MMTLP.png": 121784,
	"./stocks/MMV.png": 731472,
	"./stocks/MN.png": 462221,
	"./stocks/MNDO.png": 123303,
	"./stocks/MNDR.png": 436348,
	"./stocks/MNDT.png": 182657,
	"./stocks/MNDY.png": 799752,
	"./stocks/MNK.png": 132066,
	"./stocks/MNKD.png": 105226,
	"./stocks/MNMD.png": 727713,
	"./stocks/MNPR.png": 630839,
	"./stocks/MNR.png": 238728,
	"./stocks/MNRO.png": 893277,
	"./stocks/MNSO.png": 377407,
	"./stocks/MNST.png": 43453,
	"./stocks/MNTS.png": 761695,
	"./stocks/MNTV.png": 58115,
	"./stocks/MNY.png": 729510,
	"./stocks/MO.png": 196432,
	"./stocks/MOB.png": 957950,
	"./stocks/MOBQ.png": 330308,
	"./stocks/MOBX.png": 678127,
	"./stocks/MOD.png": 524748,
	"./stocks/MODD.png": 14763,
	"./stocks/MODG.png": 498046,
	"./stocks/MODN.png": 563035,
	"./stocks/MOFG.png": 129217,
	"./stocks/MOGO.png": 384631,
	"./stocks/MOGU.png": 322092,
	"./stocks/MOH.png": 917019,
	"./stocks/MOHO.png": 90915,
	"./stocks/MOLN.png": 659912,
	"./stocks/MOMO.png": 204051,
	"./stocks/MON.png": 224326,
	"./stocks/MOR.png": 500083,
	"./stocks/MORF.png": 197084,
	"./stocks/MORN.png": 882584,
	"./stocks/MOS.png": 62405,
	"./stocks/MOSY.png": 637927,
	"./stocks/MOTS.png": 72775,
	"./stocks/MOVE.png": 419582,
	"./stocks/MOXC.png": 356358,
	"./stocks/MP.png": 968636,
	"./stocks/MPA.png": 822132,
	"./stocks/MPAC.png": 422184,
	"./stocks/MPB.png": 373210,
	"./stocks/MPC.png": 684387,
	"./stocks/MPLN.png": 211027,
	"./stocks/MPLX.png": 505967,
	"./stocks/MPTI.png": 829283,
	"./stocks/MPW.png": 797248,
	"./stocks/MQ.png": 912955,
	"./stocks/MQT.png": 403430,
	"./stocks/MQY.png": 263796,
	"./stocks/MRAI.png": 506464,
	"./stocks/MRAM.png": 575169,
	"./stocks/MRBK.png": 324151,
	"./stocks/MRC.png": 459227,
	"./stocks/MRCC.png": 284144,
	"./stocks/MRDB.png": 545530,
	"./stocks/MREO.png": 112012,
	"./stocks/MRIN.png": 751624,
	"./stocks/MRK.png": 472730,
	"./stocks/MRKR.png": 598815,
	"./stocks/MRLN.png": 240479,
	"./stocks/MRM.png": 444687,
	"./stocks/MRNA.png": 431774,
	"./stocks/MRNO.png": 594095,
	"./stocks/MRNS.png": 754949,
	"./stocks/MRO.png": 708574,
	"./stocks/MRSN.png": 812237,
	"./stocks/MRT.png": 202599,
	"./stocks/MRTX.png": 458284,
	"./stocks/MRVL.png": 962744,
	"./stocks/MS.png": 149551,
	"./stocks/MSA.png": 260481,
	"./stocks/MSAC.png": 132778,
	"./stocks/MSAI.png": 681130,
	"./stocks/MSB.png": 945262,
	"./stocks/MSBI.png": 567133,
	"./stocks/MSC.png": 560517,
	"./stocks/MSCI.png": 985690,
	"./stocks/MSDA.png": 17737,
	"./stocks/MSDAU.png": 331864,
	"./stocks/MSFT.png": 951681,
	"./stocks/MSGM.png": 693509,
	"./stocks/MSGN.png": 407097,
	"./stocks/MSGS.png": 101174,
	"./stocks/MSI.png": 44173,
	"./stocks/MSM.png": 712057,
	"./stocks/MSN.png": 187459,
	"./stocks/MSON.png": 186259,
	"./stocks/MSP.png": 345883,
	"./stocks/MSPR.png": 747195,
	"./stocks/MSS.png": 185837,
	"./stocks/MSTR.png": 340668,
	"./stocks/MSW.png": 240420,
	"./stocks/MT.png": 271566,
	"./stocks/MTA.png": 853891,
	"./stocks/MTB.png": 297671,
	"./stocks/MTBC.png": 585580,
	"./stocks/MTBCP.png": 705336,
	"./stocks/MTC.png": 572403,
	"./stocks/MTCH.png": 968449,
	"./stocks/MTD.png": 893917,
	"./stocks/MTDR.png": 155516,
	"./stocks/MTEM.png": 947372,
	"./stocks/MTEX.png": 707233,
	"./stocks/MTH.png": 433993,
	"./stocks/MTL.png": 445682,
	"./stocks/MTLS.png": 66853,
	"./stocks/MTN.png": 134612,
	"./stocks/MTNB.png": 181179,
	"./stocks/MTOR.png": 444834,
	"./stocks/MTP.png": 980647,
	"./stocks/MTRN.png": 764500,
	"./stocks/MTRX.png": 107234,
	"./stocks/MTSI.png": 280251,
	"./stocks/MTSR.png": 126953,
	"./stocks/MTSS.png": 53022,
	"./stocks/MTTR.png": 859138,
	"./stocks/MTW.png": 408814,
	"./stocks/MTX.png": 914279,
	"./stocks/MTZ.png": 463929,
	"./stocks/MU.png": 20829,
	"./stocks/MUA.png": 713890,
	"./stocks/MUC.png": 383264,
	"./stocks/MUE.png": 779575,
	"./stocks/MUFG.png": 219382,
	"./stocks/MUI.png": 450813,
	"./stocks/MUJ.png": 5209,
	"./stocks/MULN.png": 165399,
	"./stocks/MUX.png": 722749,
	"./stocks/MVBF.png": 353360,
	"./stocks/MVF.png": 497820,
	"./stocks/MVIS.png": 522772,
	"./stocks/MVLA.png": 78010,
	"./stocks/MVST.png": 273092,
	"./stocks/MVT.png": 334932,
	"./stocks/MWG.png": 883825,
	"./stocks/MX.png": 191511,
	"./stocks/MXC.png": 734665,
	"./stocks/MXCT.png": 36818,
	"./stocks/MYC.png": 577838,
	"./stocks/MYD.png": 235319,
	"./stocks/MYE.png": 546334,
	"./stocks/MYFW.png": 696291,
	"./stocks/MYGN.png": 734914,
	"./stocks/MYI.png": 104519,
	"./stocks/MYJ.png": 564839,
	"./stocks/MYMD.png": 66283,
	"./stocks/MYN.png": 187808,
	"./stocks/MYNA.png": 755362,
	"./stocks/MYOV.png": 786111,
	"./stocks/MYRG.png": 496709,
	"./stocks/MYSZ.png": 182733,
	"./stocks/MYTE.png": 535487,
	"./stocks/NA.png": 301634,
	"./stocks/NAAS.png": 121679,
	"./stocks/NABL.png": 867581,
	"./stocks/NAK.png": 262074,
	"./stocks/NAKD.png": 134827,
	"./stocks/NAMI.png": 260361,
	"./stocks/NAOV.png": 954664,
	"./stocks/NARI.png": 866868,
	"./stocks/NAT.png": 767275,
	"./stocks/NATH.png": 783503,
	"./stocks/NATI.png": 949101,
	"./stocks/NAUT.png": 926854,
	"./stocks/NAVB.png": 625002,
	"./stocks/NB.png": 609519,
	"./stocks/NBEV.png": 100155,
	"./stocks/NBIS.png": 121107,
	"./stocks/NBL.png": 486364,
	"./stocks/NBN.png": 27019,
	"./stocks/NBR.png": 179499,
	"./stocks/NBRV.png": 841306,
	"./stocks/NBSE.png": 703977,
	"./stocks/NBTX.png": 611523,
	"./stocks/NBY.png": 201449,
	"./stocks/NCI.png": 916069,
	"./stocks/NCL.png": 617802,
	"./stocks/NCLH.png": 760175,
	"./stocks/NCMI.png": 417589,
	"./stocks/NCNA.png": 552293,
	"./stocks/NCNC.png": 726193,
	"./stocks/NCPL.png": 29330,
	"./stocks/NCR.png": 449377,
	"./stocks/NCRA.png": 418919,
	"./stocks/NCSM.png": 303479,
	"./stocks/NCTY.png": 905909,
	"./stocks/NCV.png": 276856,
	"./stocks/NDAQ.png": 391872,
	"./stocks/NDLS.png": 462149,
	"./stocks/NDRA.png": 431781,
	"./stocks/NDSN.png": 104258,
	"./stocks/NDX.png": 768776,
	"./stocks/NE.png": 207658,
	"./stocks/NEE.png": 838589,
	"./stocks/NEGG.png": 39136,
	"./stocks/NEM.png": 733528,
	"./stocks/NEMKY.png": 795590,
	"./stocks/NEO.png": 687425,
	"./stocks/NEOG.png": 494067,
	"./stocks/NEON.png": 941163,
	"./stocks/NEPH.png": 191134,
	"./stocks/NEPT.png": 991942,
	"./stocks/NERV.png": 136523,
	"./stocks/NES.png": 238591,
	"./stocks/NET.png": 885943,
	"./stocks/NETE.png": 460471,
	"./stocks/NETI.png": 619845,
	"./stocks/NEU.png": 261969,
	"./stocks/NEUE.png": 950813,
	"./stocks/NEUP.png": 397591,
	"./stocks/NEWR.png": 303746,
	"./stocks/NEWT.png": 665234,
	"./stocks/NEX.png": 744744,
	"./stocks/NEXI.png": 313494,
	"./stocks/NEXT.png": 802387,
	"./stocks/NFBK.png": 403040,
	"./stocks/NFE.png": 991322,
	"./stocks/NFLX.png": 748051,
	"./stocks/NFTG.png": 604848,
	"./stocks/NGG.png": 92119,
	"./stocks/NGL.png": 854948,
	"./stocks/NGM.png": 596531,
	"./stocks/NGVC.png": 526894,
	"./stocks/NGVT.png": 324993,
	"./stocks/NH.png": 621322,
	"./stocks/NHWK.png": 781801,
	"./stocks/NI.png": 883462,
	"./stocks/NICE.png": 936390,
	"./stocks/NIE.png": 866262,
	"./stocks/NIFTY50.png": 519018,
	"./stocks/NILE.png": 906111,
	"./stocks/NIMC.png": 537656,
	"./stocks/NINE.png": 509290,
	"./stocks/NIO.png": 816675,
	"./stocks/NIR.png": 888300,
	"./stocks/NITO.png": 362890,
	"./stocks/NIU.png": 418717,
	"./stocks/NIVF.png": 739558,
	"./stocks/NIXX.png": 398337,
	"./stocks/NKE.png": 664354,
	"./stocks/NKEL.png": 714990,
	"./stocks/NKEW.png": 952183,
	"./stocks/NKGN.png": 477091,
	"./stocks/NKLA.png": 595377,
	"./stocks/NKTX.png": 238494,
	"./stocks/NL.png": 43481,
	"./stocks/NLCP.png": 772977,
	"./stocks/NLOK.png": 242507,
	"./stocks/NLS.png": 69377,
	"./stocks/NLSN.png": 364519,
	"./stocks/NLSP.png": 579176,
	"./stocks/NLTX.png": 456084,
	"./stocks/NLY.png": 363458,
	"./stocks/NMG.png": 368378,
	"./stocks/NMHI.png": 231049,
	"./stocks/NMIH.png": 683850,
	"./stocks/NMMC.png": 619716,
	"./stocks/NMR.png": 959497,
	"./stocks/NMRA.png": 953576,
	"./stocks/NMRD.png": 163833,
	"./stocks/NMRK.png": 931593,
	"./stocks/NMTC.png": 384363,
	"./stocks/NMTR.png": 440440,
	"./stocks/NN.png": 185496,
	"./stocks/NNBR.png": 232174,
	"./stocks/NNDM.png": 245083,
	"./stocks/NNE.png": 351893,
	"./stocks/NNI.png": 13646,
	"./stocks/NNIV.png": 804826,
	"./stocks/NNN.png": 568237,
	"./stocks/NNOX.png": 194679,
	"./stocks/NNVC.png": 588759,
	"./stocks/NOC.png": 839016,
	"./stocks/NOGN.png": 276851,
	"./stocks/NOGNW.png": 138354,
	"./stocks/NOK.png": 47167,
	"./stocks/NOTE.png": 245326,
	"./stocks/NOTE2.png": 221485,
	"./stocks/NOTV.png": 911086,
	"./stocks/NOV.png": 82700,
	"./stocks/NOVA.png": 7583,
	"./stocks/NOVN.png": 574855,
	"./stocks/NOVT.png": 243608,
	"./stocks/NOW.png": 318002,
	"./stocks/NPCE.png": 363911,
	"./stocks/NPTN.png": 84375,
	"./stocks/NPV.png": 728345,
	"./stocks/NRBO.png": 310569,
	"./stocks/NRC.png": 815068,
	"./stocks/NRDS.png": 134712,
	"./stocks/NRDY.png": 356064,
	"./stocks/NRG.png": 266972,
	"./stocks/NRGV.png": 821115,
	"./stocks/NRIX.png": 109056,
	"./stocks/NRSN.png": 807951,
	"./stocks/NRXP.png": 371639,
	"./stocks/NRXPW.png": 553702,
	"./stocks/NRZ.png": 193337,
	"./stocks/NS.png": 492913,
	"./stocks/NSA.png": 441917,
	"./stocks/NSC.png": 987674,
	"./stocks/NSDQ.png": 934631,
	"./stocks/NSIT.png": 878095,
	"./stocks/NSP.png": 634384,
	"./stocks/NSPR.png": 864192,
	"./stocks/NSSC.png": 160284,
	"./stocks/NSTG.png": 384316,
	"./stocks/NSTS.png": 186191,
	"./stocks/NSYS.png": 299445,
	"./stocks/NTAP.png": 707594,
	"./stocks/NTB.png": 991123,
	"./stocks/NTBL.png": 962554,
	"./stocks/NTCO.png": 458216,
	"./stocks/NTCT.png": 291776,
	"./stocks/NTES.png": 659893,
	"./stocks/NTLA.png": 986462,
	"./stocks/NTNX.png": 225142,
	"./stocks/NTR.png": 800694,
	"./stocks/NTRA.png": 306031,
	"./stocks/NTRB.png": 726269,
	"./stocks/NTRBW.png": 353929,
	"./stocks/NTRS.png": 538113,
	"./stocks/NTRSO.png": 640056,
	"./stocks/NTWK.png": 608559,
	"./stocks/NTZ.png": 95328,
	"./stocks/NU.png": 945403,
	"./stocks/NUAN.png": 649329,
	"./stocks/NUE.png": 88096,
	"./stocks/NUKK.png": 220691,
	"./stocks/NURO.png": 539020,
	"./stocks/NUTX.png": 338055,
	"./stocks/NUVA.png": 363738,
	"./stocks/NUVL.png": 420284,
	"./stocks/NUVO.png": 246256,
	"./stocks/NUWE.png": 286541,
	"./stocks/NUZE.png": 595367,
	"./stocks/NVAX.png": 934292,
	"./stocks/NVCN.png": 390704,
	"./stocks/NVCR.png": 768294,
	"./stocks/NVCT.png": 834238,
	"./stocks/NVDA.png": 462273,
	"./stocks/NVEC.png": 794526,
	"./stocks/NVEE.png": 506409,
	"./stocks/NVEI.png": 889775,
	"./stocks/NVFY.png": 314634,
	"./stocks/NVGS.png": 817129,
	"./stocks/NVIV.png": 76442,
	"./stocks/NVNI.png": 990000,
	"./stocks/NVNO.png": 241510,
	"./stocks/NVO.png": 915648,
	"./stocks/NVOS.png": 964353,
	"./stocks/NVRO.png": 724891,
	"./stocks/NVS.png": 463813,
	"./stocks/NVST.png": 961745,
	"./stocks/NVT.png": 900641,
	"./stocks/NVTA.png": 314488,
	"./stocks/NVVE.png": 283484,
	"./stocks/NVX.png": 612946,
	"./stocks/NWBI.png": 318436,
	"./stocks/NWE.png": 16737,
	"./stocks/NWFL.png": 502504,
	"./stocks/NWG.png": 59421,
	"./stocks/NWL.png": 374168,
	"./stocks/NWN.png": 790842,
	"./stocks/NWPX.png": 150592,
	"./stocks/NWS.png": 556562,
	"./stocks/NWSA.png": 607283,
	"./stocks/NWTN.png": 625935,
	"./stocks/NX.png": 845219,
	"./stocks/NXGL.png": 169400,
	"./stocks/NXL.png": 101708,
	"./stocks/NXPI.png": 401905,
	"./stocks/NXPL.png": 791558,
	"./stocks/NXST.png": 365233,
	"./stocks/NXTC.png": 671688,
	"./stocks/NXTD.png": 137887,
	"./stocks/NXTP.png": 368343,
	"./stocks/NXTT.png": 616591,
	"./stocks/NXU.png": 797990,
	"./stocks/NYC.png": 682408,
	"./stocks/NYCB.png": 56638,
	"./stocks/NYMT.png": 622798,
	"./stocks/NYXH.png": 115882,
	"./stocks/O.png": 955576,
	"./stocks/OACB.png": 875395,
	"./stocks/OBCI.png": 862862,
	"./stocks/OBIO.png": 401592,
	"./stocks/OBLG.png": 89076,
	"./stocks/OBNK.png": 493137,
	"./stocks/OBSV.png": 479995,
	"./stocks/OC.png": 754927,
	"./stocks/OCA.png": 803738,
	"./stocks/OCAX.png": 6437,
	"./stocks/OCC.png": 885528,
	"./stocks/OCCI.png": 193740,
	"./stocks/OCDX.png": 244982,
	"./stocks/OCEA.png": 465781,
	"./stocks/OCFC.png": 655657,
	"./stocks/OCFCP.png": 875501,
	"./stocks/OCFT.png": 792249,
	"./stocks/OCG.png": 970602,
	"./stocks/OCGN.png": 961904,
	"./stocks/OCIO.png": 805241,
	"./stocks/OCN.png": 445370,
	"./stocks/OCSL.png": 238845,
	"./stocks/OCTO.png": 60951,
	"./stocks/OCUL.png": 917245,
	"./stocks/OCUP.png": 892042,
	"./stocks/OCX.png": 964802,
	"./stocks/ODC.png": 884438,
	"./stocks/ODFL.png": 660990,
	"./stocks/ODT.png": 394790,
	"./stocks/OEG.png": 567224,
	"./stocks/OESX.png": 279404,
	"./stocks/OFC.png": 893370,
	"./stocks/OFIX.png": 243073,
	"./stocks/OG.png": 956412,
	"./stocks/OGC.png": 935091,
	"./stocks/OGE.png": 633412,
	"./stocks/OGEN.png": 341315,
	"./stocks/OGI.png": 448756,
	"./stocks/OGN.png": 109995,
	"./stocks/OGS.png": 911692,
	"./stocks/OHI.png": 541219,
	"./stocks/OI.png": 799686,
	"./stocks/OIA.png": 870306,
	"./stocks/OII.png": 225080,
	"./stocks/OIS.png": 549141,
	"./stocks/OKE.png": 832277,
	"./stocks/OKLO.png": 270434,
	"./stocks/OKTA.png": 764262,
	"./stocks/OKYO.png": 354937,
	"./stocks/OLB.png": 489418,
	"./stocks/OLD.png": 698330,
	"./stocks/OLED.png": 73410,
	"./stocks/OLK.png": 346852,
	"./stocks/OLLI.png": 427632,
	"./stocks/OLN.png": 176017,
	"./stocks/OLO.png": 322681,
	"./stocks/OLP.png": 475612,
	"./stocks/OLPX.png": 579426,
	"./stocks/OM.png": 347604,
	"./stocks/OMAB.png": 389446,
	"./stocks/OMC.png": 36559,
	"./stocks/OMCL.png": 530485,
	"./stocks/OMEG.png": 790683,
	"./stocks/OMER.png": 472981,
	"./stocks/OMEX.png": 824938,
	"./stocks/OMGA.png": 432461,
	"./stocks/OMH.png": 18995,
	"./stocks/OMI.png": 828605,
	"./stocks/OMIC.png": 915419,
	"./stocks/OMQS.png": 94715,
	"./stocks/ON.png": 989442,
	"./stocks/ONB.png": 441746,
	"./stocks/ONCO.png": 133583,
	"./stocks/ONCR.png": 154930,
	"./stocks/ONCS.png": 212186,
	"./stocks/ONCT.png": 976251,
	"./stocks/ONCY.png": 646952,
	"./stocks/ONDS.png": 515767,
	"./stocks/ONEM.png": 621800,
	"./stocks/ONEW.png": 6375,
	"./stocks/ONFO.png": 878244,
	"./stocks/ONMD.png": 487770,
	"./stocks/ONON.png": 528694,
	"./stocks/ONTF.png": 787016,
	"./stocks/ONTX.png": 452621,
	"./stocks/ONVO.png": 906117,
	"./stocks/OOMA.png": 532758,
	"./stocks/OP.png": 886283,
	"./stocks/OPAD.png": 184289,
	"./stocks/OPAL.png": 547625,
	"./stocks/OPCH.png": 263525,
	"./stocks/OPEN.png": 253407,
	"./stocks/OPER.png": 878765,
	"./stocks/OPFI.png": 162596,
	"./stocks/OPGN.png": 575548,
	"./stocks/OPHC.png": 160757,
	"./stocks/OPI.png": 849403,
	"./stocks/OPK.png": 286194,
	"./stocks/OPNT.png": 937575,
	"./stocks/OPOF.png": 948298,
	"./stocks/OPRA.png": 743445,
	"./stocks/OPRT.png": 320936,
	"./stocks/OPRX.png": 445657,
	"./stocks/OPT.png": 773576,
	"./stocks/OPTN.png": 341267,
	"./stocks/OPTT.png": 485224,
	"./stocks/OPTX.png": 49920,
	"./stocks/ORA.png": 78429,
	"./stocks/ORCC.png": 349900,
	"./stocks/ORCL.png": 416695,
	"./stocks/ORGO.png": 167509,
	"./stocks/ORGS.png": 359819,
	"./stocks/ORI.png": 533029,
	"./stocks/ORIC.png": 548000,
	"./stocks/ORIS.png": 637962,
	"./stocks/ORKT.png": 94309,
	"./stocks/ORLY.png": 853559,
	"./stocks/ORMP.png": 238014,
	"./stocks/ORN.png": 720834,
	"./stocks/ORPH.png": 376953,
	"./stocks/ORTX.png": 288058,
	"./stocks/OSAT.png": 236160,
	"./stocks/OSBC.png": 506418,
	"./stocks/OSCR.png": 40840,
	"./stocks/OSH.png": 533063,
	"./stocks/OSK.png": 888661,
	"./stocks/OSPN.png": 58546,
	"./stocks/OSRH.png": 112377,
	"./stocks/OST.png": 978686,
	"./stocks/OSTK.png": 134094,
	"./stocks/OSTX.png": 437340,
	"./stocks/OSUR.png": 877191,
	"./stocks/OSW.png": 102836,
	"./stocks/OTIC.png": 900048,
	"./stocks/OTIS.png": 659969,
	"./stocks/OTLK.png": 354064,
	"./stocks/OTLY.png": 470208,
	"./stocks/OTMO.png": 842714,
	"./stocks/OTRK.png": 895992,
	"./stocks/OTRKP.png": 402001,
	"./stocks/OUT.png": 492541,
	"./stocks/OVBC.png": 738196,
	"./stocks/OVID.png": 434898,
	"./stocks/OVV.png": 45298,
	"./stocks/OWL.png": 394872,
	"./stocks/OWLT.png": 247114,
	"./stocks/OXM.png": 326879,
	"./stocks/OXY.png": 212115,
	"./stocks/OYST.png": 891755,
	"./stocks/OZK.png": 828978,
	"./stocks/OZON.png": 284498,
	"./stocks/OZSC.png": 943947,
	"./stocks/PAA.png": 942498,
	"./stocks/PAAS.png": 689524,
	"./stocks/PAC.png": 466255,
	"./stocks/PACB.png": 95095,
	"./stocks/PACI.png": 40706,
	"./stocks/PACK.png": 622696,
	"./stocks/PACW.png": 648819,
	"./stocks/PAE.png": 908686,
	"./stocks/PAG.png": 870242,
	"./stocks/PAGP.png": 315443,
	"./stocks/PAGS.png": 225195,
	"./stocks/PAHC.png": 530065,
	"./stocks/PAL.png": 961192,
	"./stocks/PALI.png": 482348,
	"./stocks/PALT.png": 244103,
	"./stocks/PAM.png": 132102,
	"./stocks/PANL.png": 340560,
	"./stocks/PANW.png": 553195,
	"./stocks/PARA.png": 582706,
	"./stocks/PARR.png": 974160,
	"./stocks/PASG.png": 501677,
	"./stocks/PATH.png": 932939,
	"./stocks/PATK.png": 713241,
	"./stocks/PAVM.png": 81115,
	"./stocks/PAVMW.png": 323751,
	"./stocks/PAVS.png": 257300,
	"./stocks/PAY.png": 581125,
	"./stocks/PAYA.png": 103843,
	"./stocks/PAYO.png": 616737,
	"./stocks/PAYS.png": 980365,
	"./stocks/PAYX.png": 581136,
	"./stocks/PBA.png": 999376,
	"./stocks/PBBK.png": 669569,
	"./stocks/PBF.png": 42847,
	"./stocks/PBHC.png": 652411,
	"./stocks/PBI.png": 35134,
	"./stocks/PBIP.png": 84930,
	"./stocks/PBLA.png": 336430,
	"./stocks/PBM.png": 633310,
	"./stocks/PBPB.png": 786717,
	"./stocks/PBR.png": 212088,
	"./stocks/PBTS.png": 213446,
	"./stocks/PCAR.png": 891535,
	"./stocks/PCF.png": 376029,
	"./stocks/PCG.png": 498943,
	"./stocks/PCH.png": 965484,
	"./stocks/PCLA.png": 71236,
	"./stocks/PCM.png": 487586,
	"./stocks/PCN.png": 981749,
	"./stocks/PCOM.png": 989861,
	"./stocks/PCOR.png": 949993,
	"./stocks/PCRX.png": 503081,
	"./stocks/PCSA.png": 796112,
	"./stocks/PCSB.png": 401888,
	"./stocks/PCT.png": 598626,
	"./stocks/PCTI.png": 376193,
	"./stocks/PCTTU.png": 889882,
	"./stocks/PCVX.png": 725412,
	"./stocks/PCYG.png": 605138,
	"./stocks/PD.png": 669102,
	"./stocks/PDD.png": 767109,
	"./stocks/PDFS.png": 674367,
	"./stocks/PDI.png": 273245,
	"./stocks/PDLB.png": 823536,
	"./stocks/PDM.png": 849354,
	"./stocks/PDOT.png": 998814,
	"./stocks/PDS.png": 40485,
	"./stocks/PDSB.png": 382022,
	"./stocks/PDYN.png": 904304,
	"./stocks/PEAK.png": 741097,
	"./stocks/PEB.png": 677617,
	"./stocks/PEBK.png": 211107,
	"./stocks/PEBO.png": 954258,
	"./stocks/PED.png": 11940,
	"./stocks/PEG.png": 317780,
	"./stocks/PEGA.png": 467538,
	"./stocks/PEGY.png": 152465,
	"./stocks/PEN.png": 851296,
	"./stocks/PENG.png": 86285,
	"./stocks/PENN.png": 278285,
	"./stocks/PEO.png": 350665,
	"./stocks/PEP.png": 638493,
	"./stocks/PEPG.png": 521100,
	"./stocks/PERI.png": 69566,
	"./stocks/PET.png": 451956,
	"./stocks/PETQ.png": 410094,
	"./stocks/PETS.png": 584061,
	"./stocks/PETV.png": 358983,
	"./stocks/PETZ.png": 398086,
	"./stocks/PEV.png": 422222,
	"./stocks/PFE.png": 480146,
	"./stocks/PFEL.png": 430326,
	"./stocks/PFES.png": 100396,
	"./stocks/PFG.png": 1683,
	"./stocks/PFHD.png": 104549,
	"./stocks/PFIE.png": 835784,
	"./stocks/PFIS.png": 157436,
	"./stocks/PFL.png": 824909,
	"./stocks/PFN.png": 595913,
	"./stocks/PFS.png": 420223,
	"./stocks/PFSW.png": 25314,
	"./stocks/PFTA.png": 941293,
	"./stocks/PFTAU.png": 489404,
	"./stocks/PFTAW.png": 402517,
	"./stocks/PG.png": 377577,
	"./stocks/PGEN.png": 501408,
	"./stocks/PGHL.png": 974386,
	"./stocks/PGNY.png": 164275,
	"./stocks/PGR.png": 178495,
	"./stocks/PGRE.png": 798532,
	"./stocks/PGRU.png": 217536,
	"./stocks/PGTI.png": 807693,
	"./stocks/PGY.png": 342081,
	"./stocks/PH.png": 239822,
	"./stocks/PHAS.png": 653351,
	"./stocks/PHAT.png": 554553,
	"./stocks/PHG.png": 336159,
	"./stocks/PHGE.png": 340248,
	"./stocks/PHI.png": 690382,
	"./stocks/PHIO.png": 237175,
	"./stocks/PHIOW.png": 446506,
	"./stocks/PHK.png": 770707,
	"./stocks/PHM.png": 454145,
	"./stocks/PHR.png": 678846,
	"./stocks/PHUN.png": 418534,
	"./stocks/PHVS.png": 402855,
	"./stocks/PI.png": 531247,
	"./stocks/PIFI.png": 414534,
	"./stocks/PII.png": 192046,
	"./stocks/PIII.png": 188799,
	"./stocks/PIK.png": 682197,
	"./stocks/PIM.png": 315617,
	"./stocks/PINC.png": 601954,
	"./stocks/PINE.png": 37235,
	"./stocks/PING.png": 517241,
	"./stocks/PINS.png": 955036,
	"./stocks/PIRS.png": 877526,
	"./stocks/PITA.png": 604298,
	"./stocks/PIXY.png": 351241,
	"./stocks/PJT.png": 570341,
	"./stocks/PKG.png": 856796,
	"./stocks/PKI.png": 41786,
	"./stocks/PKO.png": 391492,
	"./stocks/PKX.png": 131335,
	"./stocks/PL.png": 449809,
	"./stocks/PLAB.png": 279608,
	"./stocks/PLAG.png": 503330,
	"./stocks/PLAN.png": 31880,
	"./stocks/PLAY.png": 934406,
	"./stocks/PLBY.png": 546514,
	"./stocks/PLCE.png": 746990,
	"./stocks/PLD.png": 842591,
	"./stocks/PLG.png": 409272,
	"./stocks/PLIN.png": 257887,
	"./stocks/PLL.png": 691226,
	"./stocks/PLM.png": 278092,
	"./stocks/PLMR.png": 623771,
	"./stocks/PLNT.png": 716053,
	"./stocks/PLPX.png": 858043,
	"./stocks/PLRX.png": 998711,
	"./stocks/PLRZ.png": 764313,
	"./stocks/PLSE.png": 540006,
	"./stocks/PLTK.png": 49709,
	"./stocks/PLTN.png": 243679,
	"./stocks/PLTR.png": 660294,
	"./stocks/PLUG.png": 91685,
	"./stocks/PLXP.png": 559966,
	"./stocks/PLYA.png": 70211,
	"./stocks/PM.png": 55611,
	"./stocks/PMAX.png": 510046,
	"./stocks/PMAX2.png": 895422,
	"./stocks/PMCB.png": 34972,
	"./stocks/PMD.png": 862610,
	"./stocks/PMEC.png": 837680,
	"./stocks/PMF.png": 717422,
	"./stocks/PML.png": 629907,
	"./stocks/PMM.png": 257684,
	"./stocks/PMNT.png": 541536,
	"./stocks/PMO.png": 368915,
	"./stocks/PMTS.png": 928058,
	"./stocks/PMVP.png": 385862,
	"./stocks/PNBK.png": 84997,
	"./stocks/PNC.png": 332191,
	"./stocks/PNST.png": 719,
	"./stocks/PNT.png": 952423,
	"./stocks/PNTG.png": 851466,
	"./stocks/PNTM.png": 756076,
	"./stocks/PNW.png": 921631,
	"./stocks/POAI.png": 150332,
	"./stocks/PODD.png": 363113,
	"./stocks/POET.png": 112240,
	"./stocks/POFCY.png": 679895,
	"./stocks/POL.png": 516299,
	"./stocks/POLA.png": 504640,
	"./stocks/PONO.png": 696839,
	"./stocks/PONY.png": 962863,
	"./stocks/POR.png": 419880,
	"./stocks/POSH.png": 7053,
	"./stocks/POST.png": 434402,
	"./stocks/POWI.png": 642629,
	"./stocks/POWL.png": 425361,
	"./stocks/POWW.png": 185424,
	"./stocks/POWWP.png": 133157,
	"./stocks/PPBT.png": 64434,
	"./stocks/PPD.png": 794055,
	"./stocks/PPG.png": 695972,
	"./stocks/PPL.png": 576614,
	"./stocks/PPP.png": 502265,
	"./stocks/PPSI.png": 280435,
	"./stocks/PPT.png": 504623,
	"./stocks/PPTA.png": 199136,
	"./stocks/PR.png": 877931,
	"./stocks/PRA.png": 267152,
	"./stocks/PRAA.png": 652163,
	"./stocks/PRAX.png": 828016,
	"./stocks/PRCH.png": 808711,
	"./stocks/PRCT.png": 531610,
	"./stocks/PRDS.png": 467519,
	"./stocks/PRE.png": 517444,
	"./stocks/PRFX.png": 580037,
	"./stocks/PRG.png": 41425,
	"./stocks/PRGO.png": 145395,
	"./stocks/PRGS.png": 447711,
	"./stocks/PRI.png": 208697,
	"./stocks/PRIM.png": 195846,
	"./stocks/PRLD.png": 60571,
	"./stocks/PRME.png": 412231,
	"./stocks/PROC.png": 805515,
	"./stocks/PROF.png": 911295,
	"./stocks/PROG.png": 929657,
	"./stocks/PROK.png": 471781,
	"./stocks/PRPH.png": 857774,
	"./stocks/PRPL.png": 751591,
	"./stocks/PRPO.png": 429099,
	"./stocks/PRQR.png": 689686,
	"./stocks/PRSO.png": 927717,
	"./stocks/PRSR.png": 101260,
	"./stocks/PRST.png": 784116,
	"./stocks/PRTA.png": 569649,
	"./stocks/PRTC.png": 613437,
	"./stocks/PRTG.png": 1625,
	"./stocks/PRTH.png": 443104,
	"./stocks/PRTK.png": 7300,
	"./stocks/PRTS.png": 654094,
	"./stocks/PRTY.png": 197184,
	"./stocks/PRU.png": 623693,
	"./stocks/PRVA.png": 993800,
	"./stocks/PRVB.png": 359436,
	"./stocks/PRZO.png": 105357,
	"./stocks/PSB.png": 585645,
	"./stocks/PSEC.png": 798863,
	"./stocks/PSHG.png": 940530,
	"./stocks/PSIG.png": 76576,
	"./stocks/PSMT.png": 596548,
	"./stocks/PSN.png": 738804,
	"./stocks/PSNL.png": 234138,
	"./stocks/PSNY.png": 397955,
	"./stocks/PSNYW.png": 373073,
	"./stocks/PSO.png": 224051,
	"./stocks/PSQH.png": 70362,
	"./stocks/PSTG.png": 712110,
	"./stocks/PSTH.png": 139826,
	"./stocks/PSTI.png": 541946,
	"./stocks/PSTL.png": 639407,
	"./stocks/PSTV.png": 882400,
	"./stocks/PSTX.png": 316920,
	"./stocks/PSX.png": 842082,
	"./stocks/PSXP.png": 824493,
	"./stocks/PT.png": 775180,
	"./stocks/PTCT.png": 196369,
	"./stocks/PTE.png": 623986,
	"./stocks/PTEN.png": 509216,
	"./stocks/PTGX.png": 429589,
	"./stocks/PTIX.png": 643906,
	"./stocks/PTKFF.png": 743857,
	"./stocks/PTLE.png": 804809,
	"./stocks/PTN.png": 946350,
	"./stocks/PTNR.png": 33180,
	"./stocks/PTOC.png": 421802,
	"./stocks/PTOCU.png": 38564,
	"./stocks/PTON.png": 210585,
	"./stocks/PTPI.png": 776764,
	"./stocks/PTR.png": 183856,
	"./stocks/PTRA.png": 852967,
	"./stocks/PTRAW.png": 617770,
	"./stocks/PTY.png": 544345,
	"./stocks/PUBM.png": 873508,
	"./stocks/PUK.png": 712427,
	"./stocks/PULM.png": 12659,
	"./stocks/PUMP.png": 838196,
	"./stocks/PVAC.png": 561630,
	"./stocks/PVBC.png": 408581,
	"./stocks/PVH.png": 630454,
	"./stocks/PW.png": 380707,
	"./stocks/PWFL.png": 806417,
	"./stocks/PWM.png": 181904,
	"./stocks/PWP.png": 920327,
	"./stocks/PWSC.png": 401685,
	"./stocks/PXD.png": 144534,
	"./stocks/PXDT.png": 620169,
	"./stocks/PXLW.png": 262161,
	"./stocks/PXMD.png": 564019,
	"./stocks/PXS.png": 466693,
	"./stocks/PXSAP.png": 155222,
	"./stocks/PYN.png": 36695,
	"./stocks/PYPD.png": 226800,
	"./stocks/PYPL.png": 570386,
	"./stocks/PYPS.png": 528224,
	"./stocks/PYPT.png": 486440,
	"./stocks/PYR.png": 35843,
	"./stocks/PYXS.png": 192904,
	"./stocks/PZG.png": 834462,
	"./stocks/PZN.png": 550387,
	"./stocks/PZZA.png": 439816,
	"./stocks/QABSY.png": 450619,
	"./stocks/QADA.png": 450985,
	"./stocks/QADB.png": 620231,
	"./stocks/QBTS.png": 56852,
	"./stocks/QCOM.png": 959192,
	"./stocks/QD.png": 134631,
	"./stocks/QDEL.png": 85350,
	"./stocks/QFIN.png": 457292,
	"./stocks/QGEN.png": 492594,
	"./stocks/QH.png": 897284,
	"./stocks/QIPT.png": 869595,
	"./stocks/QK.png": 175789,
	"./stocks/QLGN.png": 111791,
	"./stocks/QLI.png": 366352,
	"./stocks/QLYS.png": 781899,
	"./stocks/QMCO.png": 281637,
	"./stocks/QMMM.png": 959284,
	"./stocks/QNCX.png": 670534,
	"./stocks/QNGY.png": 658245,
	"./stocks/QNRX.png": 71042,
	"./stocks/QNST.png": 108975,
	"./stocks/QNTM.png": 943184,
	"./stocks/QRHC.png": 822217,
	"./stocks/QRTEA.png": 400521,
	"./stocks/QRTEB.png": 763333,
	"./stocks/QRVO.png": 650223,
	"./stocks/QS.png": 58804,
	"./stocks/QSG.png": 851161,
	"./stocks/QSI.png": 42765,
	"./stocks/QSR.png": 93301,
	"./stocks/QTEK.png": 384606,
	"./stocks/QTNT.png": 421438,
	"./stocks/QTRX.png": 684170,
	"./stocks/QTT.png": 366361,
	"./stocks/QTT2.png": 161551,
	"./stocks/QTWO.png": 508678,
	"./stocks/QUBT.png": 996337,
	"./stocks/QUIK.png": 760661,
	"./stocks/QUOT.png": 899206,
	"./stocks/QURE.png": 819260,
	"./stocks/QVCGA.png": 796899,
	"./stocks/QVCGB.png": 754643,
	"./stocks/QVCGP.png": 476916,
	"./stocks/RA.png": 234332,
	"./stocks/RAAS.png": 69290,
	"./stocks/RACA.png": 246436,
	"./stocks/RACB.png": 200561,
	"./stocks/RACE.png": 979071,
	"./stocks/RAD.png": 302831,
	"./stocks/RADA.png": 106988,
	"./stocks/RAIL.png": 452736,
	"./stocks/RAIN.png": 819938,
	"./stocks/RAM.png": 579838,
	"./stocks/RAMMU.png": 955102,
	"./stocks/RAMP.png": 385215,
	"./stocks/RANI.png": 340277,
	"./stocks/RAPT.png": 802749,
	"./stocks/RARE.png": 518661,
	"./stocks/RAVN.png": 606863,
	"./stocks/RAY.png": 640476,
	"./stocks/RBA.png": 399628,
	"./stocks/RBAC.png": 259625,
	"./stocks/RBC.png": 117179,
	"./stocks/RBCAA.png": 978896,
	"./stocks/RBCN.png": 404189,
	"./stocks/RBLX.png": 233769,
	"./stocks/RBNC.png": 519676,
	"./stocks/RBOT.png": 925454,
	"./stocks/RBT.png": 382443,
	"./stocks/RC.png": 685279,
	"./stocks/RCAT.png": 556603,
	"./stocks/RCEL.png": 623553,
	"./stocks/RCI.png": 935324,
	"./stocks/RCII.png": 995193,
	"./stocks/RCKT.png": 592304,
	"./stocks/RCKY.png": 280153,
	"./stocks/RCL.png": 431035,
	"./stocks/RCM.png": 505394,
	"./stocks/RCMT.png": 57066,
	"./stocks/RCON.png": 979380,
	"./stocks/RCOR.png": 844852,
	"./stocks/RCRT.png": 893221,
	"./stocks/RCS.png": 792234,
	"./stocks/RCUS.png": 137220,
	"./stocks/RDBX.png": 63074,
	"./stocks/RDCM.png": 449003,
	"./stocks/RDDT.png": 776396,
	"./stocks/RDFN.png": 830614,
	"./stocks/RDHL.png": 879897,
	"./stocks/RDN.png": 616778,
	"./stocks/RDS.png": 881151,
	"./stocks/RDUS.png": 879981,
	"./stocks/RDVT.png": 344235,
	"./stocks/RDW.png": 937366,
	"./stocks/RDWR.png": 774356,
	"./stocks/RDY.png": 647899,
	"./stocks/RDZN.png": 84373,
	"./stocks/RE.png": 348238,
	"./stocks/REAL.png": 613529,
	"./stocks/REBN.png": 401500,
	"./stocks/REE.png": 12563,
	"./stocks/REECF.png": 595192,
	"./stocks/REED.png": 334623,
	"./stocks/REFR.png": 726405,
	"./stocks/REG.png": 958160,
	"./stocks/REGN.png": 62171,
	"./stocks/REKR.png": 180069,
	"./stocks/RELI.png": 816545,
	"./stocks/RELX.png": 219662,
	"./stocks/RENB.png": 158513,
	"./stocks/RENT.png": 602434,
	"./stocks/REPH.png": 728343,
	"./stocks/REPL.png": 885159,
	"./stocks/RERE.png": 725818,
	"./stocks/RETA.png": 729058,
	"./stocks/RETO.png": 386962,
	"./stocks/REUN.png": 753952,
	"./stocks/REV.png": 610033,
	"./stocks/REVB.png": 332754,
	"./stocks/REXR.png": 102388,
	"./stocks/REZI.png": 690379,
	"./stocks/RF.png": 254581,
	"./stocks/RFIL.png": 989257,
	"./stocks/RFL.png": 184502,
	"./stocks/RFP.png": 7736,
	"./stocks/RGA.png": 238350,
	"./stocks/RGC.png": 788975,
	"./stocks/RGCO.png": 531567,
	"./stocks/RGEN.png": 717902,
	"./stocks/RGF.png": 759487,
	"./stocks/RGLD.png": 397080,
	"./stocks/RGLS.png": 314540,
	"./stocks/RGNX.png": 460372,
	"./stocks/RGP.png": 193105,
	"./stocks/RGS.png": 139977,
	"./stocks/RGTI.png": 900919,
	"./stocks/RH.png": 246337,
	"./stocks/RHC.png": 446616,
	"./stocks/RHE.png": 822548,
	"./stocks/RIBT.png": 954844,
	"./stocks/RICK.png": 68040,
	"./stocks/RIDE.png": 436321,
	"./stocks/RIG.png": 560693,
	"./stocks/RIGL.png": 162996,
	"./stocks/RILY.png": 520444,
	"./stocks/RIME.png": 926364,
	"./stocks/RIO.png": 533564,
	"./stocks/RIOT.png": 665308,
	"./stocks/RITM.png": 136608,
	"./stocks/RIVN.png": 153242,
	"./stocks/RJF.png": 216413,
	"./stocks/RJM.png": 518774,
	"./stocks/RKDA.png": 345535,
	"./stocks/RKLB.png": 240563,
	"./stocks/RKLY.png": 738349,
	"./stocks/RKT.png": 856890,
	"./stocks/RL.png": 966164,
	"./stocks/RLAY.png": 686016,
	"./stocks/RLGY.png": 131407,
	"./stocks/RLJ.png": 418955,
	"./stocks/RLMD.png": 741719,
	"./stocks/RLX.png": 26872,
	"./stocks/RLYB.png": 728738,
	"./stocks/RMAX.png": 187717,
	"./stocks/RMBL.png": 323140,
	"./stocks/RMBS.png": 182399,
	"./stocks/RMCF.png": 976854,
	"./stocks/RMD.png": 107659,
	"./stocks/RMED.png": 414658,
	"./stocks/RMNI.png": 969422,
	"./stocks/RMO.png": 183394,
	"./stocks/RMR.png": 999811,
	"./stocks/RMSG.png": 538942,
	"./stocks/RMTI.png": 553659,
	"./stocks/RNA.png": 529879,
	"./stocks/RNAZ.png": 136697,
	"./stocks/RNER.png": 593108,
	"./stocks/RNG.png": 262637,
	"./stocks/RNLX.png": 198785,
	"./stocks/RNR.png": 294044,
	"./stocks/RNW.png": 932742,
	"./stocks/RNWK.png": 354614,
	"./stocks/RNXT.png": 229712,
	"./stocks/ROAD.png": 450805,
	"./stocks/ROAM.png": 711648,
	"./stocks/ROCG.png": 93488,
	"./stocks/ROCK.png": 551119,
	"./stocks/ROCL.png": 379188,
	"./stocks/ROI.png": 998604,
	"./stocks/ROIC.png": 556373,
	"./stocks/ROIV.png": 76862,
	"./stocks/ROIVW.png": 170348,
	"./stocks/ROK.png": 477131,
	"./stocks/ROKU.png": 64998,
	"./stocks/ROL.png": 550460,
	"./stocks/ROLL.png": 899683,
	"./stocks/ROLR.png": 166898,
	"./stocks/ROMA.png": 482150,
	"./stocks/ROOT.png": 244984,
	"./stocks/ROP.png": 73403,
	"./stocks/ROST.png": 777047,
	"./stocks/ROVR.png": 855077,
	"./stocks/RPAI.png": 635534,
	"./stocks/RPAY.png": 637338,
	"./stocks/RPD.png": 665388,
	"./stocks/RPHM.png": 608696,
	"./stocks/RPID.png": 527985,
	"./stocks/RPM.png": 285379,
	"./stocks/RPT.png": 113216,
	"./stocks/RPTX.png": 932091,
	"./stocks/RR.png": 527487,
	"./stocks/RRBI.png": 734982,
	"./stocks/RRC.png": 120433,
	"./stocks/RRD.png": 816185,
	"./stocks/RRGB.png": 185240,
	"./stocks/RRGH.png": 223886,
	"./stocks/RS.png": 609937,
	"./stocks/RSG.png": 984614,
	"./stocks/RSI.png": 468369,
	"./stocks/RSLS.png": 519475,
	"./stocks/RSVR.png": 529742,
	"./stocks/RSVRW.png": 392008,
	"./stocks/RTC.png": 921331,
	"./stocks/RTNTF.png": 493640,
	"./stocks/RTX.png": 683419,
	"./stocks/RUBY.png": 862406,
	"./stocks/RUM.png": 112353,
	"./stocks/RUN.png": 643741,
	"./stocks/RUSHA.png": 957298,
	"./stocks/RUSHB.png": 450144,
	"./stocks/RVAC.png": 796933,
	"./stocks/RVI.png": 744671,
	"./stocks/RVLP.png": 975713,
	"./stocks/RVLV.png": 86284,
	"./stocks/RVMD.png": 435708,
	"./stocks/RVNC.png": 714816,
	"./stocks/RVPH.png": 921643,
	"./stocks/RVSB.png": 363010,
	"./stocks/RVSN.png": 734832,
	"./stocks/RVYL.png": 450959,
	"./stocks/RWLK.png": 708134,
	"./stocks/RWT.png": 620205,
	"./stocks/RXDX.png": 899090,
	"./stocks/RXN.png": 299577,
	"./stocks/RXRX.png": 459448,
	"./stocks/RXST.png": 6008,
	"./stocks/RXT.png": 139254,
	"./stocks/RY.png": 475460,
	"./stocks/RYAAY.png": 604238,
	"./stocks/RYAM.png": 715550,
	"./stocks/RYAN.png": 400235,
	"./stocks/RYCEY.png": 430854,
	"./stocks/RYDE.png": 779319,
	"./stocks/RYN.png": 403357,
	"./stocks/RYVL.png": 40904,
	"./stocks/RZLT.png": 748286,
	"./stocks/RZLV.png": 677785,
	"./stocks/S.png": 563526,
	"./stocks/SA.png": 992688,
	"./stocks/SABS.png": 700580,
	"./stocks/SAF.png": 521289,
	"./stocks/SAFE.png": 351609,
	"./stocks/SAFM.png": 925837,
	"./stocks/SAFT.png": 291927,
	"./stocks/SAG.png": 422108,
	"./stocks/SAGE.png": 284819,
	"./stocks/SAH.png": 136781,
	"./stocks/SAI.png": 875806,
	"./stocks/SAIC.png": 808579,
	"./stocks/SAIH.png": 553279,
	"./stocks/SAIL.png": 203084,
	"./stocks/SAL.png": 730772,
	"./stocks/SALM.png": 374390,
	"./stocks/SAM.png": 507892,
	"./stocks/SAMG.png": 759508,
	"./stocks/SAN.png": 909476,
	"./stocks/SANA.png": 568726,
	"./stocks/SAND.png": 927044,
	"./stocks/SANW.png": 869214,
	"./stocks/SAP.png": 485873,
	"./stocks/SASI.png": 828868,
	"./stocks/SASR.png": 166879,
	"./stocks/SATL.png": 989222,
	"./stocks/SATRO.png": 386107,
	"./stocks/SATS.png": 216382,
	"./stocks/SATX.png": 195158,
	"./stocks/SAVA.png": 234308,
	"./stocks/SAVE.png": 732402,
	"./stocks/SB.png": 777894,
	"./stocks/SBAC.png": 756416,
	"./stocks/SBET.png": 353099,
	"./stocks/SBEV.png": 723205,
	"./stocks/SBFM.png": 678506,
	"./stocks/SBGI.png": 190700,
	"./stocks/SBLK.png": 626506,
	"./stocks/SBMH.png": 686256,
	"./stocks/SBNY.png": 598742,
	"./stocks/SBNY2.png": 934017,
	"./stocks/SBOW.png": 898037,
	"./stocks/SBRCY.png": 444147,
	"./stocks/SBS.png": 172769,
	"./stocks/SBSI.png": 452752,
	"./stocks/SBSP.png": 290359,
	"./stocks/SBSW.png": 11922,
	"./stocks/SBT.png": 320920,
	"./stocks/SBTX.png": 252674,
	"./stocks/SBUX.png": 26622,
	"./stocks/SC.png": 225962,
	"./stocks/SCCO.png": 385727,
	"./stocks/SCHL.png": 894207,
	"./stocks/SCHN.png": 144942,
	"./stocks/SCHW.png": 685574,
	"./stocks/SCI.png": 441275,
	"./stocks/SCKT.png": 759692,
	"./stocks/SCLX.png": 497870,
	"./stocks/SCNI.png": 501961,
	"./stocks/SCNX.png": 775656,
	"./stocks/SCOR.png": 410957,
	"./stocks/SCPC.png": 376226,
	"./stocks/SCPH.png": 506979,
	"./stocks/SCPS.png": 553455,
	"./stocks/SCPX.png": 213349,
	"./stocks/SCR.png": 321206,
	"./stocks/SCSC.png": 979533,
	"./stocks/SCU.png": 3237,
	"./stocks/SCVL.png": 831322,
	"./stocks/SCVX.png": 443724,
	"./stocks/SCWX.png": 942806,
	"./stocks/SCX.png": 878001,
	"./stocks/SCYX.png": 197589,
	"./stocks/SDC.png": 245525,
	"./stocks/SDGR.png": 107076,
	"./stocks/SDH.png": 598006,
	"./stocks/SDIG.png": 874086,
	"./stocks/SDST.png": 777950,
	"./stocks/SE.png": 276629,
	"./stocks/SEAC.png": 964315,
	"./stocks/SEAL-A.png": 40060,
	"./stocks/SEAL-B.png": 857573,
	"./stocks/SEAS.png": 798630,
	"./stocks/SEAT.png": 486949,
	"./stocks/SECO.png": 533147,
	"./stocks/SEDG.png": 634885,
	"./stocks/SEE.png": 72108,
	"./stocks/SEED.png": 768551,
	"./stocks/SEEL.png": 493309,
	"./stocks/SEER.png": 503120,
	"./stocks/SELB.png": 561111,
	"./stocks/SELF.png": 143270,
	"./stocks/SEM.png": 195512,
	"./stocks/SEMR.png": 970564,
	"./stocks/SENEA.png": 273383,
	"./stocks/SENS.png": 488107,
	"./stocks/SER.png": 893437,
	"./stocks/SERA.png": 218208,
	"./stocks/SERV.png": 580922,
	"./stocks/SES.png": 191493,
	"./stocks/SESN.png": 874115,
	"./stocks/SEV.png": 716759,
	"./stocks/SEZL.png": 819315,
	"./stocks/SF.png": 85609,
	"./stocks/SFBC.png": 802453,
	"./stocks/SFE.png": 307872,
	"./stocks/SFET.png": 392031,
	"./stocks/SFHG.png": 354567,
	"./stocks/SFHLF.png": 481328,
	"./stocks/SFIX.png": 602183,
	"./stocks/SFL.png": 760063,
	"./stocks/SFM.png": 110704,
	"./stocks/SFR.png": 95311,
	"./stocks/SFST.png": 828365,
	"./stocks/SFT.png": 402869,
	"./stocks/SFWL.png": 641448,
	"./stocks/SG.png": 879922,
	"./stocks/SGA.png": 511389,
	"./stocks/SGBX.png": 894925,
	"./stocks/SGC.png": 829102,
	"./stocks/SGD.png": 171667,
	"./stocks/SGE.png": 133017,
	"./stocks/SGEN.png": 735537,
	"./stocks/SGFY.png": 228723,
	"./stocks/SGHC.png": 126237,
	"./stocks/SGHIF.png": 981131,
	"./stocks/SGHT.png": 107322,
	"./stocks/SGII.png": 980943,
	"./stocks/SGLB.png": 814463,
	"./stocks/SGLY.png": 694854,
	"./stocks/SGMA.png": 802223,
	"./stocks/SGML.png": 229699,
	"./stocks/SGMO.png": 289022,
	"./stocks/SGMS.png": 621236,
	"./stocks/SGMT.png": 925094,
	"./stocks/SGN.png": 140411,
	"./stocks/SGRP.png": 293757,
	"./stocks/SGRY.png": 334960,
	"./stocks/SGTX.png": 289713,
	"./stocks/SHAC.png": 826781,
	"./stocks/SHACU.png": 745932,
	"./stocks/SHAK.png": 387554,
	"./stocks/SHBI.png": 937109,
	"./stocks/SHC.png": 528552,
	"./stocks/SHCR.png": 345871,
	"./stocks/SHEL.png": 711782,
	"./stocks/SHEN.png": 853829,
	"./stocks/SHFS.png": 934703,
	"./stocks/SHIM.png": 911576,
	"./stocks/SHIP.png": 620328,
	"./stocks/SHIPW.png": 467974,
	"./stocks/SHLS.png": 20468,
	"./stocks/SHO.png": 776276,
	"./stocks/SHOO.png": 250265,
	"./stocks/SHOP.png": 919149,
	"./stocks/SHOT.png": 742497,
	"./stocks/SHPH.png": 673758,
	"./stocks/SHPW.png": 46895,
	"./stocks/SHQA.png": 897071,
	"./stocks/SHQAU.png": 701220,
	"./stocks/SHQAW.png": 277387,
	"./stocks/SHW.png": 817725,
	"./stocks/SHYF.png": 60374,
	"./stocks/SIBN.png": 865887,
	"./stocks/SICP.png": 175801,
	"./stocks/SIDU.png": 614662,
	"./stocks/SIEB.png": 519342,
	"./stocks/SIEN.png": 581132,
	"./stocks/SIFY.png": 977814,
	"./stocks/SIG.png": 89573,
	"./stocks/SIGA.png": 854998,
	"./stocks/SIGI.png": 464166,
	"./stocks/SIGIP.png": 8332,
	"./stocks/SII.png": 142050,
	"./stocks/SILC.png": 838476,
	"./stocks/SILK.png": 717634,
	"./stocks/SILO.png": 825983,
	"./stocks/SILV.png": 504021,
	"./stocks/SIMO.png": 530441,
	"./stocks/SING.png": 732663,
	"./stocks/SINT.png": 86307,
	"./stocks/SIRI.png": 166821,
	"./stocks/SISI.png": 479297,
	"./stocks/SITC.png": 993313,
	"./stocks/SITM.png": 380504,
	"./stocks/SIVB.png": 206374,
	"./stocks/SIVBP.png": 827371,
	"./stocks/SIX.png": 474349,
	"./stocks/SJ.png": 679292,
	"./stocks/SJM.png": 176055,
	"./stocks/SJR.png": 806684,
	"./stocks/SKIL.png": 316679,
	"./stocks/SKIN.png": 701653,
	"./stocks/SKK.png": 676309,
	"./stocks/SKLZ.png": 32129,
	"./stocks/SKM.png": 159398,
	"./stocks/SKWD.png": 649846,
	"./stocks/SKX.png": 603109,
	"./stocks/SKYH.png": 680078,
	"./stocks/SKYT.png": 661735,
	"./stocks/SKYW.png": 990817,
	"./stocks/SKYX.png": 695100,
	"./stocks/SLAB.png": 350051,
	"./stocks/SLAC.png": 577876,
	"./stocks/SLB.png": 273815,
	"./stocks/SLCA.png": 456346,
	"./stocks/SLDB.png": 518024,
	"./stocks/SLDP.png": 793447,
	"./stocks/SLF.png": 443272,
	"./stocks/SLG.png": 257722,
	"./stocks/SLGG.png": 721850,
	"./stocks/SLGL.png": 673738,
	"./stocks/SLGN.png": 199279,
	"./stocks/SLHG.png": 51059,
	"./stocks/SLN.png": 133848,
	"./stocks/SLNA.png": 338677,
	"./stocks/SLNG.png": 559106,
	"./stocks/SLNH.png": 687035,
	"./stocks/SLNO.png": 380802,
	"./stocks/SLP.png": 294925,
	"./stocks/SLQT.png": 158,
	"./stocks/SLRX.png": 788712,
	"./stocks/SLS.png": 584144,
	"./stocks/SLXN.png": 140504,
	"./stocks/SM.png": 568635,
	"./stocks/SMAR.png": 736492,
	"./stocks/SMBC.png": 338118,
	"./stocks/SMCI.png": 543588,
	"./stocks/SMED.png": 808361,
	"./stocks/SMFG.png": 346334,
	"./stocks/SMFL.png": 712423,
	"./stocks/SMG.png": 718207,
	"./stocks/SMHI.png": 513383,
	"./stocks/SMID.png": 904850,
	"./stocks/SMIT.png": 882045,
	"./stocks/SMLR.png": 670191,
	"./stocks/SMMF.png": 519923,
	"./stocks/SMMT.png": 263173,
	"./stocks/SMPL.png": 296019,
	"./stocks/SMR.png": 353322,
	"./stocks/SMRT.png": 879441,
	"./stocks/SMSI.png": 162350,
	"./stocks/SMTC.png": 885167,
	"./stocks/SMTI.png": 481863,
	"./stocks/SMTK.png": 302513,
	"./stocks/SMTS.png": 981962,
	"./stocks/SMWB.png": 547002,
	"./stocks/SMX.png": 198256,
	"./stocks/SNA.png": 476951,
	"./stocks/SNAL.png": 360281,
	"./stocks/SNAP.png": 904019,
	"./stocks/SNBR.png": 242515,
	"./stocks/SNCR.png": 886919,
	"./stocks/SNCY.png": 701459,
	"./stocks/SND.png": 349320,
	"./stocks/SNDA.png": 318896,
	"./stocks/SNDL.png": 526767,
	"./stocks/SNDR.png": 96543,
	"./stocks/SNDX.png": 675939,
	"./stocks/SNES.png": 390526,
	"./stocks/SNEX.png": 343182,
	"./stocks/SNFCA.png": 608224,
	"./stocks/SNGX.png": 632315,
	"./stocks/SNMP.png": 599596,
	"./stocks/SNN.png": 178365,
	"./stocks/SNOA.png": 527007,
	"./stocks/SNOW.png": 510096,
	"./stocks/SNP.png": 630647,
	"./stocks/SNPO.png": 819604,
	"./stocks/SNPS.png": 709463,
	"./stocks/SNPX.png": 261922,
	"./stocks/SNSE.png": 488549,
	"./stocks/SNTG.png": 494027,
	"./stocks/SNTI.png": 430441,
	"./stocks/SNY.png": 429886,
	"./stocks/SO.png": 744768,
	"./stocks/SOAR.png": 887476,
	"./stocks/SOBR.png": 886439,
	"./stocks/SOC.png": 948737,
	"./stocks/SOFI.png": 915521,
	"./stocks/SOGU.png": 403596,
	"./stocks/SOHOB.png": 929214,
	"./stocks/SOHU.png": 389687,
	"./stocks/SOI.png": 605014,
	"./stocks/SOL.png": 549790,
	"./stocks/SOLO.png": 552690,
	"./stocks/SOLV.png": 299375,
	"./stocks/SOLY.png": 606225,
	"./stocks/SON.png": 772798,
	"./stocks/SOND.png": 158250,
	"./stocks/SONM.png": 798058,
	"./stocks/SONN.png": 33091,
	"./stocks/SONO.png": 600983,
	"./stocks/SONY.png": 277069,
	"./stocks/SOPA.png": 51748,
	"./stocks/SOPH.png": 878785,
	"./stocks/SOS.png": 474909,
	"./stocks/SOUHY.png": 759873,
	"./stocks/SOUN.png": 105626,
	"./stocks/SOVO.png": 585622,
	"./stocks/SOWG.png": 446227,
	"./stocks/SP.png": 534182,
	"./stocks/SPAI.png": 97508,
	"./stocks/SPB.png": 752538,
	"./stocks/SPCB.png": 889284,
	"./stocks/SPCE.png": 786307,
	"./stocks/SPDR.png": 387460,
	"./stocks/SPEC.png": 813616,
	"./stocks/SPG.png": 322685,
	"./stocks/SPGC.png": 380298,
	"./stocks/SPGI.png": 493219,
	"./stocks/SPH.png": 942249,
	"./stocks/SPHL.png": 833456,
	"./stocks/SPI.png": 680891,
	"./stocks/SPIR.png": 856081,
	"./stocks/SPK.png": 547259,
	"./stocks/SPLK.png": 345370,
	"./stocks/SPLP.png": 679798,
	"./stocks/SPNE.png": 46638,
	"./stocks/SPNS.png": 566883,
	"./stocks/SPNT.png": 960069,
	"./stocks/SPOK.png": 701172,
	"./stocks/SPOT.png": 804817,
	"./stocks/SPPI.png": 660050,
	"./stocks/SPPL.png": 850669,
	"./stocks/SPR.png": 639075,
	"./stocks/SPRB.png": 728214,
	"./stocks/SPRC.png": 515990,
	"./stocks/SPRO.png": 723755,
	"./stocks/SPRT.png": 530218,
	"./stocks/SPRY.png": 932633,
	"./stocks/SPSC.png": 151963,
	"./stocks/SPT.png": 316818,
	"./stocks/SPWH.png": 64659,
	"./stocks/SPWR.png": 722351,
	"./stocks/SPX.png": 229539,
	"./stocks/SQ.png": 598185,
	"./stocks/SQFT.png": 518178,
	"./stocks/SQFTP.png": 813033,
	"./stocks/SQL.png": 125425,
	"./stocks/SQM.png": 696940,
	"./stocks/SQNS.png": 107485,
	"./stocks/SQSP.png": 477930,
	"./stocks/SQZ.png": 268486,
	"./stocks/SRAD.png": 377337,
	"./stocks/SRAX.png": 123375,
	"./stocks/SRC.png": 442577,
	"./stocks/SRCE.png": 588478,
	"./stocks/SRCL.png": 992222,
	"./stocks/SRDX.png": 749807,
	"./stocks/SRE.png": 95938,
	"./stocks/SREV.png": 976269,
	"./stocks/SRFM.png": 112680,
	"./stocks/SRG.png": 804531,
	"./stocks/SRGA.png": 690731,
	"./stocks/SRI.png": 395885,
	"./stocks/SRM.png": 176995,
	"./stocks/SRNE.png": 476530,
	"./stocks/SRPT.png": 905726,
	"./stocks/SRRA.png": 289645,
	"./stocks/SRRK.png": 813641,
	"./stocks/SRT.png": 780357,
	"./stocks/SRTS.png": 339555,
	"./stocks/SRZN.png": 187495,
	"./stocks/SSB.png": 606655,
	"./stocks/SSIC.png": 570563,
	"./stocks/SSKN.png": 404762,
	"./stocks/SSNC.png": 174654,
	"./stocks/SSNT.png": 111864,
	"./stocks/SSP.png": 263521,
	"./stocks/SSRM.png": 803032,
	"./stocks/SSSS.png": 262002,
	"./stocks/SST.png": 741771,
	"./stocks/SSTI.png": 619044,
	"./stocks/SSU.png": 54184,
	"./stocks/SSY.png": 527866,
	"./stocks/SSYS.png": 486569,
	"./stocks/ST.png": 531114,
	"./stocks/STAA.png": 773628,
	"./stocks/STAB.png": 885832,
	"./stocks/STAF.png": 854792,
	"./stocks/STAG.png": 684446,
	"./stocks/STAI.png": 668690,
	"./stocks/STAR.png": 57101,
	"./stocks/STBX.png": 722042,
	"./stocks/STC.png": 21302,
	"./stocks/STE.png": 574664,
	"./stocks/STEC.png": 155633,
	"./stocks/STEM.png": 112078,
	"./stocks/STEP.png": 503166,
	"./stocks/STER.png": 224067,
	"./stocks/STFC.png": 234952,
	"./stocks/STHC.png": 514687,
	"./stocks/STI.png": 49551,
	"./stocks/STIM.png": 272165,
	"./stocks/STK.png": 781610,
	"./stocks/STKL.png": 474813,
	"./stocks/STKS.png": 688915,
	"./stocks/STLA.png": 421282,
	"./stocks/STLD.png": 75145,
	"./stocks/STM.png": 809120,
	"./stocks/STN.png": 220340,
	"./stocks/STNE.png": 699270,
	"./stocks/STNG.png": 91310,
	"./stocks/STOK.png": 211793,
	"./stocks/STOR.png": 309437,
	"./stocks/STR.png": 124032,
	"./stocks/STRA.png": 939678,
	"./stocks/STRE.png": 514570,
	"./stocks/STRM.png": 433458,
	"./stocks/STRN.png": 922396,
	"./stocks/STRO.png": 291479,
	"./stocks/STRR.png": 917389,
	"./stocks/STRT.png": 223994,
	"./stocks/STRY.png": 943840,
	"./stocks/STSA.png": 584978,
	"./stocks/STSS.png": 85317,
	"./stocks/STT.png": 419420,
	"./stocks/STTK.png": 618315,
	"./stocks/STVN.png": 669133,
	"./stocks/STX.png": 55003,
	"./stocks/STZ.png": 431185,
	"./stocks/SU.png": 644046,
	"./stocks/SUGP.png": 217813,
	"./stocks/SUM.png": 739560,
	"./stocks/SUMO.png": 688118,
	"./stocks/SUMR.png": 453881,
	"./stocks/SUN.png": 372804,
	"./stocks/SUNE.png": 166894,
	"./stocks/SUNL.png": 838321,
	"./stocks/SUNW.png": 208209,
	"./stocks/SUP.png": 267408,
	"./stocks/SURG.png": 51935,
	"./stocks/SV.png": 870869,
	"./stocks/SVBI.png": 405674,
	"./stocks/SVFD.png": 998813,
	"./stocks/SVIX.png": 946131,
	"./stocks/SVM.png": 913977,
	"./stocks/SVMH.png": 747947,
	"./stocks/SVRA.png": 549181,
	"./stocks/SVRE.png": 856529,
	"./stocks/SVSVU.png": 289158,
	"./stocks/SVT.png": 597202,
	"./stocks/SVVC.png": 557058,
	"./stocks/SWBI.png": 122472,
	"./stocks/SWCH.png": 926974,
	"./stocks/SWEB.png": 684367,
	"./stocks/SWI.png": 100800,
	"./stocks/SWIM.png": 403658,
	"./stocks/SWIN.png": 676886,
	"./stocks/SWK.png": 556612,
	"./stocks/SWKS.png": 631288,
	"./stocks/SWM.png": 467996,
	"./stocks/SWN.png": 736454,
	"./stocks/SWTX.png": 876129,
	"./stocks/SWVL.png": 262742,
	"./stocks/SWZ.png": 91234,
	"./stocks/SXT.png": 723060,
	"./stocks/SXTC.png": 143924,
	"./stocks/SXTP.png": 723084,
	"./stocks/SYBX.png": 439586,
	"./stocks/SYF.png": 583422,
	"./stocks/SYK.png": 178738,
	"./stocks/SYM.png": 671386,
	"./stocks/SYNA.png": 651726,
	"./stocks/SYNH.png": 12820,
	"./stocks/SYNL.png": 443529,
	"./stocks/SYPR.png": 859560,
	"./stocks/SYRA.png": 394724,
	"./stocks/SYRS.png": 319947,
	"./stocks/SYT.png": 242443,
	"./stocks/SYTA.png": 275226,
	"./stocks/SYY.png": 868295,
	"./stocks/SZC.png": 609800,
	"./stocks/T.png": 757468,
	"./stocks/TAK.png": 846511,
	"./stocks/TAL.png": 963760,
	"./stocks/TALK.png": 164250,
	"./stocks/TALS.png": 700357,
	"./stocks/TANH.png": 43200,
	"./stocks/TAOP.png": 639235,
	"./stocks/TAP.png": 315976,
	"./stocks/TARA.png": 857374,
	"./stocks/TARS.png": 409635,
	"./stocks/TBB.png": 315254,
	"./stocks/TBIO.png": 536817,
	"./stocks/TBLT.png": 235132,
	"./stocks/TBNK.png": 634479,
	"./stocks/TC.png": 916154,
	"./stocks/TCBC.png": 160665,
	"./stocks/TCBP.png": 234651,
	"./stocks/TCBX.png": 361172,
	"./stocks/TCDA.png": 346752,
	"./stocks/TCEHY.png": 215030,
	"./stocks/TCJH.png": 595970,
	"./stocks/TCOM.png": 738974,
	"./stocks/TCON.png": 252990,
	"./stocks/TCRT.png": 120867,
	"./stocks/TCRX.png": 934777,
	"./stocks/TCS.png": 495979,
	"./stocks/TCTM.png": 875517,
	"./stocks/TCTZF.png": 850157,
	"./stocks/TD.png": 534687,
	"./stocks/TDC.png": 237354,
	"./stocks/TDG.png": 344591,
	"./stocks/TDOC.png": 846879,
	"./stocks/TDTH.png": 943189,
	"./stocks/TDUP.png": 442802,
	"./stocks/TDY.png": 937384,
	"./stocks/TEAM.png": 666760,
	"./stocks/TECH.png": 618618,
	"./stocks/TECK.png": 947156,
	"./stocks/TECX.png": 303207,
	"./stocks/TEL.png": 36930,
	"./stocks/TELL.png": 383394,
	"./stocks/TELO.png": 82797,
	"./stocks/TEM.png": 315346,
	"./stocks/TEN.png": 135339,
	"./stocks/TENB.png": 164029,
	"./stocks/TENX.png": 746121,
	"./stocks/TEO.png": 939921,
	"./stocks/TER.png": 262937,
	"./stocks/TERN.png": 422864,
	"./stocks/TESS.png": 95507,
	"./stocks/TEVA.png": 306587,
	"./stocks/TFC.png": 286848,
	"./stocks/TFFP.png": 99516,
	"./stocks/TGAN.png": 463728,
	"./stocks/TGL.png": 819274,
	"./stocks/TGN.png": 710552,
	"./stocks/TGT.png": 263742,
	"./stocks/TGTX.png": 940485,
	"./stocks/TGX.png": 534497,
	"./stocks/TH.png": 741249,
	"./stocks/THAR.png": 963684,
	"./stocks/THC.png": 933736,
	"./stocks/THCA.png": 577433,
	"./stocks/THCX.png": 224263,
	"./stocks/THM.png": 588208,
	"./stocks/THMO.png": 590734,
	"./stocks/THNCF.png": 105921,
	"./stocks/THO.png": 580679,
	"./stocks/THR.png": 646009,
	"./stocks/THRY.png": 721371,
	"./stocks/TIGR.png": 561637,
	"./stocks/TIL.png": 915697,
	"./stocks/TINV-UN.png": 231890,
	"./stocks/TINV.png": 740423,
	"./stocks/TIRX.png": 90235,
	"./stocks/TISI.png": 634164,
	"./stocks/TITN.png": 254445,
	"./stocks/TIVC.png": 667891,
	"./stocks/TJX.png": 436971,
	"./stocks/TKAT.png": 999536,
	"./stocks/TKC.png": 247802,
	"./stocks/TKLF.png": 25547,
	"./stocks/TLF.png": 607850,
	"./stocks/TLN.png": 607358,
	"./stocks/TLPH.png": 971172,
	"./stocks/TLRY.png": 360754,
	"./stocks/TLS.png": 594328,
	"./stocks/TLSA.png": 852118,
	"./stocks/TM.png": 797370,
	"./stocks/TMBR.png": 816881,
	"./stocks/TMC.png": 461847,
	"./stocks/TMCI.png": 172191,
	"./stocks/TMDI.png": 694864,
	"./stocks/TMDS.png": 545088,
	"./stocks/TMDX.png": 570868,
	"./stocks/TME.png": 601681,
	"./stocks/TMO.png": 430495,
	"./stocks/TMP.png": 913401,
	"./stocks/TMPO.png": 991167,
	"./stocks/TMQ.png": 850284,
	"./stocks/TMUS.png": 605105,
	"./stocks/TNDM.png": 100601,
	"./stocks/TNFA.png": 470372,
	"./stocks/TNGX.png": 85417,
	"./stocks/TNON.png": 442400,
	"./stocks/TNP.png": 786748,
	"./stocks/TNXP.png": 827823,
	"./stocks/TNYA.png": 818693,
	"./stocks/TOL.png": 330218,
	"./stocks/TOMZ.png": 217214,
	"./stocks/TOP.png": 755397,
	"./stocks/TOPS.png": 884888,
	"./stocks/TOST.png": 984401,
	"./stocks/TOUR.png": 792938,
	"./stocks/TOVX.png": 85632,
	"./stocks/TOYO.png": 793429,
	"./stocks/TPC.png": 183651,
	"./stocks/TPET.png": 627506,
	"./stocks/TPG.png": 925782,
	"./stocks/TPHS.png": 102881,
	"./stocks/TPIC.png": 338763,
	"./stocks/TPL.png": 203046,
	"./stocks/TPST.png": 224334,
	"./stocks/TPX.png": 706349,
	"./stocks/TRAW.png": 288231,
	"./stocks/TRC.png": 984524,
	"./stocks/TRHC.png": 605587,
	"./stocks/TRIB.png": 972855,
	"./stocks/TRIP.png": 748846,
	"./stocks/TRKA.png": 911418,
	"./stocks/TRNR.png": 641196,
	"./stocks/TROO.png": 586331,
	"./stocks/TROW.png": 565364,
	"./stocks/TRP.png": 154988,
	"./stocks/TRSG.png": 331039,
	"./stocks/TRT.png": 442195,
	"./stocks/TRTX.png": 963084,
	"./stocks/TRUE.png": 121016,
	"./stocks/TRUG.png": 677819,
	"./stocks/TRUP.png": 367701,
	"./stocks/TRV.png": 265615,
	"./stocks/TRVI.png": 564938,
	"./stocks/TRVN.png": 615766,
	"./stocks/TS.png": 242089,
	"./stocks/TSCO.png": 552050,
	"./stocks/TSHA.png": 159169,
	"./stocks/TSLA.png": 851544,
	"./stocks/TSM.png": 553257,
	"./stocks/TSN.png": 632892,
	"./stocks/TSP.png": 784465,
	"./stocks/TSRI.png": 63144,
	"./stocks/TSVT.png": 385462,
	"./stocks/TT.png": 148715,
	"./stocks/TTC.png": 414261,
	"./stocks/TTCF.png": 400290,
	"./stocks/TTD.png": 329390,
	"./stocks/TTE.png": 660448,
	"./stocks/TTEC.png": 960395,
	"./stocks/TTI.png": 484858,
	"./stocks/TTM.png": 604643,
	"./stocks/TTNP.png": 652651,
	"./stocks/TTOO.png": 304267,
	"./stocks/TTSH.png": 636022,
	"./stocks/TTWO.png": 516345,
	"./stocks/TU.png": 247934,
	"./stocks/TUEM.png": 851438,
	"./stocks/TUGC.png": 812928,
	"./stocks/TUP.png": 581426,
	"./stocks/TURB.png": 549503,
	"./stocks/TUSK.png": 190742,
	"./stocks/TV.png": 415432,
	"./stocks/TVGN.png": 79235,
	"./stocks/TWG.png": 144693,
	"./stocks/TWKS.png": 826986,
	"./stocks/TWLO.png": 825809,
	"./stocks/TWLV.png": 710911,
	"./stocks/TWNP.png": 538246,
	"./stocks/TWNPV.png": 252649,
	"./stocks/TWTR.png": 166870,
	"./stocks/TX.png": 973765,
	"./stocks/TXG.png": 522933,
	"./stocks/TXMD.png": 743515,
	"./stocks/TXN.png": 930263,
	"./stocks/TXNM.png": 76669,
	"./stocks/TXRH.png": 886142,
	"./stocks/TXRS.png": 971162,
	"./stocks/TXT.png": 692386,
	"./stocks/TYDE.png": 405908,
	"./stocks/U.png": 122479,
	"./stocks/UA.png": 696578,
	"./stocks/UAA.png": 455431,
	"./stocks/UAL.png": 572066,
	"./stocks/UAN.png": 34355,
	"./stocks/UAVS.png": 149396,
	"./stocks/UBCP.png": 793658,
	"./stocks/UBER.png": 54602,
	"./stocks/UBFO.png": 277476,
	"./stocks/UBS.png": 822352,
	"./stocks/UBX.png": 864986,
	"./stocks/UBXG.png": 128827,
	"./stocks/UCAR.png": 705750,
	"./stocks/UCL.png": 889946,
	"./stocks/UDMY.png": 616276,
	"./stocks/UEC.png": 620013,
	"./stocks/UFAB.png": 660281,
	"./stocks/UG.png": 251069,
	"./stocks/UGI.png": 108389,
	"./stocks/UGRO.png": 229389,
	"./stocks/UHS.png": 543387,
	"./stocks/UIHC.png": 86066,
	"./stocks/UK.png": 29782,
	"./stocks/UL.png": 454862,
	"./stocks/ULCC.png": 972314,
	"./stocks/ULH.png": 783567,
	"./stocks/ULTA.png": 596894,
	"./stocks/ULY.png": 896872,
	"./stocks/UMAC.png": 187807,
	"./stocks/UMAM.png": 243936,
	"./stocks/UMBF.png": 402613,
	"./stocks/UMC.png": 419772,
	"./stocks/UNAM.png": 231997,
	"./stocks/UNCY.png": 65689,
	"./stocks/UNFI.png": 316088,
	"./stocks/UNG.png": 666639,
	"./stocks/UNH.png": 61018,
	"./stocks/UNIT.png": 994181,
	"./stocks/UNP.png": 30561,
	"./stocks/UOKA.png": 742788,
	"./stocks/UONE.png": 506540,
	"./stocks/UP.png": 565889,
	"./stocks/UPC.png": 773512,
	"./stocks/UPH.png": 116500,
	"./stocks/UPS.png": 146410,
	"./stocks/UPST.png": 584662,
	"./stocks/UPWK.png": 674907,
	"./stocks/UPXI.png": 479631,
	"./stocks/URG.png": 363604,
	"./stocks/UROY.png": 138210,
	"./stocks/USB.png": 117777,
	"./stocks/USEA.png": 149764,
	"./stocks/USEG.png": 421314,
	"./stocks/USFD.png": 295122,
	"./stocks/USIO.png": 917768,
	"./stocks/USO.png": 932258,
	"./stocks/USPH.png": 96982,
	"./stocks/USX.png": 579224,
	"./stocks/UTI.png": 872325,
	"./stocks/UTL.png": 348165,
	"./stocks/UTMD.png": 524367,
	"./stocks/UTME.png": 786440,
	"./stocks/UTRS.png": 616083,
	"./stocks/UTSI.png": 409194,
	"./stocks/UTZ.png": 234891,
	"./stocks/UUU.png": 840844,
	"./stocks/UVIX.png": 668214,
	"./stocks/UVSP.png": 616758,
	"./stocks/UWMC.png": 955011,
	"./stocks/UXIN.png": 784024,
	"./stocks/V.png": 556324,
	"./stocks/VABK.png": 674758,
	"./stocks/VACC.png": 241807,
	"./stocks/VAL.png": 441409,
	"./stocks/VALE.png": 451509,
	"./stocks/VALN.png": 568886,
	"./stocks/VALU.png": 662158,
	"./stocks/VANI.png": 843796,
	"./stocks/VAPO.png": 434601,
	"./stocks/VAQC.png": 54487,
	"./stocks/VATE.png": 739366,
	"./stocks/VAXX.png": 890192,
	"./stocks/VBF.png": 879978,
	"./stocks/VBFC.png": 882105,
	"./stocks/VBIV.png": 359893,
	"./stocks/VBLT.png": 963852,
	"./stocks/VBTX.png": 960436,
	"./stocks/VC.png": 136421,
	"./stocks/VCEL.png": 605045,
	"./stocks/VCIG.png": 246777,
	"./stocks/VCNX.png": 714396,
	"./stocks/VCRA.png": 924626,
	"./stocks/VCTR.png": 313080,
	"./stocks/VCV.png": 775982,
	"./stocks/VCYT.png": 433365,
	"./stocks/VEC.png": 62187,
	"./stocks/VECO.png": 105295,
	"./stocks/VECT.png": 305082,
	"./stocks/VEDL.png": 346371,
	"./stocks/VEEA.png": 331070,
	"./stocks/VEEE.png": 667494,
	"./stocks/VEEV.png": 644384,
	"./stocks/VENA.png": 127299,
	"./stocks/VEON.png": 456732,
	"./stocks/VER.png": 947992,
	"./stocks/VERA.png": 466478,
	"./stocks/VERB.png": 785037,
	"./stocks/VERI.png": 973629,
	"./stocks/VERO.png": 248177,
	"./stocks/VERU.png": 346591,
	"./stocks/VERV.png": 738997,
	"./stocks/VERX.png": 822906,
	"./stocks/VERY.png": 534791,
	"./stocks/VEV.png": 177215,
	"./stocks/VFC.png": 988944,
	"./stocks/VFF.png": 594904,
	"./stocks/VFS.png": 124447,
	"./stocks/VG.png": 434389,
	"./stocks/VGAS.png": 930453,
	"./stocks/VGFC.png": 156737,
	"./stocks/VGM.png": 56803,
	"./stocks/VHAI.png": 497406,
	"./stocks/VIAC.png": 53305,
	"./stocks/VIACA.png": 654960,
	"./stocks/VIACP.png": 506255,
	"./stocks/VIAO.png": 446673,
	"./stocks/VICI.png": 941638,
	"./stocks/VICR.png": 836822,
	"./stocks/VIEW.png": 771774,
	"./stocks/VIEWW.png": 461886,
	"./stocks/VIGL.png": 752687,
	"./stocks/VINC.png": 707197,
	"./stocks/VINE.png": 609687,
	"./stocks/VINO.png": 601234,
	"./stocks/VIPS.png": 90052,
	"./stocks/VIR.png": 687440,
	"./stocks/VIRC.png": 41917,
	"./stocks/VIRI.png": 521422,
	"./stocks/VIRT.png": 279803,
	"./stocks/VIRX.png": 174380,
	"./stocks/VISL.png": 475991,
	"./stocks/VITL.png": 465920,
	"./stocks/VIV.png": 737644,
	"./stocks/VIVE.png": 870212,
	"./stocks/VIVK.png": 740007,
	"./stocks/VIVO.png": 42845,
	"./stocks/VJET.png": 621695,
	"./stocks/VKQ.png": 854077,
	"./stocks/VKTX.png": 966287,
	"./stocks/VLCN.png": 338280,
	"./stocks/VLDR.png": 405639,
	"./stocks/VLN.png": 442321,
	"./stocks/VLO.png": 939350,
	"./stocks/VLON.png": 794951,
	"./stocks/VLRS.png": 632958,
	"./stocks/VLT.png": 499389,
	"./stocks/VLTA.png": 870835,
	"./stocks/VLY.png": 108431,
	"./stocks/VMAC.png": 319505,
	"./stocks/VMAR.png": 799633,
	"./stocks/VMD.png": 18858,
	"./stocks/VMEO.png": 524951,
	"./stocks/VMI.png": 596907,
	"./stocks/VMO.png": 279536,
	"./stocks/VMW.png": 113790,
	"./stocks/VNCE.png": 850122,
	"./stocks/VNDA.png": 648970,
	"./stocks/VNE.png": 901556,
	"./stocks/VNET.png": 12685,
	"./stocks/VNOM.png": 526013,
	"./stocks/VNRX.png": 472308,
	"./stocks/VNTR.png": 699088,
	"./stocks/VOD.png": 405265,
	"./stocks/VOR.png": 576019,
	"./stocks/VORB.png": 118921,
	"./stocks/VOXX.png": 894355,
	"./stocks/VPCC.png": 220311,
	"./stocks/VPRX.png": 995919,
	"./stocks/VPV.png": 601880,
	"./stocks/VQS.png": 992869,
	"./stocks/VRA.png": 460266,
	"./stocks/VRAR.png": 958886,
	"./stocks/VRAX.png": 300400,
	"./stocks/VRAY.png": 696634,
	"./stocks/VRCA.png": 421117,
	"./stocks/VRDN.png": 158245,
	"./stocks/VREX.png": 503487,
	"./stocks/VRM.png": 136633,
	"./stocks/VRME.png": 149347,
	"./stocks/VRNA.png": 868197,
	"./stocks/VRNOF.png": 74047,
	"./stocks/VRNS.png": 7121,
	"./stocks/VRPX.png": 519538,
	"./stocks/VRRM.png": 311783,
	"./stocks/VRS.png": 77204,
	"./stocks/VRSK.png": 195015,
	"./stocks/VRT.png": 280811,
	"./stocks/VRTS.png": 789168,
	"./stocks/VRTX.png": 271431,
	"./stocks/VS.png": 164514,
	"./stocks/VSAT.png": 181110,
	"./stocks/VSCO.png": 248372,
	"./stocks/VSEC.png": 277161,
	"./stocks/VSEE.png": 174444,
	"./stocks/VSH.png": 496523,
	"./stocks/VSME.png": 649136,
	"./stocks/VST.png": 324981,
	"./stocks/VSTA.png": 708369,
	"./stocks/VSTE.png": 139995,
	"./stocks/VSTM.png": 480696,
	"./stocks/VSTO.png": 94157,
	"./stocks/VSXT.png": 353128,
	"./stocks/VTA.png": 836709,
	"./stocks/VTAK.png": 54266,
	"./stocks/VTAQ.png": 649523,
	"./stocks/VTEX.png": 901635,
	"./stocks/VTGN.png": 747744,
	"./stocks/VTIQ.png": 543323,
	"./stocks/VTIQU.png": 949450,
	"./stocks/VTN.png": 20987,
	"./stocks/VTNR.png": 890951,
	"./stocks/VTRS.png": 100784,
	"./stocks/VTRU.png": 504628,
	"./stocks/VTSI.png": 557213,
	"./stocks/VTVT.png": 302653,
	"./stocks/VTYX.png": 955079,
	"./stocks/VUZI.png": 855946,
	"./stocks/VVNT.png": 618046,
	"./stocks/VVOS.png": 403616,
	"./stocks/VVPR.png": 825882,
	"./stocks/VVR.png": 5890,
	"./stocks/VVV.png": 864018,
	"./stocks/VWDRY.png": 396186,
	"./stocks/VWE.png": 44153,
	"./stocks/VXRT.png": 140649,
	"./stocks/VYGG.png": 532743,
	"./stocks/VYGR.png": 727457,
	"./stocks/VYNE.png": 127463,
	"./stocks/VYNT.png": 424635,
	"./stocks/VZ.png": 12514,
	"./stocks/VZIO.png": 46725,
	"./stocks/W.png": 510912,
	"./stocks/WAB.png": 154433,
	"./stocks/WAFD.png": 489707,
	"./stocks/WAFU.png": 705124,
	"./stocks/WAI.png": 140681,
	"./stocks/WAL.png": 419680,
	"./stocks/WALD.png": 851738,
	"./stocks/WANSF.png": 188167,
	"./stocks/WASH.png": 188157,
	"./stocks/WATT.png": 494808,
	"./stocks/WAVD.png": 498311,
	"./stocks/WAVE.png": 379043,
	"./stocks/WBA.png": 147702,
	"./stocks/WBD.png": 536419,
	"./stocks/WBEV.png": 719861,
	"./stocks/WBK.png": 742637,
	"./stocks/WBS.png": 780581,
	"./stocks/WBT.png": 756850,
	"./stocks/WBUY.png": 150103,
	"./stocks/WCC.png": 292177,
	"./stocks/WCN.png": 97935,
	"./stocks/WCT.png": 412981,
	"./stocks/WDAY.png": 491088,
	"./stocks/WDC.png": 202167,
	"./stocks/WDH.png": 549727,
	"./stocks/WE.png": 854139,
	"./stocks/WEAT.png": 251539,
	"./stocks/WEBR.png": 109608,
	"./stocks/WEC.png": 363011,
	"./stocks/WEI.png": 991730,
	"./stocks/WEJO.png": 306143,
	"./stocks/WELL.png": 183593,
	"./stocks/WEN.png": 190202,
	"./stocks/WENA.png": 296735,
	"./stocks/WERN.png": 799110,
	"./stocks/WES.png": 775295,
	"./stocks/WETF.png": 526974,
	"./stocks/WETG.png": 432158,
	"./stocks/WETH.png": 10100,
	"./stocks/WEX.png": 217777,
	"./stocks/WF.png": 237594,
	"./stocks/WFC.png": 601865,
	"./stocks/WFCF.png": 29834,
	"./stocks/WFG.png": 365883,
	"./stocks/WFRD.png": 725611,
	"./stocks/WGO.png": 767552,
	"./stocks/WGS.png": 844314,
	"./stocks/WHLM.png": 18610,
	"./stocks/WHLR.png": 636414,
	"./stocks/WHR.png": 426743,
	"./stocks/WIMI.png": 593645,
	"./stocks/WING.png": 162754,
	"./stocks/WINT.png": 597313,
	"./stocks/WIRE.png": 703094,
	"./stocks/WISA.png": 449676,
	"./stocks/WISH.png": 176575,
	"./stocks/WIT.png": 802646,
	"./stocks/WIX.png": 245689,
	"./stocks/WKEY.png": 593840,
	"./stocks/WKHS.png": 640151,
	"./stocks/WKME.png": 61576,
	"./stocks/WKSP.png": 759697,
	"./stocks/WLDN.png": 931260,
	"./stocks/WLDS.png": 140474,
	"./stocks/WLFC.png": 499778,
	"./stocks/WLGS.png": 582908,
	"./stocks/WLL.png": 146450,
	"./stocks/WLTW.png": 857791,
	"./stocks/WM.png": 951677,
	"./stocks/WMB.png": 117165,
	"./stocks/WMK.png": 93198,
	"./stocks/WMPN.png": 843756,
	"./stocks/WMT.png": 667568,
	"./stocks/WNC.png": 846289,
	"./stocks/WNW.png": 616788,
	"./stocks/WOK.png": 54972,
	"./stocks/WOLF.png": 621671,
	"./stocks/WOOF.png": 935522,
	"./stocks/WORX.png": 170042,
	"./stocks/WOW.png": 296274,
	"./stocks/WPM.png": 755469,
	"./stocks/WPRT.png": 389863,
	"./stocks/WRAP.png": 752689,
	"./stocks/WRB.png": 855401,
	"./stocks/WRBY.png": 334397,
	"./stocks/WRD.png": 129522,
	"./stocks/WRNT.png": 56539,
	"./stocks/WSBF.png": 592508,
	"./stocks/WSC.png": 508213,
	"./stocks/WSFS.png": 280655,
	"./stocks/WSM.png": 203312,
	"./stocks/WSR.png": 365400,
	"./stocks/WST.png": 67155,
	"./stocks/WTBA.png": 496354,
	"./stocks/WTC.png": 992000,
	"./stocks/WTER.png": 443496,
	"./stocks/WTFC.png": 983659,
	"./stocks/WTFCM.png": 743677,
	"./stocks/WTFCP.png": 880491,
	"./stocks/WTI.png": 459204,
	"./stocks/WTO.png": 549258,
	"./stocks/WTRG.png": 537798,
	"./stocks/WTRH.png": 406499,
	"./stocks/WTS.png": 609110,
	"./stocks/WTTR.png": 540781,
	"./stocks/WU.png": 878536,
	"./stocks/WUBA.png": 287118,
	"./stocks/WULF.png": 275902,
	"./stocks/WVE.png": 993352,
	"./stocks/WVVI.png": 107576,
	"./stocks/WW.png": 956285,
	"./stocks/WWD.png": 183489,
	"./stocks/WWE.png": 516681,
	"./stocks/WWR.png": 449756,
	"./stocks/WWW.png": 522952,
	"./stocks/WYNN.png": 876851,
	"./stocks/WYY.png": 883481,
	"./stocks/X.png": 191522,
	"./stocks/XAIR.png": 604421,
	"./stocks/XBIO.png": 871338,
	"./stocks/XBIT.png": 503506,
	"./stocks/XBP.png": 468783,
	"./stocks/XCH.png": 254333,
	"./stocks/XCUR.png": 590669,
	"./stocks/XELA.png": 770412,
	"./stocks/XENT.png": 408283,
	"./stocks/XERS.png": 181457,
	"./stocks/XFIN.png": 160629,
	"./stocks/XFOR.png": 763326,
	"./stocks/XGN.png": 610154,
	"./stocks/XHG.png": 478801,
	"./stocks/XHLD.png": 425347,
	"./stocks/XHR.png": 42302,
	"./stocks/XIN.png": 789410,
	"./stocks/XL.png": 229276,
	"./stocks/XLNX.png": 546016,
	"./stocks/XLO.png": 819943,
	"./stocks/XLRN.png": 671313,
	"./stocks/XM.png": 924882,
	"./stocks/XNET.png": 114921,
	"./stocks/XOG.png": 6217,
	"./stocks/XOM.png": 238288,
	"./stocks/XOMA.png": 836430,
	"./stocks/XOMAO.png": 366929,
	"./stocks/XOMAP.png": 155310,
	"./stocks/XOS.png": 627430,
	"./stocks/XP.png": 688190,
	"./stocks/XPEL.png": 569051,
	"./stocks/XPER.png": 307474,
	"./stocks/XPEV.png": 592173,
	"./stocks/XPO.png": 583962,
	"./stocks/XPOA.png": 784060,
	"./stocks/XPON.png": 267183,
	"./stocks/XRTX.png": 474188,
	"./stocks/XRX.png": 882,
	"./stocks/XSPA.png": 269354,
	"./stocks/XTIA.png": 474314,
	"./stocks/XTLB.png": 561148,
	"./stocks/XXII.png": 532600,
	"./stocks/XYL.png": 759300,
	"./stocks/XYZ.png": 159469,
	"./stocks/Y.png": 35903,
	"./stocks/YALA.png": 651070,
	"./stocks/YCBD.png": 701808,
	"./stocks/YELL.png": 485299,
	"./stocks/YELP.png": 501293,
	"./stocks/YETI.png": 249259,
	"./stocks/YEXT.png": 143999,
	"./stocks/YGMZ.png": 339696,
	"./stocks/YHC.png": 325798,
	"./stocks/YHGJ.png": 694802,
	"./stocks/YIBO.png": 2500,
	"./stocks/YJ.png": 542957,
	"./stocks/YMAB.png": 525942,
	"./stocks/YMTX.png": 647574,
	"./stocks/YOSH.png": 861733,
	"./stocks/YOTA.png": 319817,
	"./stocks/YOU.png": 508221,
	"./stocks/YPF.png": 46891,
	"./stocks/YQ.png": 642767,
	"./stocks/YS.png": 249907,
	"./stocks/YSG.png": 30322,
	"./stocks/YTEN.png": 739473,
	"./stocks/YTRA.png": 699754,
	"./stocks/YUMC.png": 795862,
	"./stocks/YVR.png": 108607,
	"./stocks/YY.png": 56178,
	"./stocks/YYAI.png": 343225,
	"./stocks/YYGH.png": 270485,
	"./stocks/Z.png": 43973,
	"./stocks/ZAPP.png": 599885,
	"./stocks/ZBAI.png": 149275,
	"./stocks/ZBAO.png": 374561,
	"./stocks/ZBH.png": 178596,
	"./stocks/ZCAR.png": 894961,
	"./stocks/ZCMD.png": 152467,
	"./stocks/ZDGE.png": 105234,
	"./stocks/ZEAL.png": 278549,
	"./stocks/ZEN.png": 569026,
	"./stocks/ZENA.png": 879655,
	"./stocks/ZENV.png": 493784,
	"./stocks/ZEO.png": 590545,
	"./stocks/ZEST.png": 982871,
	"./stocks/ZETA.png": 154619,
	"./stocks/ZEUS.png": 996505,
	"./stocks/ZEV.png": 18112,
	"./stocks/ZG.png": 758956,
	"./stocks/ZGNX.png": 458890,
	"./stocks/ZH.png": 127480,
	"./stocks/ZI.png": 956451,
	"./stocks/ZIM.png": 547918,
	"./stocks/ZIMV.png": 823720,
	"./stocks/ZION.png": 229006,
	"./stocks/ZIP.png": 797098,
	"./stocks/ZIVO.png": 504937,
	"./stocks/ZIXI.png": 752742,
	"./stocks/ZJK.png": 553360,
	"./stocks/ZJYL.png": 32106,
	"./stocks/ZKIN.png": 165636,
	"./stocks/ZLAB.png": 715168,
	"./stocks/ZM.png": 457665,
	"./stocks/ZME.png": 296337,
	"./stocks/ZNGA.png": 647539,
	"./stocks/ZNH.png": 765567,
	"./stocks/ZNTE.png": 670533,
	"./stocks/ZNTEU.png": 883101,
	"./stocks/ZNTL.png": 601473,
	"./stocks/ZOM.png": 543768,
	"./stocks/ZONE.png": 785781,
	"./stocks/ZOOZ.png": 497708,
	"./stocks/ZPTA.png": 930389,
	"./stocks/ZPTA2.png": 837996,
	"./stocks/ZS.png": 277917,
	"./stocks/ZSAN.png": 739180,
	"./stocks/ZSPC.png": 164955,
	"./stocks/ZTO.png": 592856,
	"./stocks/ZTS.png": 927341,
	"./stocks/ZUA.png": 339078,
	"./stocks/ZUMZ.png": 973877,
	"./stocks/ZVIA.png": 245415,
	"./stocks/ZVO.png": 888431,
	"./stocks/ZVSA.png": 507283,
	"./stocks/ZWRK.png": 250154,
	"./stocks/ZWRKU.png": 373899,
	"./stocks/ZY.png": 230505,
	"./stocks/ZYME.png": 68318,
	"./stocks/ZYNE.png": 354141,
	"./stocks/ZYXI.png": 748714
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 677007;